webpackJsonp([58],{

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_logger__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_logger__);


var isProduction = "production" === 'production';
var options = {
  isEnabled: true,
  logLevel: isProduction ? 'warn' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: ' > ',
  showConsoleColors: true
};
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuejs_logger___default.a, options);

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonArrow_vue_vue_type_template_id_e137ccf6___ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ButtonArrow_vue_vue_type_script_lang_js___ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ButtonArrow_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ButtonArrow_vue_vue_type_template_id_e137ccf6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ButtonArrow_vue_vue_type_template_id_e137ccf6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return trackDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateTimeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dateFormatDashboard; });
/* unused harmony export dateFormatShortMonth */
/* unused harmony export dateFormatYYYYMMDD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return titleFormat; });
/* unused harmony export filterBy */
/* unused harmony export reverse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lgrDate; });
/* unused harmony export findBy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return numberFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return seoURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateFormatStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isFutureDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabcase__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_kebabcase__);


function trackDuration(secs) {
  if (secs < 3600) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(secs * 1000).format('mm:ss');
  }
  return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(secs * 1000).format('HH:mm:ss');
}
function dateFormat(value) {
  return value && __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MMMM Do YYYY');
}
function dateFormatShortMonth(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MMM D YYYY');
}
function lgrDate(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MMM D YYYY');
}
function dateFormatDashboard(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('D of MMM YYYY');
}
function dateTimeFormat(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('DD/MM/YYYY - HH:mm');
}
function dateFormatYYYYMMDD(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD');
}
function dateFormatStat(start, end) {
  var startMoment = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start);
  var endMoment = __WEBPACK_IMPORTED_MODULE_0_moment___default()(end || start);
  var endDateFormat = endMoment.format('Do MMMM YYYY');
  var isSameMonth = startMoment.isSame(endMoment, 'month');
  var isSameYear = startMoment.isSame(endMoment, 'year');
  var startDateFormat = "Do".concat(isSameMonth ? '' : ' MMMM').concat(isSameYear ? '' : ' YYYY');
  return "".concat(startMoment.format(startDateFormat), " - ").concat(endDateFormat);
}
function isFutureDate(date) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()());
}
function titleFormat(str, lineColor) {
  if (!str) return '';
  var text = str.split(' ');
  if (text.length > 2) {
    text[0] = "<span class='" + lineColor + "-line'>" + text[0];
    text[1] = ' ' + text[1] + '</span>';
  } else {
    text[0] = "<span class='" + lineColor + "-line'>" + text[0] + '</span>';
  }
  return text.join(' ');
}
function filterBy(list, value) {
  return list.filter(function (item) {
    return item.indexOf(value) > -1;
  });
}
function findBy(list, value) {
  return list.filter(function (item) {
    return item === value;
  });
}
function reverse(value) {
  return value.split('').reverse().join('');
}

/**
 * Truncate a string to a specified length
 *
 * @param {string} string - String to be truncated
 * @param {number} [length=40] - Max. length of the string
 * @param {string} [ending=…] - Ending to be appended to the string
 * @param {boolean} [breakWord=true] - End the string at the nearest character or at the nearest word
 * @returns {string} - Truncated string
 * @example truncate('This is a long string', 10) // This is a…
 */
function truncate() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;
  var ending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '…';
  var breakWord = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (string.length <= length) return string;
  var maxLength = Math.max(0, length - ending.length);
  if (breakWord) return string.slice(0, maxLength).trim() + ending;
  return string.slice(0, string.lastIndexOf(' ', maxLength)).trim() + ending;
}
function numberFormat(value) {
  var newValue = value;
  if (value >= 1000) {
    var suffixes = ['', 'k', 'm', 'b', 't'];
    var suffixNum = Math.floor(('' + value).length / 3);
    var shortValue = '';
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat((suffixNum === 0 ? value : value / Math.pow(1000, suffixNum)).toPrecision(precision));
      var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
}
function seoURL(url) {
  if (!url) {
    return url;
  }
  var encodedUrl = url.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().substring(0, 32);
  return __WEBPACK_IMPORTED_MODULE_1_lodash_kebabcase___default()(encodedUrl);
}
function formatNumber(number) {
  var numberFormat = new Intl.NumberFormat(navigator.language, {
    notation: 'compact',
    maximumFractionDigits: 2,
    compactDisplay: 'short'
  });
  return numberFormat.format(number);
}


/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatisticsHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_model_StatisticsData_Data__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_model_StatisticsData_User__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_model_StatisticsData_Device__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_model_StatisticsData_ScreenSize__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_model_StatisticsData_ViewportSize__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_model_StatisticsData_StatisticsData__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(690);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }







var uuid = __webpack_require__(494);
var StatisticsHelper = /*#__PURE__*/function () {
  function StatisticsHelper() {
    _classCallCheck(this, StatisticsHelper);
  }
  _createClass(StatisticsHelper, null, [{
    key: "createSessionId",
    value:
    /**
     * This method should only be called when a new user comes on to afripods.africa.
     */
    function createSessionId() {
      var id = uuid();
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__Constants__["b" /* AFRIPODS_SESSION_ID */], id);
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__Constants__["b" /* AFRIPODS_SESSION_ID */]);
    }
  }, {
    key: "getAppVersion",
    value: function getAppVersion() {
      return 1;
    }
  }, {
    key: "getDeviceType",
    value: function getDeviceType() {
      var device = null;
      if (navigator.userAgent.match(/Android/i)) {
        device = 'android-web';
      } else if (navigator.userAgent.match(/BlackBerry/i)) {
        device = 'blackberry-web';
      } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        device = 'ios-web';
      } else if (this.createScreenSize().width > 600 || this.createScreenSize().height > 600) {
        device = 'desktop';
      } else {
        device = 'other';
      }
      return device;
    }
  }, {
    key: "getDeviceId",
    value: function getDeviceId() {
      var id = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__Constants__["c" /* DEVICE_ID */]);
      if (id == undefined) {
        id = uuid();
        window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__Constants__["c" /* DEVICE_ID */], id);
        return id;
      }
      return id;
    }
  }, {
    key: "getAbtestId",
    value: function getAbtestId() {
      var id = Number(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__Constants__["a" /* ABTEST_ID */]));
      if (id == undefined) {
        var newId = Math.floor(Math.random() * 100) + 1;
        window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__Constants__["a" /* ABTEST_ID */], newId);
        return Number(newId);
      }
      return id;
    }
  }, {
    key: "getSchemeVersion",
    value: function getSchemeVersion() {
      return 1;
    }
  }, {
    key: "getUserAgent",
    value: function getUserAgent() {
      return window.navigator.userAgent;
    }
  }, {
    key: "getNetworkConnection",
    value: function getNetworkConnection() {
      return 'online';
    }
  }, {
    key: "createDate",
    value: function createDate() {
      return new Date().toISOString();
    }
  }, {
    key: "createData",
    value: function createData(dataType, adId, episodeId, startTimeMinutes, endTimeMinutes, event, state, podcastId, podcastFollowed, pageName, listName, buttonName) {
      return new __WEBPACK_IMPORTED_MODULE_0__api_model_StatisticsData_Data__["a" /* Data */](dataType, adId, episodeId, startTimeMinutes, endTimeMinutes, event, state, podcastId, podcastFollowed, pageName, listName, buttonName);
    }
  }, {
    key: "createScreenSize",
    value: function createScreenSize() {
      var width = screen.width;
      var height = screen.height;
      return new __WEBPACK_IMPORTED_MODULE_3__api_model_StatisticsData_ScreenSize__["a" /* ScreenSize */](width, height);
    }
  }, {
    key: "createViewPortSize",
    value: function createViewPortSize() {
      var width = window.innerWidth;
      var height = window.innerHeight;
      return new __WEBPACK_IMPORTED_MODULE_4__api_model_StatisticsData_ViewportSize__["a" /* ViewportSize */](width, height);
    }
  }, {
    key: "createUser",
    value: function createUser() {
      return new __WEBPACK_IMPORTED_MODULE_1__api_model_StatisticsData_User__["a" /* User */](new __WEBPACK_IMPORTED_MODULE_2__api_model_StatisticsData_Device__["a" /* Device */](this.getDeviceType(), this.getDeviceId(), this.getAppVersion(), this.createScreenSize(), this.createViewPortSize(), this.getUserAgent(), this.getAbtestId()));
    }

    /**
     * Creats a Statistics object when episode starts playing.
     * @param dataType
     * @param episodeId
     * @param impression
     * @returns {StatisticsData}
     */
  }, {
    key: "episode",
    value: function episode(dataType, episodeId, impression) {
      var stats = new __WEBPACK_IMPORTED_MODULE_5__api_model_StatisticsData_StatisticsData__["a" /* StatisticsData */](this.createDate(), this.getSchemeVersion(), impression, this.createData(dataType, undefined, episodeId), this.getNetworkConnection(), this.createUser(), this.getSessionId());
      return stats;
    }
    /**
     * Creates Stream Statistics object.
     * @param dataType: string
     * @param episodeId
     * @param impression
     * @param startTimeMinutes
     * @param endTimeMinutes
     * @param event
     * @returns {StatisticsData}
     */
  }, {
    key: "stream",
    value: function stream(dataType, episodeId, impression, startTimeMinutes, endTimeMinutes, event) {
      var stats = new __WEBPACK_IMPORTED_MODULE_5__api_model_StatisticsData_StatisticsData__["a" /* StatisticsData */](this.createDate(), this.getSchemeVersion(), impression, this.createData(dataType, undefined, episodeId, startTimeMinutes, endTimeMinutes, event), this.getNetworkConnection(), this.createUser(), this.getSessionId());
      return stats;
    }
  }, {
    key: "episodeSave",
    value: function episodeSave(dataType, state, podcastFollowState, episodeId, pageName, listName) {
      var stats = new __WEBPACK_IMPORTED_MODULE_5__api_model_StatisticsData_StatisticsData__["a" /* StatisticsData */](this.createDate(), this.getSchemeVersion(), 'click', this.createData(dataType, null, episodeId, null, null, null, state, null, podcastFollowState, pageName, listName), this.getNetworkConnection(), this.createUser(), this.getSessionId());
      return stats;
    }
  }, {
    key: "podcastFollow",
    value: function podcastFollow(dataType, state, podcastId, pageName, listName) {
      var stats = new __WEBPACK_IMPORTED_MODULE_5__api_model_StatisticsData_StatisticsData__["a" /* StatisticsData */](this.createDate(), this.getSchemeVersion(), 'click', this.createData(dataType, null, null, null, null, null, state, podcastId, null, pageName, listName), this.getNetworkConnection(), this.createUser(), this.getSessionId());
      return stats;
    }
    /**
     * Creates Button Click Statistics object.
     * @param dataType
     * @param state
     * @param impressionType
     * @param episodeId
     * @returns {StatisticsData}
     */
  }, {
    key: "buttonClick",
    value: function buttonClick(dataType, state, impressionType, episodeId, buttonName) {
      var stats = new __WEBPACK_IMPORTED_MODULE_5__api_model_StatisticsData_StatisticsData__["a" /* StatisticsData */](this.createDate(), this.getSchemeVersion(), impressionType, this.createData(dataType, null, episodeId, null, null, null, state, null, null, null, null, buttonName), this.getNetworkConnection(), this.createUser(), this.getSessionId());
      return stats;
    }
    /**
     * Creates a Statistics object when an ad starts playing.
     * @param dataType
     * @param adId
     * @param episodeId
     * @param impression
     * @returns {StatisticsData}
     */
  }, {
    key: "ad",
    value: function ad(dataType, adId, episodeId, impression) {
      var stats = new __WEBPACK_IMPORTED_MODULE_5__api_model_StatisticsData_StatisticsData__["a" /* StatisticsData */](this.createDate(), this.getSchemeVersion(), impression, this.createData(dataType, adId, episodeId), this.getNetworkConnection(), this.createUser(), this.getSessionId());
      return stats;
    }
  }]);
  return StatisticsHelper;
}();

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOT_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLAYING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAUSED; });
var NOT_STARTED = 'notStarted';
var PLAYING = 'playing';
var PAUSED = 'paused';

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___ = __webpack_require__(262);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_clarity__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AudioPlayer_AudioPlayer__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reused_components_footer_section_FooterSection__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_reused_components_skeletonBody_SkeletonBody__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_conf__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_filters__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_payments_users__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_Statistics_StatisticsHelper__ = __webpack_require__(220);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_2_components_AudioPlayer_AudioPlayer__["a" /* default */],
    FooterSection: __WEBPACK_IMPORTED_MODULE_3_components_reused_components_footer_section_FooterSection__["a" /* default */],
    SkeletonBody: __WEBPACK_IMPORTED_MODULE_4_components_reused_components_skeletonBody_SkeletonBody__["a" /* default */]
  },
  data: function data() {
    return {
      lt: 'listener',
      searchResultsEpisodes: [],
      searchResultsPodcasts: [],
      searchResultsCategories: [],
      searchResultsNetworks: [],
      searchResultsStations: [],
      trendingPodcasts: [],
      podcastList: [],
      podcastCategories: [],
      podcastCategoriesMore: [],
      allPodcastCategoriesMore: [],
      featuredPodcastsList: [],
      featuredPodcastsColors: [],
      currentCatId: '',
      featuredPodcastActiveColor: '',
      transparentNav: false,
      userLoggedIn: false,
      noSearchResults: false,
      showSpinner: false,
      isIframePlayer: null,
      isEmbedPlayer: null,
      user: {
        id: '',
        type: '',
        name: '',
        image: 'static/images/temp-profile.png',
        hasPodcast: false
      }
    };
  },
  computed: {
    canViewPayments: function canViewPayments() {
      return  true ? Object(__WEBPACK_IMPORTED_MODULE_8_utils_payments_users__["a" /* default */])(this.user.id) : true;
    }
  },
  watch: {
    '$route.name': {
      handler: function handler(newId, oldId) {
        this.transparentNav = newId === 'Podcast' || newId === 'Episode';
        this.isIframePlayer = newId === 'iframe-player';
        this.isEmbedPlayer = newId === 'embedplayer' || newId === 'embedarchiveplayer';
        if (newId !== oldId) {
          $('#loginModal').modal('hide');
        }
      }
    }
  },
  beforeCreate: function beforeCreate() {
    this.isIframePlayer = this.$route.name === 'iframe-player';
    this.isEmbedPlayer = this.$route.name === 'embedplayer';
  },
  created: function created() {
    // Create a session id when a user comes on the site.
    __WEBPACK_IMPORTED_MODULE_9_utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].createSessionId();

    // Setting the nav
    if (__WEBPACK_IMPORTED_MODULE_1_auth__["a" /* default */].checkToken()) {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_7_utils__["c" /* event */].$emit('setLoggedInUserInfo');
      }, 200);
    }
  },
  mounted: function mounted() {
    if (this.getHash() === '#recover-password') {
      $('#retrievePasswordModal').modal();
    }
    var self = this;
    var typingTimer; // timer identifier
    var doneTypingInterval = 400; // time in ms, 5 second for example
    $('.search-results').slideUp();
    $('#search-input').on('keyup', function (event) {
      if (event.key === 'Enter') return;
      var query = $(this).val();
      if (query.length > 2) {
        self.showSpinner = true;
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {
          self.executeSearch(query);
        }, doneTypingInterval);
      }
    });
    $('#search-input').on('keydown', function () {
      clearTimeout(typingTimer);
    });
    __WEBPACK_IMPORTED_MODULE_7_utils__["c" /* event */].$on('hideSearchBar', function () {
      self.closeSearchBar();
    });

    // sets logged in user info in navbar
    __WEBPACK_IMPORTED_MODULE_7_utils__["c" /* event */].$on('setLoggedInUserInfo', function () {
      if (localStorage.getItem('afripodsLoggedInAccountType') == null) {
        self.userLoggedIn = false;
      } else {
        self.user.id = localStorage.getItem('afripodsLoggedInUserId');
        self.user.name = localStorage.getItem('afripodsLoggedInUserName');
        self.user.type = localStorage.getItem('afripodsLoggedInAccountType');
        self.user.image = localStorage.getItem('afripodsLoggedInUserImage') === 'null' ? '/static/images/icons/avatar.svg' : __WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].image.user.thumb + localStorage.getItem('afripodsLoggedInUserImage');
        self.user.hasPodcast = JSON.parse(localStorage.getItem('afripodsLoggedInUserHasPodcasts'));
        self.userLoggedIn = true;
        this.$http.get(__WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].url.listener_dashboard, {
          params: {},
          headers: __WEBPACK_IMPORTED_MODULE_1_auth__["a" /* default */].getAuthHeader()
        }).then(function (response) {
          var data = response.body.data;
          localStorage.setItem('userShows', JSON.stringify(data.shows));
          localStorage.setItem('userBookmarks', JSON.stringify(data.bookmarks));
          localStorage.setItem('userEpisodes', data.episodes);
          self.$forceUpdate();
        }, function (error) {
          if (error.status === '401') {
            __WEBPACK_IMPORTED_MODULE_1_auth__["a" /* default */].logout(this);
          }
        });
      }
    });
    __WEBPACK_IMPORTED_MODULE_7_utils__["c" /* event */].$on('logOutUser', function () {
      self.user = {
        name: '',
        type: '',
        image: ''
      };
      self.userLoggedIn = false;
    });
    document.getElementById('app').addEventListener('scroll', this.handleScroll);
    __WEBPACK_IMPORTED_MODULE_0__microsoft_clarity__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].clarityProjectId);
  },
  methods: {
    seoURL: __WEBPACK_IMPORTED_MODULE_6_filters__["i" /* seoURL */],
    scrollToHash: __WEBPACK_IMPORTED_MODULE_7_utils__["k" /* scrollToHash */],
    getHash: function getHash() {
      return location.hash;
    },
    handleScroll: function handleScroll() {
      if (this.transparentNav) {
        if ($('#app').scrollTop() > 100) {
          $('.navbar-general').removeClass('transparent');
        } else {
          $('.navbar-general').addClass('transparent');
        }
      }
    },
    logOut: function logOut() {
      __WEBPACK_IMPORTED_MODULE_1_auth__["a" /* default */].logout(this);
      this.$router.go();
    },
    closeSearchBar: function closeSearchBar() {
      $('.search-field').slideUp(500);
      $('.search-results').slideUp(200);
    },
    openSearchBar: function openSearchBar() {
      $('.searchbar').addClass('is-visible');
      $('.search-field').fadeIn(200);
      $('#search-input').focus();
      if (this.searchResultsEpisodes.length > 0 || this.searchResultsPodcasts.length > 0 || this.searchResultsCategories.length > 0 || this.searchResultsNetworks.length > 0 || this.searchResultsStations.length > 0) {
        $('.search-results').slideDown();
      }
    },
    executeSearch: function executeSearch(query) {
      var vue = this;
      vue.searchResultsEpisodes = [];
      vue.searchResultsPodcasts = [];
      vue.searchResultsCategories = [];
      vue.searchResultsNetworks = [];
      vue.searchResultsStations = [];
      vue.$http.post(__WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].url.search, {
        term: query
      }, {
        headers: __WEBPACK_IMPORTED_MODULE_1_auth__["a" /* default */].getAuthHeader()
      }).then(function (response) {
        this.showSpinner = false;
        $.each(response.body.data, function (k, v) {
          if (k === 'episodes' && response.body.data.episodes.length > 0) {
            var _iterator = _createForOfIteratorHelper(v),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var element = _step.value;
                vue.searchResultsEpisodes.push({
                  id: element.id,
                  title: element.title,
                  image: Object(__WEBPACK_IMPORTED_MODULE_7_utils__["i" /* isValidUrl */])(element.image) ? element.image : __WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].image.episode.thumb + element.image,
                  podcast_id: element.podcast_id,
                  author: element.author.name,
                  created: element.created
                });
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else if (k === 'podcasts' && response.body.data.podcasts.length > 0) {
            var _iterator2 = _createForOfIteratorHelper(v),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var data = _step2.value;
                vue.searchResultsPodcasts.push({
                  id: data.id,
                  slug: data.slug,
                  title: data.title,
                  image: Object(__WEBPACK_IMPORTED_MODULE_7_utils__["i" /* isValidUrl */])(data.images.main) ? data.images.main : __WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].image.podcast.thumb + data.images.main,
                  category: data.category && data.category.title,
                  author: data.author.name,
                  created: data.created
                });
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else if (k === 'categories' && response.body.data.categories.length > 0) {
            var _iterator3 = _createForOfIteratorHelper(v),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _element = _step3.value;
                vue.searchResultsCategories.push({
                  id: _element.id,
                  title: _element.title
                });
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else if (k === 'networks' && response.body.data.networks.length > 0) {
            v.forEach(function (item) {
              vue.searchResultsNetworks.push({
                id: item.network_id,
                name: item.network_name,
                ownerName: item.owner_name,
                image: Object(__WEBPACK_IMPORTED_MODULE_7_utils__["i" /* isValidUrl */])(item.image_main) ? item.image_main : __WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].image.network.cover + item.image_main,
                // There are no thumbnails for networks
                slug: item.slug
              });
            });
          } else if (k === 'stations' && response.body.data.stations.length > 0) {
            v.forEach(function (item) {
              vue.searchResultsStations.push({
                id: item.station_id,
                name: item.station_name,
                ownerName: item.owner_name,
                image: Object(__WEBPACK_IMPORTED_MODULE_7_utils__["i" /* isValidUrl */])(item.image_main) ? item.image_main : __WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].image.station.main + item.image_main,
                slug: item.slug
              });
            });
          }
        });
        vue.noSearchResults = vue.searchResultsEpisodes.length === 0 && vue.searchResultsPodcasts.length === 0 && vue.searchResultsNetworks.length === 0 && vue.searchResultsStations.length === 0;
        $('.search-results').slideDown();
      }, function (error) {
        this.$log.debug(error);
        this.$notify({
          title: 'Error fetching search results',
          text: this.getErrorMessage(error),
          type: 'error'
        });
      });
    },
    searchEpisodeLink: function searchEpisodeLink(podcastId, episodeId) {
      this.$router.push({
        path: "/podcast/".concat(podcastId, "/episode/").concat(episodeId),
        params: {
          podcastId: podcastId,
          episodeId: episodeId
        }
      });
      // event.$emit('loadAudioEpisode',episodeId)
    },
    setLoginType: function setLoginType(type) {
      this.lt = type;
    },
    updatelt: function updatelt(type) {
      this.lt = type;
    },
    openMobileLogin: function openMobileLogin() {
      document.getElementById('mobile-login-menu').className += 'open';
    },
    mobileLoginClose: function mobileLoginClose() {
      document.getElementById('mobile-login-menu').classList.remove('open');
    },
    listenerAccount: function listenerAccount() {
      document.getElementById('listener-account-mobile').className += ' open';
    },
    listenerAccountClose: function listenerAccountClose() {
      document.getElementById('listener-account-mobile').classList.remove('open');
    },
    fetchSaveFollow: function fetchSaveFollow() {
      this.$http.get(__WEBPACK_IMPORTED_MODULE_5_conf__["a" /* default */].url.listener_dashboard, {
        params: {},
        headers: __WEBPACK_IMPORTED_MODULE_1_auth__["a" /* default */].getAuthHeader()
      }).then(function () {}, function (error) {
        if (error.status === '401') {
          __WEBPACK_IMPORTED_MODULE_1_auth__["a" /* default */].logout(this);
        }
      });
    },
    collapseAllNavbars: function collapseAllNavbars() {
      $('.navbar-collapse').collapse('hide');
    }
  }
});
window.AF_ENV = Object({"AFRIPODS_API_URL":"https://api.afripods.com","AFRIPODS_PAYMENT_API_URL":"https://payment-service-prod-dnh3ytvq4a-ew.a.run.app","AFRIPODS_APP_URL":"https://afripods.africa","AFRIPODS_MEDIA_URL":"https://media.afripods.com","NODE_ENV":"production","BUILD_ENV":"prod","GA4_ID":"G-CZDGWZ0K45","FEATURE_FILTER_PAYMENTS_USERS":"true","FEATURE_PAYMENTS_ONBOARDING":"true"});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_script_lang_js___ = __webpack_require__(399);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_statistics_statistics__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_index__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf_index__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_index__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_AudioPlayer__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_constants_WhichObject__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__ = __webpack_require__(493);














var SocialSharing = __webpack_require__(497);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a,
    SocialSharing: SocialSharing
  },
  /**
   *
   * player - the instance of the audio player retrieved from document.getElementById('audioplayer')
   *
   * audioPlayer - the object which contains the data used by the afripods media player to display data and function correctly.
   *
   * currentPlayObject - the object which contains the data needed for the audio player to play an episode, includes preroll and midroll
   * ads, and other data needed to execute all functions needed in order to play an episode and its ads.
   *
   * playObjects - All playObjects. A playObject is created for each episode in a podcast.
   *
   * ads - all ads, preroll and midroll.
   *
   * https://github.com/NightCatSama/vue-slider-component
   */
  data: function data() {
    return {
      player: '',
      audioPlayer: {},
      currentPlayObject: {},
      playObjects: [],
      socialShareLink: '',
      viewSize: 'default',
      view: 'desktop',
      episodeSaved: false,
      user: {
        userId: ''
      },
      timer: null,
      streamTimer: null,
      startTimestamp: null,
      stopTimestamp: null,
      timerDiff: null,
      aggregatedPlaySent: false,
      stats: {
        streamTimerStartTimeMinutes: 0,
        startTimeMinutes: 0,
        endTimeMinutes: 0,
        streamTimerStarted: false
      },
      statsObject: [],
      rangeSlider: {
        current: 0,
        start: 0,
        end: 0
      }
    };
  },
  created: function created() {
    window.addEventListener('resize', this.screenResized);
  },
  mounted: function mounted() {
    this.initPlayer();
    this.sendTrackingDataObject(this.statsObject);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$off('loadAudioEpisode', this.loadEpisodeAndStartPlayer);
    __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$off('showAudioPlayer', this.loadEpisodeAndShowPlayer);
    __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$off('embedPlayClicked', this.pauseAudio);
    this.player.removeEventListener('timeupdate', this.timeUpdateEventListener);
    this.player.removeEventListener('ended', this.endEventListener);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.screenResized);
  },
  methods: {
    aggregatedPlay: function aggregatedPlay() {
      var episodeId = this.currentPlayObject.episode.id;
      var stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].episode(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["c" /* EPISODE */], episodeId, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["c" /* PLAY_IMPRESSION */]);
      // Player has accumulated at least 60 seconds of playtime for episodeId
      this.sendTrackingData(stat);
      this.aggregatedPlaySent = true;
    },
    trackInfoClick: function trackInfoClick(e) {
      if (this.viewSize !== 'fullscreen') {
        this.mediaPlayerFullscreen(e);
      }
    },
    buttonClick: function buttonClick(button, state) {
      switch (button) {
        case 'controlPlayPause':
          this.pauseAudio();
          if (state === 'paused') {
            this.stats.endTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60);
            this.statComposer('buttonClick', __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["b" /* PAUSED */], 'controlPlayPause');
            this.statComposer('stream');
          } else {
            this.stats.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60);
            this.statComposer('buttonClick', __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["c" /* PLAYING */], 'controlPlayPause');
          }
          break;
        case 'controlNext':
          this.statComposer('buttonClick', true, 'controlNext');
          this.getObjectFromList('next');
          break;
        case 'controlPrev':
          this.statComposer('buttonClick', true, 'controlPrev');
          this.getObjectFromList('previous');
          break;
      }
    },
    calculatePlayTime: function calculatePlayTime() {
      var _this = this;
      var diff;
      if (!this.aggregatedPlaySent) {
        if (this.startTimestamp === null) {
          this.startTimestamp = new Date();
          // New start timestamp
          if (this.timerDiff === null) {
            // Starting first timer
            this.timer = setTimeout(function () {
              return _this.aggregatedPlay();
            }, 60000);
          } else {
            var remaining = 60000 - this.timerDiff;
            this.stopTimestamp = null;
            clearTimeout(this.timer);
            this.timer = setTimeout(function () {
              return _this.aggregatedPlay();
            }, remaining);
          }
        } else if (this.startTimestamp !== null && this.stopTimestamp === null) {
          this.stopTimestamp = new Date();
          diff = this.stopTimestamp - this.startTimestamp;
          var oldDiff = 0;
          if (this.timerDiff !== null) {
            oldDiff = this.timerDiff;
          }
          var newDiff = diff + oldDiff;
          this.timerDiff = newDiff;
          this.startTimestamp = null;
          clearTimeout(this.timer);
        }
      }
    },
    resetPlayTime: function resetPlayTime() {
      // All play impression timer related data cleared
      this.stats.startTimeMinutes = 0;
      this.stats.endTimeMinutes = 0;
      this.timerDiff = null;
      this.startTimestamp = null;
      this.stopTimestamp = null;
      this.aggregatedPlaySent = false;
      clearTimeout(this.timer);
    },
    initPlayer: function initPlayer() {
      this.audioPlayer = new __WEBPACK_IMPORTED_MODULE_7__model_AudioPlayer__["a" /* AudioPlayer */]();
      this.player = document.getElementById('audioplayer');
      this.player.addEventListener('timeupdate', this.timeUpdateEventListener);
      this.player.addEventListener('ended', this.endEventListener);
      __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$on('loadAudioEpisode', this.loadEpisodeAndStartPlayer);
      __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$on('showAudioPlayer', this.loadEpisodeAndShowPlayer);
      __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$on('embedPlayClicked', this.pauseAudio);
    },
    statComposer: function statComposer(type, state, buttonName) {
      var episodeId = this.currentPlayObject.episode.id;
      var stat;
      var start = this.stats.startTimeMinutes;
      var end = this.stats.endTimeMinutes;
      switch (type) {
        case 'buttonClick':
          stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].buttonClick(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["b" /* BUTTON */], state, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["a" /* CLICK */], episodeId, buttonName);
          this.statsObject.push(stat);
          break;
        case 'stream':
          if (start !== end && start < end) {
            stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].stream(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["e" /* STREAMDURATION */], episodeId, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["d" /* STREAM_IMPRESSION */], this.stats.startTimeMinutes, this.stats.endTimeMinutes, type);
            this.statsObject.push(stat);
          }
          break;
        case 'stopped':
          if (start !== end && start < end) {
            stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].stream(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["e" /* STREAMDURATION */], episodeId, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["d" /* STREAM_IMPRESSION */], this.stats.startTimeMinutes, this.stats.endTimeMinutes, type);
            this.statsObject.push(stat);
          }
          break;
        case 'completed':
          if (start !== end && start < end) {
            stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].stream(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["e" /* STREAMDURATION */], episodeId, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["d" /* STREAM_IMPRESSION */], this.stats.startTimeMinutes, this.stats.endTimeMinutes, type);
            this.statsObject.push(stat);
          }
          break;
      }
    },
    loadEpisodeAndShowPlayer: function loadEpisodeAndShowPlayer(episodeId) {
      this.loadEpisode(episodeId, false);
    },
    loadEpisodeAndStartPlayer: function loadEpisodeAndStartPlayer(episodeId) {
      this.resetPlayTime();
      this.loadEpisode(episodeId, true);
    },
    loadEpisode: function loadEpisode(episodeId) {
      var _this2 = this;
      var startPlayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var enableClientSideAdInsertion = false;
      var adPromise;
      if (enableClientSideAdInsertion) {
        adPromise = __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$http.get(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.ads, {
          params: {
            episode_id: episodeId
          },
          headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
        }).then(function (response) {
          return response.body.data;
        });
      } else {
        adPromise = Promise.resolve([]);
      }
      adPromise.then(function (ads) {
        _this2.$http.get(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.episodes + '/' + episodeId, {
          params: {},
          headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
        }).then(function (response) {
          var episode = response.body.data;
          _this2.socialShareLink = 'https://afripods.africa/episode/' + episode.title + '/' + episode.id;

          // Gets all episodes associated with podcast of chosen episode.
          _this2.$http.get(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.podcasts + '/' + episode.podcast_id + '/episodes', {
            params: {},
            headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
          }).then(function (response) {
            var data = response.body.data;

            // A harvested episode will not have any episodes in the playlist
            // so just create a one item playlist of the selected episode.
            if (data.length === 0) {
              data = [episode];
            }

            // Get all play objects
            _this2.playObjects = __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].getListOfPlayObjects(data, __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].getPreRollAds(ads), __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].getMidRollAds(ads));
            if (!startPlayer) {
              _this2.waitingForFirstPlay = true;
            }
            _this2.getObjectFromList(episode.id, startPlayer);
          });
        }, function (e) {
          _this2.$notify({
            title: 'Unable to play audio',
            text: 'Unable to play audio file from the third party, please contact us if the error persists',
            type: 'error'
          });
        });
      }, function (e) {
        _this2.$log.error('Error loading episode ads', e.body);
      });
    },
    /**
     * Handles selecting a playObject. whichObject can be an id for an episode.
     * Or a string such as 'NEXT' or 'PREVIOUS'
     *
     * @param whichObject
     */
    getObjectFromList: function getObjectFromList(whichObject) {
      var startPlayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.audioPlayer.showAudioPlayer = true;

      // If user wants the next playObject in the queue
      if (whichObject === __WEBPACK_IMPORTED_MODULE_12__model_constants_WhichObject__["a" /* NEXT */]) {
        this.currentPlayObject = __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].getPlayObjectFromListByIndexId(__WEBPACK_IMPORTED_MODULE_12__model_constants_WhichObject__["a" /* NEXT */], this.currentPlayObject, this.playObjects);
      } // If user wants the previous object in the queue
      else if (whichObject === __WEBPACK_IMPORTED_MODULE_12__model_constants_WhichObject__["b" /* PREVIOUS */]) {
        this.currentPlayObject = __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].getPlayObjectFromListByIndexId(__WEBPACK_IMPORTED_MODULE_12__model_constants_WhichObject__["b" /* PREVIOUS */], this.currentPlayObject, this.playObjects);
      } else {
        this.currentPlayObject = __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].getPlayObjectFromListById(whichObject, this.playObjects);
      }
      this.currentObjectUpdated(startPlayer);
      if (startPlayer) {
        this.trackEpisodePlayImpression();
      }
    },
    currentObjectUpdated: function currentObjectUpdated() {
      var startPlayer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.resetPlayTime();
      if (this.currentPlayObject.preRollAds.length > 0) {
        this.playPreRoll(this.currentPlayObject.preRollAds[0], startPlayer);
        if (!startPlayer) {
          this.setEpisodeMetaData();
        }
      } else {
        this.setEpisodeMetaData();
        this.playAudio(this.currentPlayObject.episode.streamUrl, 0, startPlayer);
      }
    },
    playPreRoll: function playPreRoll(preRoll) {
      var startPlayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.currentPlayObject.currentObjectType = __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["d" /* PRE_ROLL */];
      this.playAdRoll(preRoll, startPlayer);
    },
    playMidRoll: function playMidRoll(midRoll) {
      this.currentPlayObject.currentObjectType = __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["b" /* MID_ROLL */];
      this.currentPlayObject.currentMidroll = midRoll.timestamp;
      __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].removeAdFromMidrollList(this.currentPlayObject);
      this.pauseAudio();
      this.playAdRoll(midRoll);
    },
    playAdRoll: function playAdRoll(adRoll) {
      var startPlayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.currentPlayObject.idOfLastPlayedAd = adRoll.id;
      if (startPlayer) {
        this.setAdMetaData(adRoll);
        this.playAudio(adRoll.ad.media_file, 0, startPlayer);
        this.trackAdPlayImpression(adRoll);
      }
    },
    trackAdPlayImpression: function trackAdPlayImpression(adRoll) {
      var stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].ad(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["a" /* AD */], adRoll.id, this.currentPlayObject.episode.id, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["c" /* PLAY_IMPRESSION */]);
      this.sendTrackingData(stat);

      // Old tracking
      this.oldAdImpression(adRoll.id, this.currentPlayObject.episode.id);
    },
    trackAdCompleteImpression: function trackAdCompleteImpression() {
      var stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].ad(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["a" /* AD */], this.currentPlayObject.idOfLastPlayedAd, this.currentPlayObject.episode.id, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["b" /* COMPLETE_IMPRESSION */]);
      this.sendTrackingData(stat);
    },
    trackEpisodeCompleteImpression: function trackEpisodeCompleteImpression(adId) {
      var stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].episode(__WEBPACK_IMPORTED_MODULE_8__model_constants_DataType__["c" /* EPISODE */], this.currentPlayObject.episode.id, __WEBPACK_IMPORTED_MODULE_9__model_constants_ImpressionType__["b" /* COMPLETE_IMPRESSION */]);
      this.sendTrackingData(stat);
    },
    trackEpisodePlayImpression: function trackEpisodePlayImpression() {
      var episodeId = this.currentPlayObject.episode.id;
      var episodeTitle = this.currentPlayObject.episode.title;
      this.calculatePlayTime();
      this.$ga.event({
        eventCategory: 'Episode',
        eventAction: 'play',
        eventLabel: episodeTitle,
        eventValue: episodeId
      });
    },
    setEpisodeMetaData: function setEpisodeMetaData() {
      this.view = window.innerWidth > 991 ? 'desktop' : 'mobile';
      this.audioPlayer.speed = 3;
      this.audioPlayer.speedRadio = 3;
      this.audioPlayer.playerElement = document.getElementById('audio-player');
      this.audioPlayer.author = this.currentPlayObject.episode.podcast_title;
      this.audioPlayer.episodeIndex = this.currentPlayObject.episode.number;
      this.currentPlayObject.currentObjectType = __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["a" /* EPISODE */];
      this.audioPlayer.title = this.currentPlayObject.episode.title;
      this.audioPlayer.image = Object(__WEBPACK_IMPORTED_MODULE_5__utils_index__["i" /* isValidUrl */])(this.currentPlayObject.episode.image) ? this.currentPlayObject.episode.image : __WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].image.episode.thumb + this.currentPlayObject.episode.image;
      this.audioPlayer.durationInSeconds = Number(this.currentPlayObject.episode.duration);
      this.audioPlayer.playerEpisodeDuration = Object(__WEBPACK_IMPORTED_MODULE_4__filters__["k" /* trackDuration */])(this.currentPlayObject.episode.duration);
      this.checkUserSave();
      __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$emit('audioPlayerEpisodeLoaded', this.currentPlayObject.episode);
    },
    setAdMetaData: function setAdMetaData(adRoll) {
      this.audioPlayer.currentTimeInSeconds = 0;
      this.audioPlayer.durationInSeconds = Number(adRoll.ad.duration);
      this.audioPlayer.playerEpisodeDuration = Object(__WEBPACK_IMPORTED_MODULE_4__filters__["k" /* trackDuration */])(adRoll.ad.duration);
      this.audioPlayer.title = 'AD - ' + adRoll.ad.title;
      this.audioPlayer.author = this.currentPlayObject.episode.author;
      this.audioPlayer.image = __WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].image.ad.thumb + adRoll.ad.image;
    },
    /**
     * Handles starting a track from a particular time point.
     * @param url
     * @param time
     * @param startPlayer
     */
    playAudio: function playAudio(url, time) {
      var startPlayer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (document.getElementById('afripods-content') !== null) {
        var contentWrapperId = document.getElementById('afripods-content');
        if (!contentWrapperId.classList.contains('media-player-open')) {
          contentWrapperId.classList.add('media-player-open');
        }
      }
      var decoratedUrl = url;
      if (url.indexOf(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.media) !== -1) {
        // eslint-disable-next-line no-undef
        var listenerId = typeof com_adswizz_synchro_getListenerId === 'function' && com_adswizz_synchro_getListenerId(); // From Adswizz library loaded as a script tag.
        if (listenerId) {
          try {
            var parsedUrl = new URL(url);
            parsedUrl.searchParams.append('listenerId', listenerId);
            decoratedUrl = parsedUrl.toString();
          } catch (ignored) {
            // Ignored - just continuing without a listenerId
          }
        }
      }
      if (startPlayer) {
        this.currentPlayObject.playState = __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["c" /* PLAYING */];
        __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].playAudio(this.player, decoratedUrl, time);
        this.stats.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60);
      } else {
        this.player.src = decoratedUrl;
        this.player.preload = 'none';
        this.player.currentTime = time;
        this.currentPlayObject.playState = __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["b" /* PAUSED */];
      }
      __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$emit('audioPlayerPlayStateChanged', this.currentPlayObject.playState);
    },
    pauseAudio: function pauseAudio() {
      this.calculatePlayTime();
      if (this.currentPlayObject.playState === __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["c" /* PLAYING */]) {
        this.player.pause();
        this.currentPlayObject.playState = __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["b" /* PAUSED */];
      } else if (this.currentPlayObject.playState === __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["b" /* PAUSED */]) {
        if (this.waitingForFirstPlay) {
          // player wasn't started with auto play => need to track play impressions and updating metadata for the pre roll
          this.waitingForFirstPlay = false;
          this.trackEpisodePlayImpression();
          if (this.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["d" /* PRE_ROLL */]) {
            var adRoll = this.currentPlayObject.preRollAds[0];
            this.setAdMetaData(adRoll);
            this.trackAdPlayImpression(adRoll);
          }
        }
        this.player.play();
        this.currentPlayObject.playState = __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["c" /* PLAYING */];
        this.stats.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60);
      }
      __WEBPACK_IMPORTED_MODULE_5__utils_index__["c" /* event */].$emit('audioPlayerPlayStateChanged', this.currentPlayObject.playState);
    },
    volumeControl: function volumeControl() {
      this.player.volume = this.audioPlayer.volume / 100;
    },
    speedControl: function speedControl() {
      switch (this.audioPlayer.speed) {
        case '1':
          this.player.playbackRate = '0.5';
          this.audioPlayer.speedRadio = '1';
          break;
        case '2':
          this.player.playbackRate = '0.75';
          this.audioPlayer.speedRadio = '2';
          break;
        case '3':
          this.player.playbackRate = '1';
          this.audioPlayer.speedRadio = '3';
          break;
        case '4':
          this.player.playbackRate = '1.25';
          this.audioPlayer.speedRadio = '4';
          break;
        case '5':
          this.player.playbackRate = '1.5';
          this.audioPlayer.speedRadio = '5';
          break;
        case '6':
          this.player.playbackRate = '1.75';
          this.audioPlayer.speedRadio = '6';
          break;
        case '7':
          this.player.playbackRate = '2';
          this.audioPlayer.speedRadio = '7';
          break;
        case '8':
          this.player.playbackRate = '2.5';
          this.audioPlayer.speedRadio = '8';
          break;
        case '9':
          this.player.playbackRate = '3';
          this.audioPlayer.speedRadio = '9';
          break;
        default:
          this.player.playbackRate = '1';
          this.audioPlayer.speedRadio = '3';
      }
    },
    speedControlToggle: function speedControlToggle(val) {
      this.audioPlayer.speed = val;
      this.audioPlayer.speedRadio = val;
      this.speedControl();
    },
    rangeSliderEvent: function rangeSliderEvent(event) {
      switch (event) {
        case 'start':
          this.rangeSlider.start = this.rangeSlider.current;
          //TODO: Stats for dragstart (?)
          break;
        case 'stop':
          this.rangeSlider.end = this.rangeSlider.current;
          //TODO: Stats for dragend (?)
          break;
        case 'click':
          this.rangeSlider.current;
          this.startTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60);
          break;
      }
    },
    seekSelect: function seekSelect() {
      if (this.audioPlayer.currentTimeInSeconds < this.audioPlayer.durationInSeconds && this.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["a" /* EPISODE */]) {
        this.audioPlayer.currentTimeInSeconds = this.rangeSlider.current;
        __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].seekTo(this.player, this.audioPlayer.currentTimeInSeconds);
      }
    },
    /**
     *
     * This function listens for when an audio file plays until the end. When this occurs an end event occurs and executes the appropriate methods.
     *
     */
    listenForEndEvent: function listenForEndEvent(player) {
      var _this3 = this;
      this.player.addEventListener('ended', function () {
        if (_this3.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["b" /* MID_ROLL */]) {
          _this3.trackAdCompleteImpression();
          _this3.pauseAudio();
          _this3.setEpisodeMetaData();
          _this3.audioPlayer.currentTimeInSeconds = Math.floor(_this3.currentPlayObject.currentMidroll);
          _this3.playAudio(_this3.currentPlayObject.episode.streamUrl, _this3.currentPlayObject.currentMidroll);
        } else if (_this3.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["d" /* PRE_ROLL */]) {
          _this3.trackAdCompleteImpression();
          _this3.pauseAudio();
          _this3.setEpisodeMetaData();
          _this3.playAudio(_this3.currentPlayObject.episode.streamUrl, 0);
        } else if (_this3.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["a" /* EPISODE */]) {
          _this3.trackEpisodeCompleteImpression();
          _this3.pauseAudio();
          _this3.getObjectFromList(__WEBPACK_IMPORTED_MODULE_12__model_constants_WhichObject__["a" /* NEXT */]);
        }
      });
    },
    endEventListener: function endEventListener() {
      if (this.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["b" /* MID_ROLL */]) {
        this.trackAdCompleteImpression();
        this.pauseAudio();
        this.setEpisodeMetaData();
        this.audioPlayer.currentTimeInSeconds = Math.floor(this.currentPlayObject.currentMidroll);
        this.playAudio(this.currentPlayObject.episode.streamUrl, this.currentPlayObject.currentMidroll);
      } else if (this.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["d" /* PRE_ROLL */]) {
        this.trackAdCompleteImpression();
        this.pauseAudio();
        this.setEpisodeMetaData();
        this.playAudio(this.currentPlayObject.episode.streamUrl, 0);
      } else if (this.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["a" /* EPISODE */]) {
        this.trackEpisodeCompleteImpression();
        this.stats.endTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60);
        this.statComposer('completed');
        this.pauseAudio();
        this.stats.startTimeMinutes = 0;
        this.getObjectFromList(__WEBPACK_IMPORTED_MODULE_12__model_constants_WhichObject__["a" /* NEXT */]);
      }
    },
    closePlayer: function closePlayer() {
      this.audioPlayer.showAudioPlayer = false;
      if (this.currentPlayObject.playState === __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["c" /* PLAYING */]) {
        this.player.pause();
        this.currentPlayObject.playState = __WEBPACK_IMPORTED_MODULE_11__model_constants_PlayState__["b" /* PAUSED */];
        this.stats.endTimeMinutes = Math.floor(this.audioPlayer.currentTimeInSeconds / 60);
        this.statComposer('stopped');
      }
      if (this.audioPlayer.playerElement !== undefined && this.audioPlayer.playerElement !== null && this.audioPlayer.playerElement.classList.contains('fullscreen')) {
        this.audioPlayer.playerElement.classList.remove('fullscreen');
      }
      this.viewSize = 'default';
      if (document.getElementById('afripods-content') !== null) {
        document.getElementById('afripods-content').classList.remove('media-player-open');
      }
    },
    /**
     * Listens for the track time and performs actions required to be done while an episode is playing. Mainly updates the player timer
     * and if there are midroll ads it listens for the time points of these ads, and will play the ad if necessary.
     *
     * @param player
     */
    listenForTimePoints: function listenForTimePoints(player) {
      player.addEventListener('timeupdate', this.timeUpdateEventListener);
    },
    timeUpdateEventListener: function timeUpdateEventListener(event) {
      var _this4 = this;
      this.audioPlayer.currentTimeInSeconds = Math.floor(this.player.currentTime);
      this.rangeSlider.current = Math.floor(this.player.currentTime);
      this.audioPlayer.playerEpisodeCurrentTime = Object(__WEBPACK_IMPORTED_MODULE_4__filters__["k" /* trackDuration */])(this.player.currentTime);
      if (this.currentPlayObject.currentObjectType === __WEBPACK_IMPORTED_MODULE_10__model_constants_ObjectType__["a" /* EPISODE */]) {
        var midRoll = this.currentPlayObject.midRollads.find(function (midRollAd, index) {
          return __WEBPACK_IMPORTED_MODULE_13__utils_AudioPlayerUtils__["a" /* AudioPlayerUtils */].isMidRollPoint(_this4.player.currentTime, midRollAd);
        });
        if (midRoll) {
          this.playMidRoll(midRoll);
        }
      }
    },
    sendTrackingData: function sendTrackingData(stat) {
      var _this5 = this;
      __WEBPACK_IMPORTED_MODULE_1__api_statistics_statistics__["a" /* default */].createTrackingData(stat).then(function (res) {
        return res;
      }).catch(function (e) {
        return _this5.$log.debug('** Afripods error on sendTrackingData(): ', e);
      });
    },
    sendTrackingDataObject: function sendTrackingDataObject(object) {
      var self = this;
      setTimeout(function () {
        var _this6 = this;
        if (object.length > 0) {
          __WEBPACK_IMPORTED_MODULE_1__api_statistics_statistics__["a" /* default */].createListOfTrackingData(object).then(function (res) {
            return res;
          }).catch(function (e) {
            return _this6.$log.debug('** Afripods error on sendTrackingDataObject(): ', e);
          });
          self.statsObject = [];
        }
        self.sendTrackingDataObject(self.statsObject);
      }, 30000);
    },
    oldEpisodeImpression: function oldEpisodeImpression(episodeId) {
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.episodes + '/' + episodeId + '/play', {}, {
        headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
      }).then(function (response) {}, function (e) {
        this.$log.debug('Error sending ad impression to server ' + e.body.message);
      });
    },
    oldAdImpression: function oldAdImpression(scheduleAdId, episodeId) {
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.ads + '?scheduled_ad_id=' + scheduleAdId + '&episode_id=' + episodeId, {}, {
        headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
      }).then(function (response) {}, function (e) {
        this.$log.debug('Error sending episode impression to server ' + e.body.message);
      });
    },
    mediaPlayerFullscreen: function mediaPlayerFullscreen(e) {
      if (window.innerWidth < 992 && window.innerHeight > 567 && !document.getElementById('audio-player').classList.contains('fullscreen') && window === window.parent) {
        this.audioPlayer.playerElement = document.getElementById('audio-player');
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          if (this.audioPlayer.playerElement.requestFullscreen) {
            this.audioPlayer.playerElement.requestFullscreen();
          } else if (this.audioPlayer.playerElement.webkitRequestFullscreen) {
            /* Safari */
            this.audioPlayer.playerElement.webkitRequestFullscreen();
          } else if (this.audioPlayer.playerElement.msRequestFullscreen) {
            /* IE11 */
            this.audioPlayer.playerElement.msRequestFullscreen();
          }
          this.audioPlayer.playerElement.className += ' fullscreen';
          this.viewSize = 'fullscreen';
        }
      }
    },
    screenResized: function screenResized() {
      if (window.innerWidth > 991) {
        this.view = 'desktop';
        if (document.exitFullscreen && document.fullscreenElement !== null) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen && document.fullscreenElement !== null) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen && document.fullscreenElement !== null) {
          /* IE11 */
          document.msExitFullscreen();
        }
        if (this.audioPlayer.playerElement !== undefined && this.audioPlayer.playerElement !== null && this.audioPlayer.playerElement.classList.contains('fullscreen')) {
          this.audioPlayer.playerElement.classList.remove('fullscreen');
        }
        this.viewSize = 'default';
      } else {
        this.view = 'mobile';
      }
    },
    minimizeFullscreen: function minimizeFullscreen() {
      this.audioPlayer.playerElement.classList.remove('fullscreen');
      this.viewSize = 'default';
      if (document.exitFullscreen && document.fullscreenElement !== null) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen && document.fullscreenElement !== null) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen && document.fullscreenElement !== null) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },
    mobileSpeedMenu: function mobileSpeedMenu() {
      var speedMenu = document.getElementById('speed-menu');
      speedMenu.classList.add('open');
    },
    mobileShareMenu: function mobileShareMenu() {
      var mobileShareMenu = document.getElementById('mobile-share-menu');
      mobileShareMenu.classList.add('open');
    },
    speedMenuClose: function speedMenuClose() {
      var speedMenu = document.getElementById('speed-menu');
      speedMenu.classList.remove('open');
    },
    shareMenuClose: function shareMenuClose() {
      var shareMenu = document.getElementById('mobile-share-menu');
      shareMenu.classList.remove('open');
    },
    copyUrl: function copyUrl() {
      var dummy = document.createElement('input');
      var text = window.location.href;
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      alert('Link copied to clipboard');
    },
    checkUserSave: function checkUserSave() {
      var _this7 = this;
      var userBookmarks = localStorage.getItem('userBookmarks');
      var savedEpisodes = userBookmarks ? JSON.parse(userBookmarks) : [];
      this.episodeSaved = !!savedEpisodes.some(function (el) {
        return el.id === _this7.currentPlayObject.episode.id;
      });
    },
    handleSave: function handleSave() {
      var self = this;
      this.user.userId = __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getLoggedInUserId();
      if (this.user.userId === null) {
        $('#promptModal').modal('show');
      } else {
        // handle save function
        if (!this.episodeSaved) {
          this.sendStatistics('save', this.currentPlayObject.episode.id);
          this.$http.post(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.episodes + '/' + this.currentPlayObject.episode.id + '/save', {}, {
            headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
          }).then(function (response) {
            self.episodeSaved = true;
            this.$http.get(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.listener_dashboard, {
              params: {},
              headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
            }).then(function (response) {
              var data = response.body.data;
              localStorage.setItem('userShows', JSON.stringify(data.shows));
              localStorage.setItem('userBookmarks', JSON.stringify(data.bookmarks));
              localStorage.setItem('userEpisodes', data.episodes);
            });
          }, function (e) {
            this.$notify({
              title: 'Error',
              text: this.getErrorMessage(e),
              type: 'error'
            });
          });
        } else {
          this.sendStatistics('saveRemoved', this.currentPlayObject.episode.id);
          this.$http.delete(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.episodes + '/' + this.currentPlayObject.episode.id + '/save', {
            params: {},
            headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
          }).then(function (response) {
            self.episodeSaved = false;
            this.$http.get(__WEBPACK_IMPORTED_MODULE_3__conf_index__["a" /* default */].url.listener_dashboard, {
              params: {},
              headers: __WEBPACK_IMPORTED_MODULE_2__auth_index__["a" /* default */].getAuthHeader()
            }).then(function (response) {
              var data = response.body.data;
              localStorage.setItem('userShows', JSON.stringify(data.shows));
              localStorage.setItem('userBookmarks', JSON.stringify(data.bookmarks));
              localStorage.setItem('userEpisodes', data.episodes);
            });
          }, function (e) {
            this.$notify({
              title: 'Error',
              text: this.getErrorMessage(e),
              type: 'error'
            });
          });
        }
      }
    },
    sendStatistics: function sendStatistics(type, id) {
      var stat;
      switch (type) {
        case 'save':
          this.checkUserFollowEpisodePodcast();
          stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].episodeSave('favouriteUpdate', true, this.user.podcastFollowed, id, 'audioplayer');
          break;
        case 'saveRemoved':
          this.checkUserFollowEpisodePodcast();
          stat = __WEBPACK_IMPORTED_MODULE_6__utils_Statistics_StatisticsHelper__["a" /* StatisticsHelper */].episodeSave('favouriteUpdate', false, this.user.podcastFollowed, id, 'audioplayer');
          break;
      }
      this.sendTrackingData(stat);
    },
    checkUserFollowEpisodePodcast: function checkUserFollowEpisodePodcast() {
      var _this8 = this;
      var userShows = localStorage.getItem('userShows');
      var followedShows = userShows ? JSON.parse(userShows) : [];
      var following = followedShows.some(function (el) {
        return el.id === _this8.currentPlayObject.episode.podcast_id;
      });
      this.user.podcastFollowed = following;
    },
    goToPodcast: function goToPodcast() {
      if (this.view === 'mobile' && this.viewSize === 'default') return;
      var podcast = {
        id: this.currentPlayObject.episode.podcast_id.toString(),
        slug: this.currentPlayObject.episode.podcast_slug
      };
      this.$router.push({
        name: 'Podcast',
        params: {
          slug: podcast.slug || podcast.id
        }
      });
      if (this.view === 'mobile' && this.viewSize === 'fullscreen') {
        this.minimizeFullscreen();
      }
    }
  }
});

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PRE_ROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MID_ROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EPISODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NONE; });
var PRE_ROLL = 'preRoll';
var MID_ROLL = 'midRoll';
var EPISODE = 'episode';
var NONE = 'none';

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PREVIOUS; });
var NEXT = 'next';
var PREVIOUS = 'previous';

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FooterSection_vue_vue_type_script_lang_js___ = __webpack_require__(413);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FooterSection_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_ChangeEmail__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ChangePassword__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_reused_components_login_button_LoginButton__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_reused_components_login_form_LoginForm__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_reused_components_retrieve_password_form_RetrievePasswordForm__ = __webpack_require__(713);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AfripodsFooter',
  components: {
    LoginButton: __WEBPACK_IMPORTED_MODULE_2_components_reused_components_login_button_LoginButton__["a" /* default */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_3_components_reused_components_login_form_LoginForm__["a" /* default */],
    ChangeForm: __WEBPACK_IMPORTED_MODULE_1_components_ChangePassword__["a" /* default */],
    ChangeEmailForm: __WEBPACK_IMPORTED_MODULE_0_components_ChangeEmail__["a" /* default */],
    RetrievePasswordForm: __WEBPACK_IMPORTED_MODULE_4_components_reused_components_retrieve_password_form_RetrievePasswordForm__["a" /* default */]
  },
  props: {
    lt: {
      type: String,
      default: 'listener'
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loginType: this.lt,
      year: new Date().getFullYear()
    };
  },
  watch: {
    lt: function lt() {
      this.loginType = this.lt;
    }
  },
  methods: {
    closeLogin: function closeLogin() {
      $('#loginModal').modal('hide');
    },
    closePrompt: function closePrompt() {
      $('#promptModal').modal('hide');
    },
    updatelt: function updatelt(type) {
      this.loginType = type;
      this.$emit('ltchanged', type);
    }
  }
});

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEmail_vue_vue_type_script_lang_js___ = __webpack_require__(415);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEmail_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__(64);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      change: {
        user_id: '',
        email: '',
        confirmEmail: ''
      },
      user: {
        user_id: '',
        email: ''
      },
      formData: {
        id: '',
        name: '',
        biography: '',
        image: '',
        cover_image: '',
        email: ''
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.fetchUserDetails();
    $.validate({
      form: '#email-change-form',
      modules: 'security',
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function onSuccess($form) {
        self.changeEmail();
        return false;
      }
    });
  },
  methods: {
    changeEmail: function changeEmail() {
      this.fetchUserDetails();
      if (this.change.email === this.user.email) {
        this.$http.put(__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* default */].url.listener_users + '/' + this.user.user_id, this.formData, {
          headers: __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].getAuthHeader()
        }).then(function (response) {
          if (response.status == 200) {
            this.$notify({
              title: 'Success!',
              text: 'Email changed successfully!',
              type: 'success'
            });
            $('#changeEmailModal').modal('hide');
            this.user.email = this.formData.email;
            this.formData.email = '';
            this.change.email = '';
            this.change.confirmEmail = '';
            this.$router.go();
          }
        }, function (e) {
          $('#changeEmailModal').modal('hide');
          this.formData.email = '';
          this.change.email = '';
          this.change.confirmEmail = '';
          this.$notify({
            title: 'Response Error',
            text: this.getErrorMessage(e),
            type: 'error'
          });
        });
      } else {
        $('#changeEmailModal').modal('hide');
        this.formData.email = '';
        this.change.email = '';
        this.change.confirmEmail = '';
        this.$notify({
          title: 'Error',
          text: 'Current email is wrong',
          type: 'error'
        });
      }
    },
    closeModal: function closeModal() {
      $('#changeEmailModal').modal('hide');
    },
    fetchUserDetails: function fetchUserDetails() {
      var user_id = __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].getLoggedInUserId();
      var self = this;
      if (user_id !== null) {
        this.$http.get(__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* default */].url.listener_users + '/' + user_id, {
          params: {},
          headers: __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].getAuthHeader()
        }).then(function (response) {
          self.user.email = response.body.data.email;
          self.user.user_id = response.body.data.id;
          self.formData.id = response.body.data.id;
          self.formData.name = response.body.data.name;
          self.formData.biography = response.body.data.biography;
          self.formData.image = response.body.data.image;
          self.formData.cover_image = response.body.data.cover_image;
        }, function (err) {
          this.router().go();
        });
      }
    }
  }
});

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangePassword_vue_vue_type_script_lang_js___ = __webpack_require__(417);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangePassword_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__(64);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      change: {
        password: '',
        confirmPassword: ''
      },
      formData: {
        email: '',
        currentPassword: '',
        password: ''
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    $.validate({
      form: '#password-change-form',
      modules: 'security html5',
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function onSuccess($form) {
        self.changePassword();
        return false;
      }
    });
  },
  methods: {
    changePassword: function changePassword() {
      if (this.formData.password === this.change.confirmPassword && this.formData.password !== '') {
        var user_id = localStorage.getItem('afripodsLoggedInUserId');
        this.formData.email = localStorage.getItem('afripodsLoggedInUserEmail');
        this.$http.put(__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* default */].url.podcaster_users + '/' + user_id, this.formData, {
          params: {},
          headers: __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].getAuthHeader()
        }).then(function (response) {
          if (response.status == 200) {
            this.$notify({
              title: 'Success!',
              text: 'Password changed successfully!',
              type: 'success'
            });
            document.getElementById('changePasswordModal').remove();
            document.getElementsByClassName('modal-backdrop')[0].remove();
            this.formData.password = '';
            this.change.confirmPassword = '';
            this.formData.currentPassword = '';
          }
        }, function (e) {
          this.$notify({
            title: 'Something went wrong!',
            text: this.getErrorMessage(e),
            type: 'error'
          });
        });
      }
    },
    closeModal: function closeModal() {
      this.formData.password = '';
      this.formData.currentPassword = '';
      this.change.confirmPassword = '';
      $('#changePasswordModal').modal('hide');
    }
  }
});

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginButton_vue_vue_type_script_lang_js___ = __webpack_require__(419);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginButton_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_arrow_ButtonArrow__ = __webpack_require__(161);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginButton',
  components: {
    ButtonArrow: __WEBPACK_IMPORTED_MODULE_0__button_arrow_ButtonArrow__["a" /* default */]
  }
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonArrow_vue_vue_type_script_lang_js___ = __webpack_require__(421);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonArrow_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ButtonArrow',
  props: {
    // if provided, the text provided by <slot> will be hidden and replaced with the icon on small screens.
    icon: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button',
      validator: function validator(prop) {
        return ['button', 'submit', 'reset'].includes(prop);
      }
    }
  }
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginForm_vue_vue_type_script_lang_js___ = __webpack_require__(423);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginForm_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_arrow_ButtonArrow__ = __webpack_require__(161);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginForm',
  components: {
    ButtonArrow: __WEBPACK_IMPORTED_MODULE_1__button_arrow_ButtonArrow__["a" /* default */]
  },
  props: {
    lt: {
      type: String,
      default: 'listener'
    },
    onExit: {
      type: Function,
      default: function _default() {}
    },
    onPasswordRetrieval: {
      type: Function,
      default: function _default() {}
    },
    onSuccess: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      panel: 'login',
      login: {
        username: '',
        password: '',
        type: this.lt
      },
      loginUsername: '',
      loginPassword: '',
      retrieve: {
        email: ''
      }
    };
  },
  watch: {
    loginPassword: function loginPassword(newVal) {
      if (newVal.length > 0) {
        document.getElementById('password').classList.add('has-value');
      } else {
        document.getElementById('password').classList.remove('has-value');
      }
      this.login.password = newVal;
    },
    loginUsername: function loginUsername(newVal) {
      if (newVal.length > 0) {
        document.getElementById('username').classList.add('has-value');
      } else {
        document.getElementById('username').classList.remove('has-value');
      }
      this.login.username = newVal;
    }
  },
  mounted: function mounted() {
    var _this = this;
    $('#loginModal').on('hidden.bs.modal', function () {
      _this.panel = 'login';
    });
    var self = this;
    $.validate({
      form: '#login-form',
      modules: 'html5',
      validateOnBlur: false,
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function onSuccess() {
        self.checkLogin();
        return false;
      }
    });
    $.validate({
      form: '#retrieve-password-form',
      modules: 'html5',
      validateOnBlur: false,
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function onSuccess() {
        self.retrievePassword();
        return false;
      }
    });
  },
  methods: {
    checkLogin: function checkLogin() {
      var credentials = {
        username: this.login.username,
        password: this.login.password,
        type: 'podcaster'
      };
      __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].login(this, credentials);
      this.onSuccess();
    },
    retrievePassword: function retrievePassword() {
      var credentials = {
        email: this.retrieve.email
      };
      __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].retrievePassword(this, credentials);
      this.retrieve = {
        email: ''
      };
      this.onPasswordRetrieval();
    },
    switchPanel: function switchPanel() {
      this.panel = this.panel === 'login' ? 'retrieve' : 'login';
    }
  }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RetrievePasswordForm_vue_vue_type_script_lang_js___ = __webpack_require__(425);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RetrievePasswordForm_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_arrow_ButtonArrow__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RetrievePasswordForm',
  components: {
    ButtonArrow: __WEBPACK_IMPORTED_MODULE_0__button_arrow_ButtonArrow__["a" /* default */]
  },
  props: {
    onExit: {
      type: Function,
      default: function _default() {}
    },
    onSuccess: {
      type: Function,
      default: function _default() {}
    },
    onPasswordRetrieval: {
      type: Function,
      default: function _default() {}
    },
    lt: {
      type: String,
      default: 'podcaster'
    }
  },
  data: function data() {
    return {
      login: {
        username: '',
        password: '',
        type: this.lt
      },
      retrieve: {
        email: ''
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    $.validate({
      form: '#retrieve-password-form-modal',
      modules: 'html5',
      validateOnBlur: false,
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function onSuccess($form) {
        self.retrievePassword();
        $('#retrievePasswordModal').modal('hide');
        return false;
      }
    });
  },
  methods: {
    retrievePassword: function retrievePassword() {
      this.$log.info('retrieving password');
      var credentials = {
        email: this.retrieve.email
      };
      __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].retrievePassword(this, credentials);
      this.retrieve = {
        email: ''
      };
      this.onPasswordRetrieval();
    },
    closeModal: function closeModal() {
      $('#retrievePasswordModal').modal('hide');
    }
  }
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_script_lang_js___ = __webpack_require__(427);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      editor: null
    };
  },
  watch: {
    value: function value(_value) {
      if (this.editor && this.editor.getLength() > 1) return;
      var delta = this.editor.clipboard.convert(_value);
      this.editor.setContents(delta, 'api');
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.editor = new __WEBPACK_IMPORTED_MODULE_0_quill___default.a(this.$refs.editor, {
      modules: {
        toolbar: [['bold', 'italic', 'underline', 'strike', 'link'], [{
          script: 'sub'
        }, {
          script: 'super'
        }], [{
          list: 'ordered'
        }, {
          list: 'bullet'
        }], [{
          color: []
        }, {
          background: []
        }]]
      },
      theme: 'snow'
    });
    this.editor.on('text-change', function () {
      return _this.update();
    });
  },
  methods: {
    update: function update() {
      var content = this.editor && this.editor.getLength() > 1 ? this.editor.root.innerHTML : '';
      this.$emit('input', content);
    }
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return startPageLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stopPageLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a, {
  color: '#f2765d',
  backgroundColor: 'rgba(0,0,0,0)',
  opacity: 0.4,
  blur: '20px',
  width: 75,
  height: 75,
  zIndex: 98
});
var pageLoader = null;
var requestAmount = 0;
var startPageLoader = function startPageLoader() {
  if (requestAmount === 0) {
    pageLoader = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.$loading.show();
  }
  requestAmount += 1;
};
var stopPageLoader = function stopPageLoader() {
  requestAmount -= 1;
  if (pageLoader && requestAmount === 0) pageLoader.hide();
};

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export MutationType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PiniaVuePlugin; });
/* unused harmony export acceptHMRUpdate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPinia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defineStore; });
/* unused harmony export getActivePinia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapActions; });
/* unused harmony export mapGetters */
/* unused harmony export mapState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapStores; });
/* unused harmony export mapWritableState */
/* unused harmony export setActivePinia */
/* unused harmony export setMapStoreSuffix */
/* unused harmony export skipHydrate */
/* unused harmony export storeToRefs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_demi__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_devtools_api__ = __webpack_require__(534);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
  * pinia v2.0.35
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */



/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */
var activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */
// @ts-expect-error: cannot constrain the type of the return
var setActivePinia = function setActivePinia(pinia) {
  return activePinia = pinia;
};
/**
 * Get the currently active pinia if there is any.
 */
var getActivePinia = function getActivePinia() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentInstance"])() && Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["inject"])(piniaSymbol) || activePinia;
};
var piniaSymbol =  false ? Symbol('pinia') : /* istanbul ignore next */Symbol();
function isPlainObject(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
  return o && _typeof(o) === 'object' && Object.prototype.toString.call(o) === '[object Object]' && typeof o.toJSON !== 'function';
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */
var MutationType;
(function (MutationType) {
  /**
   * Direct mutation of the state:
   *
   * - `store.name = 'new name'`
   * - `store.$state.name = 'new name'`
   * - `store.list.push('new item')`
   */
  MutationType["direct"] = "direct";
  /**
   * Mutated the state with `$patch` and an object
   *
   * - `store.$patch({ name: 'newName' })`
   */
  MutationType["patchObject"] = "patch object";
  /**
   * Mutated the state with `$patch` and a function
   *
   * - `store.$patch(state => state.name = 'newName')`
   */
  MutationType["patchFunction"] = "patch function";
  // maybe reset? for $state = {} and $reset
})(MutationType || (MutationType = {}));
var IS_CLIENT = typeof window !== 'undefined';
/**
 * Should we add the devtools plugins.
 * - only if dev mode or forced through the prod devtools flag
 * - not in test
 * - only if window exists (could change in the future)
 */
var USE_DEVTOOLS = ("production" !== 'production' || typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__) && !("production" === 'test') && IS_CLIENT;

/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */
// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
var _global = /*#__PURE__*/function () {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.window === window ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === 'object' && self.self === self ? self : (typeof global === "undefined" ? "undefined" : _typeof(global)) === 'object' && global.global === global ? global : (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === 'object' ? globalThis : {
    HTMLElement: null
  };
}();
function bom(blob) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$autoBom = _ref.autoBom,
    autoBom = _ref$autoBom === void 0 ? false : _ref$autoBom;
  // prepend BOM for UTF-8 XML and text/* types (including HTML)
  // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
  if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
    return new Blob([String.fromCharCode(0xfeff), blob], {
      type: blob.type
    });
  }
  return blob;
}
function download(url, name, opts) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    saveAs(xhr.response, name, opts);
  };
  xhr.onerror = function () {
    console.error('could not download file');
  };
  xhr.send();
}
function corsEnabled(url) {
  var xhr = new XMLHttpRequest();
  // use sync to avoid popup blocker
  xhr.open('HEAD', url, false);
  try {
    xhr.send();
  } catch (e) {}
  return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function click(node) {
  try {
    node.dispatchEvent(new MouseEvent('click'));
  } catch (e) {
    var evt = document.createEvent('MouseEvents');
    evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
    node.dispatchEvent(evt);
  }
}
var _navigator = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' ? navigator : {
  userAgent: ''
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
var isMacOSWebView = /*#__PURE__*/function () {
  return /Macintosh/.test(_navigator.userAgent) && /AppleWebKit/.test(_navigator.userAgent) && !/Safari/.test(_navigator.userAgent);
}();
var saveAs = !IS_CLIENT ? function () {} // noop
:
// Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
typeof HTMLAnchorElement !== 'undefined' && 'download' in HTMLAnchorElement.prototype && !isMacOSWebView ? downloadSaveAs :
// Use msSaveOrOpenBlob as a second approach
'msSaveOrOpenBlob' in _navigator ? msSaveAs :
// Fallback to using FileReader and a popup
fileSaverSaveAs;
function downloadSaveAs(blob) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'download';
  var opts = arguments.length > 2 ? arguments[2] : undefined;
  var a = document.createElement('a');
  a.download = name;
  a.rel = 'noopener'; // tabnabbing
  // TODO: detect chrome extensions & packaged apps
  // a.target = '_blank'
  if (typeof blob === 'string') {
    // Support regular links
    a.href = blob;
    if (a.origin !== location.origin) {
      if (corsEnabled(a.href)) {
        download(blob, name, opts);
      } else {
        a.target = '_blank';
        click(a);
      }
    } else {
      click(a);
    }
  } else {
    // Support blobs
    a.href = URL.createObjectURL(blob);
    setTimeout(function () {
      URL.revokeObjectURL(a.href);
    }, 4e4); // 40s
    setTimeout(function () {
      click(a);
    }, 0);
  }
}
function msSaveAs(blob) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'download';
  var opts = arguments.length > 2 ? arguments[2] : undefined;
  if (typeof blob === 'string') {
    if (corsEnabled(blob)) {
      download(blob, name, opts);
    } else {
      var a = document.createElement('a');
      a.href = blob;
      a.target = '_blank';
      setTimeout(function () {
        click(a);
      });
    }
  } else {
    // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob(bom(blob, opts), name);
  }
}
function fileSaverSaveAs(blob, name, opts, popup) {
  // Open a popup immediately do go around popup blocker
  // Mostly only available on user interaction and the fileReader is async so...
  popup = popup || open('', '_blank');
  if (popup) {
    popup.document.title = popup.document.body.innerText = 'downloading...';
  }
  if (typeof blob === 'string') return download(blob, name, opts);
  var force = blob.type === 'application/octet-stream';
  var isSafari = /constructor/i.test(String(_global.HTMLElement)) || 'safari' in _global;
  var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((isChromeIOS || force && isSafari || isMacOSWebView) && typeof FileReader !== 'undefined') {
    // Safari doesn't allow downloading of blob URLs
    var reader = new FileReader();
    reader.onloadend = function () {
      var url = reader.result;
      if (typeof url !== 'string') {
        popup = null;
        throw new Error('Wrong reader.result type');
      }
      url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
      if (popup) {
        popup.location.href = url;
      } else {
        location.assign(url);
      }
      popup = null; // reverse-tabnabbing #460
    };

    reader.readAsDataURL(blob);
  } else {
    var url = URL.createObjectURL(blob);
    if (popup) popup.location.assign(url);else location.href = url;
    popup = null; // reverse-tabnabbing #460
    setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 4e4); // 40s
  }
}

/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */
function toastMessage(message, type) {
  var piniaMessage = '🍍 ' + message;
  if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') {
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
  } else if (type === 'error') {
    console.error(piniaMessage);
  } else if (type === 'warn') {
    console.warn(piniaMessage);
  } else {
    console.log(piniaMessage);
  }
}
function isPinia(o) {
  return '_a' in o && 'install' in o;
}
function checkClipboardAccess() {
  if (!('clipboard' in navigator)) {
    toastMessage("Your browser doesn't support the Clipboard API", 'error');
    return true;
  }
}
function checkNotFocusedError(error) {
  if (error instanceof Error && error.message.toLowerCase().includes('document is not focused')) {
    toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
    return true;
  }
  return false;
}
function actionGlobalCopyState(_x) {
  return _actionGlobalCopyState.apply(this, arguments);
}
function _actionGlobalCopyState() {
  _actionGlobalCopyState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(pinia) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!checkClipboardAccess()) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return");
        case 2:
          _context4.prev = 2;
          _context4.next = 5;
          return navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        case 5:
          toastMessage('Global state copied to clipboard.');
          _context4.next = 14;
          break;
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](2);
          if (!checkNotFocusedError(_context4.t0)) {
            _context4.next = 12;
            break;
          }
          return _context4.abrupt("return");
        case 12:
          toastMessage("Failed to serialize the state. Check the console for more details.", 'error');
          console.error(_context4.t0);
        case 14:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 8]]);
  }));
  return _actionGlobalCopyState.apply(this, arguments);
}
function actionGlobalPasteState(_x2) {
  return _actionGlobalPasteState.apply(this, arguments);
}
function _actionGlobalPasteState() {
  _actionGlobalPasteState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(pinia) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!checkClipboardAccess()) {
            _context5.next = 2;
            break;
          }
          return _context5.abrupt("return");
        case 2:
          _context5.prev = 2;
          _context5.t0 = JSON;
          _context5.next = 6;
          return navigator.clipboard.readText();
        case 6:
          _context5.t1 = _context5.sent;
          pinia.state.value = _context5.t0.parse.call(_context5.t0, _context5.t1);
          toastMessage('Global state pasted from clipboard.');
          _context5.next = 17;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t2 = _context5["catch"](2);
          if (!checkNotFocusedError(_context5.t2)) {
            _context5.next = 15;
            break;
          }
          return _context5.abrupt("return");
        case 15:
          toastMessage("Failed to deserialize the state from clipboard. Check the console for more details.", 'error');
          console.error(_context5.t2);
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[2, 11]]);
  }));
  return _actionGlobalPasteState.apply(this, arguments);
}
function actionGlobalSaveState(_x3) {
  return _actionGlobalSaveState.apply(this, arguments);
}
function _actionGlobalSaveState() {
  _actionGlobalSaveState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(pinia) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          try {
            saveAs(new Blob([JSON.stringify(pinia.state.value)], {
              type: 'text/plain;charset=utf-8'
            }), 'pinia-state.json');
          } catch (error) {
            toastMessage("Failed to export the state as JSON. Check the console for more details.", 'error');
            console.error(error);
          }
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _actionGlobalSaveState.apply(this, arguments);
}
var fileInput;
function getFileOpener() {
  if (!fileInput) {
    fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.json';
  }
  function openFile() {
    return new Promise(function (resolve, reject) {
      fileInput.onchange = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var files, file;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              files = fileInput.files;
              if (files) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", resolve(null));
            case 3:
              file = files.item(0);
              if (file) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", resolve(null));
            case 6:
              _context.t0 = resolve;
              _context.next = 9;
              return file.text();
            case 9:
              _context.t1 = _context.sent;
              _context.t2 = file;
              _context.t3 = {
                text: _context.t1,
                file: _context.t2
              };
              return _context.abrupt("return", (0, _context.t0)(_context.t3));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      // @ts-ignore: TODO: changed from 4.3 to 4.4
      fileInput.oncancel = function () {
        return resolve(null);
      };
      fileInput.onerror = reject;
      fileInput.click();
    });
  }
  return openFile;
}
function actionGlobalOpenStateFile(_x4) {
  return _actionGlobalOpenStateFile.apply(this, arguments);
}
function _actionGlobalOpenStateFile() {
  _actionGlobalOpenStateFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(pinia) {
    var _open, result, text, file;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return getFileOpener();
        case 3:
          _open = _context7.sent;
          _context7.next = 6;
          return _open();
        case 6:
          result = _context7.sent;
          if (result) {
            _context7.next = 9;
            break;
          }
          return _context7.abrupt("return");
        case 9:
          text = result.text, file = result.file;
          pinia.state.value = JSON.parse(text);
          toastMessage("Global state imported from \"".concat(file.name, "\"."));
          _context7.next = 18;
          break;
        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7["catch"](0);
          toastMessage("Failed to export the state as JSON. Check the console for more details.", 'error');
          console.error(_context7.t0);
        case 18:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 14]]);
  }));
  return _actionGlobalOpenStateFile.apply(this, arguments);
}
function formatDisplay(display) {
  return {
    _custom: {
      display: display
    }
  };
}
var PINIA_ROOT_LABEL = '🍍 Pinia (root)';
var PINIA_ROOT_ID = '_root';
function formatStoreForInspectorTree(store) {
  return isPinia(store) ? {
    id: PINIA_ROOT_ID,
    label: PINIA_ROOT_LABEL
  } : {
    id: store.$id,
    label: store.$id
  };
}
function formatStoreForInspectorState(store) {
  if (isPinia(store)) {
    var storeNames = Array.from(store._s.keys());
    var storeMap = store._s;
    var _state = {
      state: storeNames.map(function (storeId) {
        return {
          editable: true,
          key: storeId,
          value: store.state.value[storeId]
        };
      }),
      getters: storeNames.filter(function (id) {
        return storeMap.get(id)._getters;
      }).map(function (id) {
        var store = storeMap.get(id);
        return {
          editable: false,
          key: id,
          value: store._getters.reduce(function (getters, key) {
            getters[key] = store[key];
            return getters;
          }, {})
        };
      })
    };
    return _state;
  }
  var state = {
    state: Object.keys(store.$state).map(function (key) {
      return {
        editable: true,
        key: key,
        value: store.$state[key]
      };
    })
  };
  // avoid adding empty getters
  if (store._getters && store._getters.length) {
    state.getters = store._getters.map(function (getterName) {
      return {
        editable: false,
        key: getterName,
        value: store[getterName]
      };
    });
  }
  if (store._customProperties.size) {
    state.customProperties = Array.from(store._customProperties).map(function (key) {
      return {
        editable: true,
        key: key,
        value: store[key]
      };
    });
  }
  return state;
}
function formatEventData(events) {
  if (!events) return {};
  if (Array.isArray(events)) {
    // TODO: handle add and delete for arrays and objects
    return events.reduce(function (data, event) {
      data.keys.push(event.key);
      data.operations.push(event.type);
      data.oldValue[event.key] = event.oldValue;
      data.newValue[event.key] = event.newValue;
      return data;
    }, {
      oldValue: {},
      keys: [],
      operations: [],
      newValue: {}
    });
  } else {
    return {
      operation: formatDisplay(events.type),
      key: formatDisplay(events.key),
      oldValue: events.oldValue,
      newValue: events.newValue
    };
  }
}
function formatMutationType(type) {
  switch (type) {
    case MutationType.direct:
      return 'mutation';
    case MutationType.patchFunction:
      return '$patch';
    case MutationType.patchObject:
      return '$patch';
    default:
      return 'unknown';
  }
}

// timeline can be paused when directly changing the state
var isTimelineActive = true;
var componentStateTypes = [];
var MUTATIONS_LAYER_ID = 'pinia:mutations';
var INSPECTOR_ID = 'pinia';
var assign$1 = Object.assign;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */
var getStoreType = function getStoreType(id) {
  return '🍍 ' + id;
};
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */
function registerPiniaDevtools(app, pinia) {
  Object(__WEBPACK_IMPORTED_MODULE_1__vue_devtools_api__["a" /* setupDevtoolsPlugin */])({
    id: 'dev.esm.pinia',
    label: 'Pinia 🍍',
    logo: 'https://pinia.vuejs.org/logo.svg',
    packageName: 'pinia',
    homepage: 'https://pinia.vuejs.org',
    componentStateTypes: componentStateTypes,
    app: app
  }, function (api) {
    if (typeof api.now !== 'function') {
      toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
    }
    api.addTimelineLayer({
      id: MUTATIONS_LAYER_ID,
      label: "Pinia \uD83C\uDF4D",
      color: 0xe5df88
    });
    api.addInspector({
      id: INSPECTOR_ID,
      label: 'Pinia 🍍',
      icon: 'storage',
      treeFilterPlaceholder: 'Search stores',
      actions: [{
        icon: 'content_copy',
        action: function action() {
          actionGlobalCopyState(pinia);
        },
        tooltip: 'Serialize and copy the state'
      }, {
        icon: 'content_paste',
        action: function () {
          var _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return actionGlobalPasteState(pinia);
                case 2:
                  api.sendInspectorTree(INSPECTOR_ID);
                  api.sendInspectorState(INSPECTOR_ID);
                case 4:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function action() {
            return _action.apply(this, arguments);
          }
          return action;
        }(),
        tooltip: 'Replace the state with the content of your clipboard'
      }, {
        icon: 'save',
        action: function action() {
          actionGlobalSaveState(pinia);
        },
        tooltip: 'Save the state as a JSON file'
      }, {
        icon: 'folder_open',
        action: function () {
          var _action2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return actionGlobalOpenStateFile(pinia);
                case 2:
                  api.sendInspectorTree(INSPECTOR_ID);
                  api.sendInspectorState(INSPECTOR_ID);
                case 4:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function action() {
            return _action2.apply(this, arguments);
          }
          return action;
        }(),
        tooltip: 'Import the state from a JSON file'
      }],
      nodeActions: [{
        icon: 'restore',
        tooltip: 'Reset the state (option store only)',
        action: function action(nodeId) {
          var store = pinia._s.get(nodeId);
          if (!store) {
            toastMessage("Cannot reset \"".concat(nodeId, "\" store because it wasn't found."), 'warn');
          } else if (!store._isOptionsAPI) {
            toastMessage("Cannot reset \"".concat(nodeId, "\" store because it's a setup store."), 'warn');
          } else {
            store.$reset();
            toastMessage("Store \"".concat(nodeId, "\" reset."));
          }
        }
      }]
    });
    api.on.inspectComponent(function (payload, ctx) {
      var proxy = payload.componentInstance && payload.componentInstance.proxy;
      if (proxy && proxy._pStores) {
        var piniaStores = payload.componentInstance.proxy._pStores;
        Object.values(piniaStores).forEach(function (store) {
          payload.instanceData.state.push({
            type: getStoreType(store.$id),
            key: 'state',
            editable: true,
            value: store._isOptionsAPI ? {
              _custom: {
                value: Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRaw"])(store.$state),
                actions: [{
                  icon: 'restore',
                  tooltip: 'Reset the state of this store',
                  action: function action() {
                    return store.$reset();
                  }
                }]
              }
            } :
            // NOTE: workaround to unwrap transferred refs
            Object.keys(store.$state).reduce(function (state, key) {
              state[key] = store.$state[key];
              return state;
            }, {})
          });
          if (store._getters && store._getters.length) {
            payload.instanceData.state.push({
              type: getStoreType(store.$id),
              key: 'getters',
              editable: false,
              value: store._getters.reduce(function (getters, key) {
                try {
                  getters[key] = store[key];
                } catch (error) {
                  // @ts-expect-error: we just want to show it in devtools
                  getters[key] = error;
                }
                return getters;
              }, {})
            });
          }
        });
      }
    });
    api.on.getInspectorTree(function (payload) {
      if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
        var stores = [pinia];
        stores = stores.concat(Array.from(pinia._s.values()));
        payload.rootNodes = (payload.filter ? stores.filter(function (store) {
          return '$id' in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase());
        }) : stores).map(formatStoreForInspectorTree);
      }
    });
    api.on.getInspectorState(function (payload) {
      if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
        var inspectedStore = payload.nodeId === PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
        if (!inspectedStore) {
          // this could be the selected store restored for a different project
          // so it's better not to say anything here
          return;
        }
        if (inspectedStore) {
          payload.state = formatStoreForInspectorState(inspectedStore);
        }
      }
    });
    api.on.editInspectorState(function (payload, ctx) {
      if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
        var inspectedStore = payload.nodeId === PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
        if (!inspectedStore) {
          return toastMessage("store \"".concat(payload.nodeId, "\" not found"), 'error');
        }
        var path = payload.path;
        if (!isPinia(inspectedStore)) {
          // access only the state
          if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) {
            path.unshift('$state');
          }
        } else {
          // Root access, we can omit the `.value` because the devtools API does it for us
          path.unshift('state');
        }
        isTimelineActive = false;
        payload.set(inspectedStore, path, payload.state.value);
        isTimelineActive = true;
      }
    });
    api.on.editComponentState(function (payload) {
      if (payload.type.startsWith('🍍')) {
        var storeId = payload.type.replace(/^🍍\s*/, '');
        var store = pinia._s.get(storeId);
        if (!store) {
          return toastMessage("store \"".concat(storeId, "\" not found"), 'error');
        }
        var path = payload.path;
        if (path[0] !== 'state') {
          return toastMessage("Invalid path for store \"".concat(storeId, "\":\n").concat(path, "\nOnly state can be modified."));
        }
        // rewrite the first entry to be able to directly set the state as
        // well as any other path
        path[0] = '$state';
        isTimelineActive = false;
        payload.set(store, path, payload.state.value);
        isTimelineActive = true;
      }
    });
  });
}
function addStoreToDevtools(app, store) {
  if (!componentStateTypes.includes(getStoreType(store.$id))) {
    componentStateTypes.push(getStoreType(store.$id));
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__vue_devtools_api__["a" /* setupDevtoolsPlugin */])({
    id: 'dev.esm.pinia',
    label: 'Pinia 🍍',
    logo: 'https://pinia.vuejs.org/logo.svg',
    packageName: 'pinia',
    homepage: 'https://pinia.vuejs.org',
    componentStateTypes: componentStateTypes,
    app: app,
    settings: {
      logStoreChanges: {
        label: 'Notify about new/deleted stores',
        type: 'boolean',
        defaultValue: true
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, function (api) {
    // gracefully handle errors
    var now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
    store.$onAction(function (_ref2) {
      var after = _ref2.after,
        onError = _ref2.onError,
        name = _ref2.name,
        args = _ref2.args;
      var groupId = runningActionId++;
      api.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: {
          time: now(),
          title: '🛫 ' + name,
          subtitle: 'start',
          data: {
            store: formatDisplay(store.$id),
            action: formatDisplay(name),
            args: args
          },
          groupId: groupId
        }
      });
      after(function (result) {
        activeAction = undefined;
        api.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: now(),
            title: '🛬 ' + name,
            subtitle: 'end',
            data: {
              store: formatDisplay(store.$id),
              action: formatDisplay(name),
              args: args,
              result: result
            },
            groupId: groupId
          }
        });
      });
      onError(function (error) {
        activeAction = undefined;
        api.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: now(),
            logType: 'error',
            title: '💥 ' + name,
            subtitle: 'end',
            data: {
              store: formatDisplay(store.$id),
              action: formatDisplay(name),
              args: args,
              error: error
            },
            groupId: groupId
          }
        });
      });
    }, true);
    store._customProperties.forEach(function (name) {
      Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["unref"])(store[name]);
      }, function (newValue, oldValue) {
        api.notifyComponentUpdate();
        api.sendInspectorState(INSPECTOR_ID);
        if (isTimelineActive) {
          api.addTimelineEvent({
            layerId: MUTATIONS_LAYER_ID,
            event: {
              time: now(),
              title: 'Change',
              subtitle: name,
              data: {
                newValue: newValue,
                oldValue: oldValue
              },
              groupId: activeAction
            }
          });
        }
      }, {
        deep: true
      });
    });
    store.$subscribe(function (_ref3, state) {
      var events = _ref3.events,
        type = _ref3.type;
      api.notifyComponentUpdate();
      api.sendInspectorState(INSPECTOR_ID);
      if (!isTimelineActive) return;
      // rootStore.state[store.id] = state
      var eventData = {
        time: now(),
        title: formatMutationType(type),
        data: assign$1({
          store: formatDisplay(store.$id)
        }, formatEventData(events)),
        groupId: activeAction
      };
      // reset for the next mutation
      activeAction = undefined;
      if (type === MutationType.patchFunction) {
        eventData.subtitle = '⤵️';
      } else if (type === MutationType.patchObject) {
        eventData.subtitle = '🧩';
      } else if (events && !Array.isArray(events)) {
        eventData.subtitle = events.type;
      }
      if (events) {
        eventData.data['rawEvent(s)'] = {
          _custom: {
            display: 'DebuggerEvent',
            type: 'object',
            tooltip: 'raw DebuggerEvent[]',
            value: events
          }
        };
      }
      api.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: eventData
      });
    }, {
      detached: true,
      flush: 'sync'
    });
    var hotUpdate = store._hotUpdate;
    store._hotUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["markRaw"])(function (newStore) {
      hotUpdate(newStore);
      api.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: {
          time: now(),
          title: '🔥 ' + store.$id,
          subtitle: 'HMR update',
          data: {
            store: formatDisplay(store.$id),
            info: formatDisplay("HMR update")
          }
        }
      });
      // update the devtools too
      api.notifyComponentUpdate();
      api.sendInspectorTree(INSPECTOR_ID);
      api.sendInspectorState(INSPECTOR_ID);
    });
    var $dispose = store.$dispose;
    store.$dispose = function () {
      $dispose();
      api.notifyComponentUpdate();
      api.sendInspectorTree(INSPECTOR_ID);
      api.sendInspectorState(INSPECTOR_ID);
      api.getSettings().logStoreChanges && toastMessage("Disposed \"".concat(store.$id, "\" store \uD83D\uDDD1"));
    };
    // trigger an update so it can display new registered stores
    api.notifyComponentUpdate();
    api.sendInspectorTree(INSPECTOR_ID);
    api.sendInspectorState(INSPECTOR_ID);
    api.getSettings().logStoreChanges && toastMessage("\"".concat(store.$id, "\" store installed \uD83C\uDD95"));
  });
}
var runningActionId = 0;
var activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */
function patchActionForGrouping(store, actionNames) {
  // original actions of the store as they are given by pinia. We are going to override them
  var actions = actionNames.reduce(function (storeActions, actionName) {
    // use toRaw to avoid tracking #541
    storeActions[actionName] = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRaw"])(store)[actionName];
    return storeActions;
  }, {});
  var _loop = function _loop(actionName) {
    store[actionName] = function () {
      // setActivePinia(store._p)
      // the running action id is incremented in a before action hook
      var _actionId = runningActionId;
      var trackedStore = new Proxy(store, {
        get: function get() {
          activeAction = _actionId;
          return Reflect.get.apply(Reflect, arguments);
        },
        set: function set() {
          activeAction = _actionId;
          return Reflect.set.apply(Reflect, arguments);
        }
      });
      return actions[actionName].apply(trackedStore, arguments);
    };
  };
  for (var actionName in actions) {
    _loop(actionName);
  }
}
/**
 * pinia.use(devtoolsPlugin)
 */
function devtoolsPlugin(_ref4) {
  var app = _ref4.app,
    store = _ref4.store,
    options = _ref4.options;
  // HMR module
  if (store.$id.startsWith('__hot:')) {
    return;
  }
  // detect option api vs setup api
  if (options.state) {
    store._isOptionsAPI = true;
  }
  // only wrap actions in option-defined stores as this technique relies on
  // wrapping the context of the action with a proxy
  if (typeof options.state === 'function') {
    patchActionForGrouping(
    // @ts-expect-error: can cast the store...
    store, Object.keys(options.actions));
    var originalHotUpdate = store._hotUpdate;
    // Upgrade the HMR to also update the new actions
    Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRaw"])(store)._hotUpdate = function (newStore) {
      originalHotUpdate.apply(this, arguments);
      patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions));
    };
  }
  addStoreToDevtools(app,
  // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
  store);
}

/**
 * Creates a Pinia instance to be used by the application
 */
function createPinia() {
  var scope = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["effectScope"])(true);
  // NOTE: here we could check the window object for a state and directly set it
  // if there is anything like it with Vue 3 SSR
  var state = scope.run(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])({});
  });
  var _p = [];
  // plugins added before calling app.use(pinia)
  var toBeInstalled = [];
  var pinia = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["markRaw"])({
    install: function install(app) {
      // this allows calling useStore() outside of a component setup after
      // installing pinia's plugin
      setActivePinia(pinia);
      if (!__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
        pinia._a = app;
        app.provide(piniaSymbol, pinia);
        app.config.globalProperties.$pinia = pinia;
        /* istanbul ignore else */
        if (USE_DEVTOOLS) {
          registerPiniaDevtools(app, pinia);
        }
        toBeInstalled.forEach(function (plugin) {
          return _p.push(plugin);
        });
        toBeInstalled = [];
      }
    },
    use: function use(plugin) {
      if (!this._a && !__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
        toBeInstalled.push(plugin);
      } else {
        _p.push(plugin);
      }
      return this;
    },
    _p: _p,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: scope,
    _s: new Map(),
    state: state
  });
  // pinia devtools rely on dev only features so they cannot be forced unless
  // the dev build of Vue is used. Avoid old browsers like IE11.
  if (USE_DEVTOOLS && typeof Proxy !== 'undefined') {
    pinia.use(devtoolsPlugin);
  }
  return pinia;
}

/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */
var isUseStore = function isUseStore(fn) {
  return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */
function patchObject(newState, oldState) {
  // no need to go through symbols because they cannot be serialized anyway
  for (var key in oldState) {
    var subPatch = oldState[key];
    // skip the whole sub tree
    if (!(key in newState)) {
      continue;
    }
    var targetValue = newState[key];
    if (isPlainObject(targetValue) && isPlainObject(subPatch) && !Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(subPatch) && !Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isReactive"])(subPatch)) {
      newState[key] = patchObject(targetValue, subPatch);
    } else {
      // objects are either a bit more complex (e.g. refs) or primitives, so we
      // just set the whole thing
      if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["set"])(newState, key, subPatch);
      } else {
        newState[key] = subPatch;
      }
    }
  }
  return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */
function acceptHMRUpdate(initialUseStore, hot) {
  // strip as much as possible from iife.prod
  if (true) {
    return function () {};
  }
  return function (newModule) {
    var pinia = hot.data.pinia || initialUseStore._pinia;
    if (!pinia) {
      // this store is still not used
      return;
    }
    // preserve the pinia instance across loads
    hot.data.pinia = pinia;
    // console.log('got data', newStore)
    for (var exportName in newModule) {
      var useStore = newModule[exportName];
      // console.log('checking for', exportName)
      if (isUseStore(useStore) && pinia._s.has(useStore.$id)) {
        // console.log('Accepting update for', useStore.$id)
        var id = useStore.$id;
        if (id !== initialUseStore.$id) {
          console.warn("The id of the store changed from \"".concat(initialUseStore.$id, "\" to \"").concat(id, "\". Reloading."));
          // return import.meta.hot.invalidate()
          return hot.invalidate();
        }
        var existingStore = pinia._s.get(id);
        if (!existingStore) {
          console.log("[Pinia]: skipping hmr because store doesn't exist yet");
          return;
        }
        useStore(pinia, existingStore);
      }
    }
  };
}
var noop = function noop() {};
function addSubscription(subscriptions, callback, detached) {
  var onCleanup = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  subscriptions.push(callback);
  var removeSubscription = function removeSubscription() {
    var idx = subscriptions.indexOf(callback);
    if (idx > -1) {
      subscriptions.splice(idx, 1);
      onCleanup();
    }
  };
  if (!detached && Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentScope"])()) {
    Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["onScopeDispose"])(removeSubscription);
  }
  return removeSubscription;
}
function triggerSubscriptions(subscriptions) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  subscriptions.slice().forEach(function (callback) {
    callback.apply(void 0, args);
  });
}
function mergeReactiveObjects(target, patchToApply) {
  // Handle Map instances
  if (target instanceof Map && patchToApply instanceof Map) {
    patchToApply.forEach(function (value, key) {
      return target.set(key, value);
    });
  }
  // Handle Set instances
  if (target instanceof Set && patchToApply instanceof Set) {
    patchToApply.forEach(target.add, target);
  }
  // no need to go through symbols because they cannot be serialized anyway
  for (var key in patchToApply) {
    if (!patchToApply.hasOwnProperty(key)) continue;
    var subPatch = patchToApply[key];
    var targetValue = target[key];
    if (isPlainObject(targetValue) && isPlainObject(subPatch) && target.hasOwnProperty(key) && !Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(subPatch) && !Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isReactive"])(subPatch)) {
      // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
      // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
      // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
      target[key] = mergeReactiveObjects(targetValue, subPatch);
    } else {
      // @ts-expect-error: subPatch is a valid value
      target[key] = subPatch;
    }
  }
  return target;
}
var skipHydrateSymbol =  false ? Symbol('pinia:skipHydration') : /* istanbul ignore next */Symbol();
var skipHydrateMap = /*#__PURE__*/new WeakMap();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */
function skipHydrate(obj) {
  return __WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"] ?
  // in @vue/composition-api, the refs are sealed so defineProperty doesn't work...
  /* istanbul ignore next */
  skipHydrateMap.set(obj, 1) && obj : Object.defineProperty(obj, skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */
function shouldHydrate(obj) {
  return __WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"] ? /* istanbul ignore next */!skipHydrateMap.has(obj) : !isPlainObject(obj) || !obj.hasOwnProperty(skipHydrateSymbol);
}
var assign = Object.assign;
function isComputed(o) {
  return !!(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(o) && o.effect);
}
function createOptionsStore(id, options, pinia, hot) {
  var state = options.state,
    actions = options.actions,
    getters = options.getters;
  var initialState = pinia.state.value[id];
  var store;
  function setup() {
    if (!initialState && (!("production" !== 'production') || !hot)) {
      /* istanbul ignore if */
      if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["set"])(pinia.state.value, id, state ? state() : {});
      } else {
        pinia.state.value[id] = state ? state() : {};
      }
    }
    // avoid creating a state in pinia.state.value
    var localState =  false ?
    // use ref() to unwrap refs inside state TODO: check if this is still necessary
    toRefs(ref(state ? state() : {}).value) : Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRefs"])(pinia.state.value[id]);
    return assign(localState, actions, Object.keys(getters || {}).reduce(function (computedGetters, name) {
      if (false) {
        console.warn("[\uD83C\uDF4D]: A getter cannot have the same name as another state property. Rename one of them. Found with \"".concat(name, "\" in store \"").concat(id, "\"."));
      }
      computedGetters[name] = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["markRaw"])(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["computed"])(function () {
        setActivePinia(pinia);
        // it was created just before
        var store = pinia._s.get(id);
        // allow cross using stores
        /* istanbul ignore next */
        if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"] && !store._r) return;
        // @ts-expect-error
        // return getters![name].call(context, context)
        // TODO: avoid reading the getter while assigning with a global variable
        return getters[name].call(store, store);
      }));
      return computedGetters;
    }, {}));
  }
  store = createSetupStore(id, setup, options, pinia, hot, true);
  return store;
}
function createSetupStore($id, setup) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var pinia = arguments.length > 3 ? arguments[3] : undefined;
  var hot = arguments.length > 4 ? arguments[4] : undefined;
  var isOptionsStore = arguments.length > 5 ? arguments[5] : undefined;
  var scope;
  var optionsForPlugin = assign({
    actions: {}
  }, options);
  /* istanbul ignore if */
  if (false) {
    throw new Error('Pinia destroyed');
  }
  // watcher options for $subscribe
  var $subscribeOptions = {
    deep: true
    // flush: 'post',
  };
  /* istanbul ignore else */
  if (false) {
    $subscribeOptions.onTrigger = function (event) {
      /* istanbul ignore else */
      if (isListening) {
        debuggerEvents = event;
        // avoid triggering this while the store is being built and the state is being set in pinia
      } else if (isListening == false && !store._hotUpdating) {
        // let patch send all the events together later
        /* istanbul ignore else */
        if (Array.isArray(debuggerEvents)) {
          debuggerEvents.push(event);
        } else {
          console.error('🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug.');
        }
      }
    };
  }
  // internal state
  var isListening; // set to true at the end
  var isSyncListening; // set to true at the end
  var subscriptions = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["markRaw"])([]);
  var actionSubscriptions = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["markRaw"])([]);
  var debuggerEvents;
  var initialState = pinia.state.value[$id];
  // avoid setting the state for option stores if it is set
  // by the setup
  if (!isOptionsStore && !initialState && (!("production" !== 'production') || !hot)) {
    /* istanbul ignore if */
    if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
      Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["set"])(pinia.state.value, $id, {});
    } else {
      pinia.state.value[$id] = {};
    }
  }
  var hotState = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["ref"])({});
  // avoid triggering too many listeners
  // https://github.com/vuejs/pinia/issues/1129
  var activeListener;
  function $patch(partialStateOrMutator) {
    var subscriptionMutation;
    isListening = isSyncListening = false;
    // reset the debugger events since patches are sync
    /* istanbul ignore else */
    if (false) {
      debuggerEvents = [];
    }
    if (typeof partialStateOrMutator === 'function') {
      partialStateOrMutator(pinia.state.value[$id]);
      subscriptionMutation = {
        type: MutationType.patchFunction,
        storeId: $id,
        events: debuggerEvents
      };
    } else {
      mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
      subscriptionMutation = {
        type: MutationType.patchObject,
        payload: partialStateOrMutator,
        storeId: $id,
        events: debuggerEvents
      };
    }
    var myListenerId = activeListener = Symbol();
    Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["nextTick"])().then(function () {
      if (activeListener === myListenerId) {
        isListening = true;
      }
    });
    isSyncListening = true;
    // because we paused the watcher, we need to manually call the subscriptions
    triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
  }
  var $reset = isOptionsStore ? function $reset() {
    var state = options.state;
    var newState = state ? state() : {};
    // we use a patch to group all changes into one single subscription
    this.$patch(function ($state) {
      assign($state, newState);
    });
  } : /* istanbul ignore next */
   false ? function () {
    throw new Error("\uD83C\uDF4D: Store \"".concat($id, "\" is built using the setup syntax and does not implement $reset()."));
  } : noop;
  function $dispose() {
    scope.stop();
    subscriptions = [];
    actionSubscriptions = [];
    pinia._s.delete($id);
  }
  /**
   * Wraps an action to handle subscriptions.
   *
   * @param name - name of the action
   * @param action - action to wrap
   * @returns a wrapped action to handle subscriptions
   */
  function wrapAction(name, action) {
    return function () {
      setActivePinia(pinia);
      var args = Array.from(arguments);
      var afterCallbackList = [];
      var onErrorCallbackList = [];
      function after(callback) {
        afterCallbackList.push(callback);
      }
      function onError(callback) {
        onErrorCallbackList.push(callback);
      }
      // @ts-expect-error
      triggerSubscriptions(actionSubscriptions, {
        args: args,
        name: name,
        store: store,
        after: after,
        onError: onError
      });
      var ret;
      try {
        ret = action.apply(this && this.$id === $id ? this : store, args);
        // handle sync errors
      } catch (error) {
        triggerSubscriptions(onErrorCallbackList, error);
        throw error;
      }
      if (ret instanceof Promise) {
        return ret.then(function (value) {
          triggerSubscriptions(afterCallbackList, value);
          return value;
        }).catch(function (error) {
          triggerSubscriptions(onErrorCallbackList, error);
          return Promise.reject(error);
        });
      }
      // trigger after callbacks
      triggerSubscriptions(afterCallbackList, ret);
      return ret;
    };
  }
  var _hmrPayload = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["markRaw"])({
    actions: {},
    getters: {},
    state: [],
    hotState: hotState
  });
  var partialStore = {
    _p: pinia,
    // _s: scope,
    $id: $id,
    $onAction: addSubscription.bind(null, actionSubscriptions),
    $patch: $patch,
    $reset: $reset,
    $subscribe: function $subscribe(callback) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var removeSubscription = addSubscription(subscriptions, callback, options.detached, function () {
        return stopWatcher();
      });
      var stopWatcher = scope.run(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["watch"])(function () {
          return pinia.state.value[$id];
        }, function (state) {
          if (options.flush === 'sync' ? isSyncListening : isListening) {
            callback({
              storeId: $id,
              type: MutationType.direct,
              events: debuggerEvents
            }, state);
          }
        }, assign({}, $subscribeOptions, options));
      });
      return removeSubscription;
    },
    $dispose: $dispose
  };
  /* istanbul ignore if */
  if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
    // start as non ready
    partialStore._r = false;
  }
  var store = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["reactive"])("production" !== 'production' || USE_DEVTOOLS ? assign({
    _hmrPayload: _hmrPayload,
    _customProperties: Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["markRaw"])(new Set()) // devtools custom properties
  }, partialStore
  // must be added later
  // setupStore
  ) : partialStore);
  // store the partial store now so the setup of stores can instantiate each other before they are finished without
  // creating infinite loops.
  pinia._s.set($id, store);
  // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
  var setupStore = pinia._e.run(function () {
    scope = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["effectScope"])();
    return scope.run(function () {
      return setup();
    });
  });
  // overwrite existing actions to support $onAction
  for (var key in setupStore) {
    var prop = setupStore[key];
    if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(prop) && !isComputed(prop) || Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isReactive"])(prop)) {
      // mark it as a piece of state to be serialized
      if (false) {
        set(hotState.value, key, toRef(setupStore, key));
        // createOptionStore directly sets the state in pinia.state.value so we
        // can just skip that
      } else if (!isOptionsStore) {
        // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
        if (initialState && shouldHydrate(prop)) {
          if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(prop)) {
            prop.value = initialState[key];
          } else {
            // probably a reactive object, lets recursively assign
            // @ts-expect-error: prop is unknown
            mergeReactiveObjects(prop, initialState[key]);
          }
        }
        // transfer the ref to the pinia state to keep everything in sync
        /* istanbul ignore if */
        if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
          Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["set"])(pinia.state.value[$id], key, prop);
        } else {
          pinia.state.value[$id][key] = prop;
        }
      }
      /* istanbul ignore else */
      if (false) {
        _hmrPayload.state.push(key);
      }
      // action
    } else if (typeof prop === 'function') {
      // @ts-expect-error: we are overriding the function we avoid wrapping if
      var actionValue =  false ? prop : wrapAction(key, prop);
      // this a hot module replacement store because the hotUpdate method needs
      // to do it with the right context
      /* istanbul ignore if */
      if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["set"])(setupStore, key, actionValue);
      } else {
        // @ts-expect-error
        setupStore[key] = actionValue;
      }
      /* istanbul ignore else */
      if (false) {
        _hmrPayload.actions[key] = prop;
      }
      // list actions so they can be used in plugins
      // @ts-expect-error
      optionsForPlugin.actions[key] = prop;
    } else if (false) {
      // add getters for devtools
      if (isComputed(prop)) {
        _hmrPayload.getters[key] = isOptionsStore ?
        // @ts-expect-error
        options.getters[key] : prop;
        if (IS_CLIENT) {
          var getters = setupStore._getters || (
          // @ts-expect-error: same
          setupStore._getters = markRaw([]));
          getters.push(key);
        }
      }
    }
  }
  // add the state, getters, and action properties
  /* istanbul ignore if */
  if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
    Object.keys(setupStore).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["set"])(store, key, setupStore[key]);
    });
  } else {
    assign(store, setupStore);
    // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
    // Make `storeToRefs()` work with `reactive()` #799
    assign(Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRaw"])(store), setupStore);
  }
  // use this instead of a computed with setter to be able to create it anywhere
  // without linking the computed lifespan to wherever the store is first
  // created.
  Object.defineProperty(store, '$state', {
    get: function get() {
      return  false ? hotState.value : pinia.state.value[$id];
    },
    set: function set(state) {
      /* istanbul ignore if */
      if (false) {
        throw new Error('cannot set hotState');
      }
      $patch(function ($state) {
        assign($state, state);
      });
    }
  });
  // add the hotUpdate before plugins to allow them to override it
  /* istanbul ignore else */
  if (false) {
    store._hotUpdate = markRaw(function (newStore) {
      store._hotUpdating = true;
      newStore._hmrPayload.state.forEach(function (stateKey) {
        if (stateKey in store.$state) {
          var newStateTarget = newStore.$state[stateKey];
          var oldStateSource = store.$state[stateKey];
          if (_typeof(newStateTarget) === 'object' && isPlainObject(newStateTarget) && isPlainObject(oldStateSource)) {
            patchObject(newStateTarget, oldStateSource);
          } else {
            // transfer the ref
            newStore.$state[stateKey] = oldStateSource;
          }
        }
        // patch direct access properties to allow store.stateProperty to work as
        // store.$state.stateProperty
        set(store, stateKey, toRef(newStore.$state, stateKey));
      });
      // remove deleted state properties
      Object.keys(store.$state).forEach(function (stateKey) {
        if (!(stateKey in newStore.$state)) {
          del(store, stateKey);
        }
      });
      // avoid devtools logging this as a mutation
      isListening = false;
      isSyncListening = false;
      pinia.state.value[$id] = toRef(newStore._hmrPayload, 'hotState');
      isSyncListening = true;
      nextTick().then(function () {
        isListening = true;
      });
      for (var actionName in newStore._hmrPayload.actions) {
        var action = newStore[actionName];
        set(store, actionName, wrapAction(actionName, action));
      }
      // TODO: does this work in both setup and option store?
      var _loop2 = function _loop2() {
        var getter = newStore._hmrPayload.getters[getterName];
        var getterValue = isOptionsStore ?
        // special handling of options api
        computed(function () {
          setActivePinia(pinia);
          return getter.call(store, store);
        }) : getter;
        set(store, getterName, getterValue);
      };
      for (var getterName in newStore._hmrPayload.getters) {
        _loop2();
      }
      // remove deleted getters
      Object.keys(store._hmrPayload.getters).forEach(function (key) {
        if (!(key in newStore._hmrPayload.getters)) {
          del(store, key);
        }
      });
      // remove old actions
      Object.keys(store._hmrPayload.actions).forEach(function (key) {
        if (!(key in newStore._hmrPayload.actions)) {
          del(store, key);
        }
      });
      // update the values used in devtools and to allow deleting new properties later on
      store._hmrPayload = newStore._hmrPayload;
      store._getters = newStore._getters;
      store._hotUpdating = false;
    });
  }
  if (USE_DEVTOOLS) {
    var nonEnumerable = {
      writable: true,
      configurable: true,
      // avoid warning on devtools trying to display this property
      enumerable: false
    };
    ['_p', '_hmrPayload', '_getters', '_customProperties'].forEach(function (p) {
      Object.defineProperty(store, p, assign({
        value: store[p]
      }, nonEnumerable));
    });
  }
  /* istanbul ignore if */
  if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
    // mark the store as ready before plugins
    store._r = true;
  }
  // apply all plugins
  pinia._p.forEach(function (extender) {
    /* istanbul ignore else */
    if (USE_DEVTOOLS) {
      var extensions = scope.run(function () {
        return extender({
          store: store,
          app: pinia._a,
          pinia: pinia,
          options: optionsForPlugin
        });
      });
      Object.keys(extensions || {}).forEach(function (key) {
        return store._customProperties.add(key);
      });
      assign(store, extensions);
    } else {
      assign(store, scope.run(function () {
        return extender({
          store: store,
          app: pinia._a,
          pinia: pinia,
          options: optionsForPlugin
        });
      }));
    }
  });
  if (false) {
    console.warn("[\uD83C\uDF4D]: The \"state\" must be a plain object. It cannot be\n" + "\tstate: () => new MyClass()\n" + "Found in store \"".concat(store.$id, "\"."));
  }
  // only apply hydrate to option stores with an initial state in pinia
  if (initialState && isOptionsStore && options.hydrate) {
    options.hydrate(store.$state, initialState);
  }
  isListening = true;
  isSyncListening = true;
  return store;
}
function defineStore(
// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
  var id;
  var options;
  var isSetupStore = typeof setup === 'function';
  if (typeof idOrOptions === 'string') {
    id = idOrOptions;
    // the option store setup will contain the actual options in this case
    options = isSetupStore ? setupOptions : setup;
  } else {
    options = idOrOptions;
    id = idOrOptions.id;
  }
  function useStore(pinia, hot) {
    var currentInstance = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["getCurrentInstance"])();
    pinia =
    // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    ( false ? null : pinia) || currentInstance && Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["inject"])(piniaSymbol, null);
    if (pinia) setActivePinia(pinia);
    if (false) {
      throw new Error("[\uD83C\uDF4D]: getActivePinia was called with no active Pinia. Did you forget to install pinia?\n" + "\tconst pinia = createPinia()\n" + "\tapp.use(pinia)\n" + "This will fail in production.");
    }
    pinia = activePinia;
    if (!pinia._s.has(id)) {
      // creating the store registers it in `pinia._s`
      if (isSetupStore) {
        createSetupStore(id, setup, options, pinia);
      } else {
        createOptionsStore(id, options, pinia);
      }
      /* istanbul ignore else */
      if (false) {
        // @ts-expect-error: not the right inferred type
        useStore._pinia = pinia;
      }
    }
    var store = pinia._s.get(id);
    if (false) {
      var hotId = '__hot:' + id;
      var newStore = isSetupStore ? createSetupStore(hotId, setup, options, pinia, true) : createOptionsStore(hotId, assign({}, options), pinia, true);
      hot._hotUpdate(newStore);
      // cleanup the state properties and the store from the cache
      delete pinia.state.value[hotId];
      pinia._s.delete(hotId);
    }
    // save stores in instances to access them devtools
    if (false) {
      var vm = currentInstance.proxy;
      var cache = '_pStores' in vm ? vm._pStores : vm._pStores = {};
      cache[id] = store;
    }
    // StoreGeneric cannot be casted towards Store
    return store;
  }
  useStore.$id = id;
  return useStore;
}
var mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */
function setMapStoreSuffix(suffix // could be 'Store' but that would be annoying for JS
) {
  mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */
function mapStores() {
  for (var _len2 = arguments.length, stores = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    stores[_key2] = arguments[_key2];
  }
  if (false) {
    console.warn("[\uD83C\uDF4D]: Directly pass all stores to \"mapStores()\" without putting them in an array:\n" + "Replace\n" + "\tmapStores([useAuthStore, useCartStore])\n" + "with\n" + "\tmapStores(useAuthStore, useCartStore)\n" + "This will fail in production if not fixed.");
    stores = stores[0];
  }
  return stores.reduce(function (reduced, useStore) {
    // @ts-expect-error: $id is added by defineStore
    reduced[useStore.$id + mapStoreSuffix] = function () {
      return useStore(this.$pinia);
    };
    return reduced;
  }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapState(useStore, keysOrMapper) {
  return Array.isArray(keysOrMapper) ? keysOrMapper.reduce(function (reduced, key) {
    reduced[key] = function () {
      return useStore(this.$pinia)[key];
    };
    return reduced;
  }, {}) : Object.keys(keysOrMapper).reduce(function (reduced, key) {
    // @ts-expect-error
    reduced[key] = function () {
      var store = useStore(this.$pinia);
      var storeKey = keysOrMapper[key];
      // for some reason TS is unable to infer the type of storeKey to be a
      // function
      return typeof storeKey === 'function' ? storeKey.call(this, store) : store[storeKey];
    };
    return reduced;
  }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */
var mapGetters = mapState;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapActions(useStore, keysOrMapper) {
  return Array.isArray(keysOrMapper) ? keysOrMapper.reduce(function (reduced, key) {
    // @ts-expect-error
    reduced[key] = function () {
      var _useStore;
      return (_useStore = useStore(this.$pinia))[key].apply(_useStore, arguments);
    };
    return reduced;
  }, {}) : Object.keys(keysOrMapper).reduce(function (reduced, key) {
    // @ts-expect-error
    reduced[key] = function () {
      var _useStore2;
      return (_useStore2 = useStore(this.$pinia))[keysOrMapper[key]].apply(_useStore2, arguments);
    };
    return reduced;
  }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapWritableState(useStore, keysOrMapper) {
  return Array.isArray(keysOrMapper) ? keysOrMapper.reduce(function (reduced, key) {
    // @ts-ignore
    reduced[key] = {
      get: function get() {
        return useStore(this.$pinia)[key];
      },
      set: function set(value) {
        // it's easier to type it here as any
        return useStore(this.$pinia)[key] = value;
      }
    };
    return reduced;
  }, {}) : Object.keys(keysOrMapper).reduce(function (reduced, key) {
    // @ts-ignore
    reduced[key] = {
      get: function get() {
        return useStore(this.$pinia)[keysOrMapper[key]];
      },
      set: function set(value) {
        // it's easier to type it here as any
        return useStore(this.$pinia)[keysOrMapper[key]] = value;
      }
    };
    return reduced;
  }, {});
}

/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */
function storeToRefs(store) {
  // See https://github.com/vuejs/pinia/issues/852
  // It's easier to just use toRefs() even if it includes more stuff
  if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isVue2"]) {
    // @ts-expect-error: toRefs include methods and others
    return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRefs"])(store);
  } else {
    store = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRaw"])(store);
    var refs = {};
    for (var key in store) {
      var value = store[key];
      if (Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isRef"])(value) || Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["isReactive"])(value)) {
        // @ts-expect-error: the key is state or getter
        refs[key] =
        // ---
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["toRef"])(store, key);
      }
    }
    return refs;
  }
}

/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */
var PiniaVuePlugin = function PiniaVuePlugin(_Vue) {
  // Equivalent of
  // app.config.globalProperties.$pinia = pinia
  _Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      if (options.pinia) {
        var pinia = options.pinia;
        // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
        /* istanbul ignore else */
        if (!this._provided) {
          var provideCache = {};
          Object.defineProperty(this, '_provided', {
            get: function get() {
              return provideCache;
            },
            set: function set(v) {
              return Object.assign(provideCache, v);
            }
          });
        }
        this._provided[piniaSymbol] = pinia;
        // propagate the pinia instance in an SSR friendly way
        // avoid adding it to nuxt twice
        /* istanbul ignore else */
        if (!this.$pinia) {
          this.$pinia = pinia;
        }
        pinia._a = this;
        if (IS_CLIENT) {
          // this allows calling useStore() outside of a component setup after
          // installing pinia's plugin
          setActivePinia(pinia);
        }
        if (USE_DEVTOOLS) {
          registerPiniaDevtools(pinia._a, pinia);
        }
      } else if (!this.$pinia && options.parent && options.parent.$pinia) {
        this.$pinia = options.parent.$pinia;
      }
    },
    destroyed: function destroyed() {
      delete this._pStores;
    }
  });
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AudioPlayerUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_PlayObject__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_constants_WhichObject__ = __webpack_require__(411);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var AudioPlayerUtils = /*#__PURE__*/function () {
  function AudioPlayerUtils() {
    _classCallCheck(this, AudioPlayerUtils);
  }
  _createClass(AudioPlayerUtils, null, [{
    key: "getPreRollAds",
    value: function getPreRollAds() {
      var ads = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return ads.filter(function (data) {
        return data.ad.type === 'preroll';
      });
    }
  }, {
    key: "getMidRollAds",
    value: function getMidRollAds() {
      var ads = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return ads.filter(function (data) {
        return data.ad.type === 'midroll';
      });
    }

    /**
     * Creates a list of playObjects so that it is easy for the audio player to navigate through the list.
     *
     * @param episodes
     * @param preRollAds
     * @param midRollAds
     * @returns {Array}
     */
  }, {
    key: "getListOfPlayObjects",
    value: function getListOfPlayObjects(episodes, preRollAds, midRollAds) {
      return episodes.reverse().map(function (item, index) {
        return new __WEBPACK_IMPORTED_MODULE_0__model_PlayObject__["a" /* PlayObject */](index, item, preRollAds, midRollAds);
      });
    }

    /**
     * Returns the object from the listPlayObjects which has the same episode.id as whichObject.
     *
     * WhichObject can be a UUID or a string such as NEXT or PREVIOUS.
     *
     * @param whichObject
     * @param playObjects
     */
  }, {
    key: "getPlayObjectFromListById",
    value: function getPlayObjectFromListById(whichObject, playObjects) {
      return playObjects.find(function (playObject) {
        return whichObject === playObject.episode.id;
      });
    }
  }, {
    key: "getPlayObjectFromListByIndexId",
    value: function getPlayObjectFromListByIndexId(which, currentPlayObject, playObjects) {
      var indexOfObjectToGet = currentPlayObject.episodeIndex;
      if (which === __WEBPACK_IMPORTED_MODULE_1__model_constants_WhichObject__["a" /* NEXT */]) {
        if (indexOfObjectToGet === playObjects.length - 1) {
          indexOfObjectToGet = 0;
        } else {
          indexOfObjectToGet++;
        }
      } else if (which === __WEBPACK_IMPORTED_MODULE_1__model_constants_WhichObject__["b" /* PREVIOUS */]) {
        if (indexOfObjectToGet === 0) {
          indexOfObjectToGet = playObjects.length - 1;
        } else {
          indexOfObjectToGet--;
        }
      }
      return playObjects.find(function (playObject) {
        return indexOfObjectToGet === playObject.episodeIndex;
      });
    }

    /**
     * Removes an ad from the playlist because the user should not listen to an ad again after
     * having listened to it once.
     * @param currentPlayObject
     */
  }, {
    key: "removeAdFromMidrollList",
    value: function removeAdFromMidrollList(currentPlayObject) {
      currentPlayObject.midRollads.forEach(function (adwrapper, index) {
        if (adwrapper.timestamp === currentPlayObject.currentMidroll) {
          currentPlayObject.midRollads.splice(index, 1);
        }
      });
    }
  }, {
    key: "playAudio",
    value: function playAudio(player, url, time) {
      player.src = url;
      player.currentTime = time;
      player.play();
    }
  }, {
    key: "seekTo",
    value: function seekTo(player, time) {
      player.currentTime = time;
    }
  }, {
    key: "isMidRollPoint",
    value: function isMidRollPoint(currentTime, ad) {
      var lowerBound = currentTime - 1.0;
      var upperBound = currentTime + 1.0;
      return lowerBound < ad.timestamp && ad.timestamp < upperBound;
    }

    /**
     * To be able to play an episode or ad on the first click of any episode this fake start must be made.
     * Otherwise, the audio stream will be stopped because the audio player can not be started for the first time
     * with javascript.
     */
  }, {
    key: "fakeStartEpisodeIfPlayerHasNoSrc",
    value: function fakeStartEpisodeIfPlayerHasNoSrc() {
      var player = document.getElementById('audioplayer');
      if (!player.src) {
        player.src = '';
      }
    }
  }]);
  return AudioPlayerUtils;
}();

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createApp */
/* unused harmony export Vue2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVue2", function() { return isVue2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVue3", function() { return isVue3; });
/* unused harmony export install */
/* unused harmony export warn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fragment", function() { return Fragment; });
/* unused harmony export Transition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionGroup", function() { return TransitionGroup; });
/* unused harmony export Teleport */
/* unused harmony export Suspense */
/* unused harmony export KeepAlive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* unused harmony reexport Vue */
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "computed")) __webpack_require__.d(__webpack_exports__, "computed", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["computed"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "customRef")) __webpack_require__.d(__webpack_exports__, "customRef", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["customRef"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "defineComponent")) __webpack_require__.d(__webpack_exports__, "defineComponent", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["defineComponent"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "del")) __webpack_require__.d(__webpack_exports__, "del", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["del"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "effectScope")) __webpack_require__.d(__webpack_exports__, "effectScope", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["effectScope"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "getCurrentInstance")) __webpack_require__.d(__webpack_exports__, "getCurrentInstance", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["getCurrentInstance"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "getCurrentScope")) __webpack_require__.d(__webpack_exports__, "getCurrentScope", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["getCurrentScope"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "h")) __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["h"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "inject")) __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["inject"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "isReactive")) __webpack_require__.d(__webpack_exports__, "isReactive", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["isReactive"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "isReadonly")) __webpack_require__.d(__webpack_exports__, "isReadonly", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["isReadonly"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "isRef")) __webpack_require__.d(__webpack_exports__, "isRef", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["isRef"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "markRaw")) __webpack_require__.d(__webpack_exports__, "markRaw", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["markRaw"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "nextTick")) __webpack_require__.d(__webpack_exports__, "nextTick", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["nextTick"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onBeforeMount")) __webpack_require__.d(__webpack_exports__, "onBeforeMount", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onBeforeMount"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onBeforeUnmount")) __webpack_require__.d(__webpack_exports__, "onBeforeUnmount", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onBeforeUnmount"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onBeforeUpdate")) __webpack_require__.d(__webpack_exports__, "onBeforeUpdate", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onBeforeUpdate"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onMounted")) __webpack_require__.d(__webpack_exports__, "onMounted", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onMounted"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onScopeDispose")) __webpack_require__.d(__webpack_exports__, "onScopeDispose", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onScopeDispose"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onUnmounted")) __webpack_require__.d(__webpack_exports__, "onUnmounted", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onUnmounted"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onUpdated")) __webpack_require__.d(__webpack_exports__, "onUpdated", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onUpdated"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "provide")) __webpack_require__.d(__webpack_exports__, "provide", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["provide"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "reactive")) __webpack_require__.d(__webpack_exports__, "reactive", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["reactive"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "readonly")) __webpack_require__.d(__webpack_exports__, "readonly", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["readonly"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "ref")) __webpack_require__.d(__webpack_exports__, "ref", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["ref"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "set")) __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["set"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "shallowReactive")) __webpack_require__.d(__webpack_exports__, "shallowReactive", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["shallowReactive"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "shallowRef")) __webpack_require__.d(__webpack_exports__, "shallowRef", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["shallowRef"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "toRaw")) __webpack_require__.d(__webpack_exports__, "toRaw", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["toRaw"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "toRef")) __webpack_require__.d(__webpack_exports__, "toRef", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["toRef"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "toRefs")) __webpack_require__.d(__webpack_exports__, "toRefs", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["toRefs"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "unref")) __webpack_require__.d(__webpack_exports__, "unref", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["unref"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "version")) __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["version"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "watch")) __webpack_require__.d(__webpack_exports__, "watch", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["watch"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "watchEffect")) __webpack_require__.d(__webpack_exports__, "watchEffect", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["watchEffect"]; });

var isVue2 = true;
var isVue3 = false;
var Vue2 = __WEBPACK_IMPORTED_MODULE_0_vue___default.a;
var warn = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn;
function install() {}

// createApp polyfill
function createApp(rootComponent, rootProps) {
  var vm;
  var _provide = {};
  var app = {
    config: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config,
    use: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.use.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a),
    mixin: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.mixin.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a),
    component: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.component.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a),
    provide: function provide(key, value) {
      _provide[key] = value;
      return this;
    },
    directive: function directive(name, dir) {
      if (dir) {
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive(name, dir);
        return app;
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive(name);
      }
    },
    mount: function mount(el, hydrating) {
      if (!vm) {
        vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a(Object.assign({
          propsData: rootProps
        }, rootComponent, {
          provide: Object.assign(_provide, rootComponent.provide)
        }));
        vm.$mount(el, hydrating);
        return vm;
      } else {
        return vm;
      }
    },
    unmount: function unmount() {
      if (vm) {
        vm.$destroy();
        vm = undefined;
      }
    }
  };
  return app;
}


// Vue 3 components mock
function createMockComponent(name) {
  return {
    setup: function setup() {
      throw new Error('[vue-demi] ' + name + ' is not supported in Vue 2. It\'s provided to avoid compiler errors.');
    }
  };
}
var Fragment = /*#__PURE__*/createMockComponent('Fragment');
var Transition = /*#__PURE__*/createMockComponent('Transition');
var TransitionGroup = /*#__PURE__*/createMockComponent('TransitionGroup');
var Teleport = /*#__PURE__*/createMockComponent('Teleport');
var Suspense = /*#__PURE__*/createMockComponent('Suspense');
var KeepAlive = /*#__PURE__*/createMockComponent('KeepAlive');


/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createApp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Vue2", function() { return Vue2; });
/* unused harmony export isVue2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVue3", function() { return isVue3; });
/* unused harmony export install */
/* unused harmony export warn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* unused harmony reexport Vue */
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "computed")) __webpack_require__.d(__webpack_exports__, "computed", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["computed"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "defineComponent")) __webpack_require__.d(__webpack_exports__, "defineComponent", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["defineComponent"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "getCurrentInstance")) __webpack_require__.d(__webpack_exports__, "getCurrentInstance", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["getCurrentInstance"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "h")) __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["h"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "inject")) __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["inject"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "nextTick")) __webpack_require__.d(__webpack_exports__, "nextTick", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["nextTick"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onBeforeUnmount")) __webpack_require__.d(__webpack_exports__, "onBeforeUnmount", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onBeforeUnmount"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "onMounted")) __webpack_require__.d(__webpack_exports__, "onMounted", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onMounted"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "ref")) __webpack_require__.d(__webpack_exports__, "ref", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["ref"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "shallowRef")) __webpack_require__.d(__webpack_exports__, "shallowRef", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["shallowRef"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "toRefs")) __webpack_require__.d(__webpack_exports__, "toRefs", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["toRefs"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "unref")) __webpack_require__.d(__webpack_exports__, "unref", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["unref"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "watch")) __webpack_require__.d(__webpack_exports__, "watch", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["watch"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_vue__, "watchEffect")) __webpack_require__.d(__webpack_exports__, "watchEffect", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["watchEffect"]; });

var isVue2 = true;
var isVue3 = false;
var Vue2 = __WEBPACK_IMPORTED_MODULE_0_vue___default.a;
var warn = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn;
function install() {}

// createApp polyfill
function createApp(rootComponent, rootProps) {
  var vm;
  var _provide = {};
  var app = {
    config: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config,
    use: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.use.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a),
    mixin: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.mixin.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a),
    component: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.component.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a),
    provide: function provide(key, value) {
      _provide[key] = value;
      return this;
    },
    directive: function directive(name, dir) {
      if (dir) {
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive(name, dir);
        return app;
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive(name);
      }
    },
    mount: function mount(el, hydrating) {
      if (!vm) {
        vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a(Object.assign({
          propsData: rootProps
        }, rootComponent, {
          provide: Object.assign(_provide, rootComponent.provide)
        }));
        vm.$mount(el, hydrating);
        return vm;
      } else {
        return vm;
      }
    },
    unmount: function unmount() {
      if (vm) {
        vm.$destroy();
        vm = undefined;
      }
    }
  };
  return app;
}



/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_afripods_http_axios_config__ = __webpack_require__(655);

var afripodsHttp = function afripodsHttp() {
  return {
    createTrackingData: function createTrackingData(body) {
      return __WEBPACK_IMPORTED_MODULE_0_api_afripods_http_axios_config__["a" /* default */].post('/data', body);
    },
    createListOfTrackingData: function createListOfTrackingData(body) {
      return __WEBPACK_IMPORTED_MODULE_0_api_afripods_http_axios_config__["a" /* default */].post('/data/list', body);
    }
  };
};
/* harmony default export */ __webpack_exports__["a"] = (afripodsHttp());

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseXmlToJson; });
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var parseXmlToJson = function parseXmlToJson(xml) {
  var json = {};
  var _iterator = _createForOfIteratorHelper(xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var res = _step.value;
      var key = res[1] || res[3];
      var value = res[2] && parseXmlToJson(res[2]);
      json[key] = (value && Object.keys(value).length ? value : res[2]) || null;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return json;
};

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EPISODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AD; });
/* unused harmony export PODCAST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STREAMDURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STREAM; });
var EPISODE = 'episode';
var AD = 'ad';
var PODCAST = 'podcast';
var BUTTON = 'button';
var STREAMDURATION = 'streamedDuration';
var STREAM = 'stream';

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLAY_IMPRESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STREAM_IMPRESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPLETE_IMPRESSION; });
/* unused harmony export PAGE_VIEW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLICK; });
var PLAY_IMPRESSION = 'playImpression';
var STREAM_IMPRESSION = 'streamImpression';
var COMPLETE_IMPRESSION = 'completeImpression';
var PAGE_VIEW = 'pageView';
var CLICK = 'click';

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue_vue_type_template_id_b65d6e7c___ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginForm_vue_vue_type_script_lang_js___ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__LoginForm_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue_vue_type_template_id_b65d6e7c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__LoginForm_vue_vue_type_template_id_b65d6e7c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AudioPlayer_vue_vue_type_template_id_5fdcabd7_scoped_true___ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AudioPlayer_vue_vue_type_script_lang_js___ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_vue_vue_type_style_index_0_id_5fdcabd7_prod_lang_scss___ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AudioPlayer_vue_vue_type_style_index_1_id_5fdcabd7_prod_lang_scss_scoped_true___ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AudioPlayer_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AudioPlayer_vue_vue_type_template_id_5fdcabd7_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AudioPlayer_vue_vue_type_template_id_5fdcabd7_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "5fdcabd7",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginButton_vue_vue_type_template_id_6d751ce2___ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginButton_vue_vue_type_script_lang_js___ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__LoginButton_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__LoginButton_vue_vue_type_template_id_6d751ce2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__LoginButton_vue_vue_type_template_id_6d751ce2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popperjs_core__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pinia__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_mask__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_tooltip__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookies__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_dompurify_html__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_head__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notification__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_resource__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_App__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_reused_components_rich_text_editor_RichTextEditor__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_conf_index__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_router__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_error_handler__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_page_loader__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_stable__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_stable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_stable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_regenerator_runtime_runtime__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_logger__ = __webpack_require__(1039);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_dompurify_html__["a" /* default */], {
  namedConfigurations: {
    plaintext: {
      USE_PROFILES: {
        html: false
      }
    },
    ghost: {
      USE_PROFILES: {
        html: true,
        svg: true
      },
      ADD_TAGS: ['iframe', 'button', 'input', 'video', 'audio', 'script'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'preload', 'class']
    }
  }
});
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_pinia__["a" /* PiniaVuePlugin */]);
var pinia = Object(__WEBPACK_IMPORTED_MODULE_1_pinia__["b" /* createPinia */])();
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_utils_error_handler__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_v_mask__["a" /* default */]);
var hostname = window.location.hostname;
var siteDomain = hostname === 'localhost' ? hostname : ".".concat(hostname);
var cookiesDefaultConfig = {
  expires: '1y',
  path: '/',
  domain: siteDomain,
  secure: true,
  sameSite: 'Strict'
};
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_cookies___default.a, cookiesDefaultConfig);

/* Register custom components */
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.component('RichTextEditor', __WEBPACK_IMPORTED_MODULE_11_components_reused_components_rich_text_editor_RichTextEditor__["a" /* default */]);

/* Add feature flag to show and hide components in different environments. */
// noinspection JSUnusedGlobalSymbols
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$featureFlag = {
  ONLY_PROD: "production" === 'production',
  ONLY_STAGE: "production" === 'stage',
  ONLY_DEV: "production" === 'development',
  ONLY_STAGE_AND_DEV: "production" === 'stage' || "production" === 'development'
};

/* Add http interceptor to control the http requests. */
/* eslint-disable consistent-return */
// noinspection JSUnresolvedVariable,FunctionWithInconsistentReturnsJS
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.http.interceptors.push(function (request, next) {
  // ignore adding page loader for following routes
  var upload = __WEBPACK_IMPORTED_MODULE_12_conf_index__["a" /* default */].upload,
    _UrlConfig$url = __WEBPACK_IMPORTED_MODULE_12_conf_index__["a" /* default */].url,
    episodes = _UrlConfig$url.episodes,
    languages = _UrlConfig$url.languages,
    podcasts = _UrlConfig$url.podcasts;
  var s3UploadURL = 'https://afripods-data.s3.amazonaws.com';
  var bypassURLs = [languages, "".concat(podcasts, "/featured"), "".concat(episodes, "/top"), upload.image, upload.audio, s3UploadURL];
  if (bypassURLs.includes(request.url)) return next();

  // show and hide page loaders for all the requests except for bypassURLs
  Object(__WEBPACK_IMPORTED_MODULE_15_utils_page_loader__["a" /* startPageLoader */])();
  next(function () {
    Object(__WEBPACK_IMPORTED_MODULE_15_utils_page_loader__["b" /* stopPageLoader */])();
  });
});
/* eslint-enable consistent-return */

__WEBPACK_IMPORTED_MODULE_4_vue___default.a.filter('stripHTML', function () {
  var _DOMParser$parseFromS;
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var preserveNewLines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var newString = string.replace(/<(?:br\s?\/?|\/div|\/p)>/g, preserveNewLines ? '\n' : ' ').trim();
  newString = ((_DOMParser$parseFromS = new DOMParser().parseFromString(newString, 'text/html')) === null || _DOMParser$parseFromS === void 0 ? void 0 : _DOMParser$parseFromS.body.textContent) || '';
  newString = newString.replace(/\n{2}/g, '\n').trim();
  if (!preserveNewLines) newString = newString.replace(/\s+/g, ' ').trim();
  return newString;
});
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.filter('highlightString', function () {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!query) return string;
  var queryRegex = new RegExp(query, 'gi');
  return string.replace(queryRegex, '<span class="highlight">$&</span>');
});

/* eslint-disable no-new */
// noinspection ObjectAllocationIgnored
new __WEBPACK_IMPORTED_MODULE_4_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_13_router__["a" /* default */],
  components: {
    App: __WEBPACK_IMPORTED_MODULE_10_App__["a" /* default */],
    createPopper: __WEBPACK_IMPORTED_MODULE_0__popperjs_core__["a" /* createPopper */]
  },
  template: '<App/>',
  pinia: pinia
});
/* eslint-enable no-new */

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// src/conf.js

// https://api.afripods.com
// http://localhost:7777
var apiURL = "https://api.afripods.com";
var appURL = "https://afripods.africa";
var mediaURL = "https://media.afripods.com";
var imgURL = 'https://afripods-data.s3.amazonaws.com';
var apiPayoutURL = "https://payment-service-prod-dnh3ytvq4a-ew.a.run.app";
/* harmony default export */ __webpack_exports__["a"] = ({
  clarityProjectId: Object({"AFRIPODS_API_URL":"https://api.afripods.com","AFRIPODS_PAYMENT_API_URL":"https://payment-service-prod-dnh3ytvq4a-ew.a.run.app","AFRIPODS_APP_URL":"https://afripods.africa","AFRIPODS_MEDIA_URL":"https://media.afripods.com","NODE_ENV":"production","BUILD_ENV":"prod","GA4_ID":"G-CZDGWZ0K45","FEATURE_FILTER_PAYMENTS_USERS":"true","FEATURE_PAYMENTS_ONBOARDING":"true"}).VUE_APP_CLARITY_PROJECT_ID || 'tmw6b0wjpo',
  url: {
    default: apiURL,
    app: appURL,
    media: mediaURL,
    networks: "".concat(apiURL, "/networks"),
    trendingNetworks: "".concat(apiURL, "/networks/explore"),
    stations: "".concat(apiURL, "/networks/stations"),
    podcasts: "".concat(apiURL, "/podcasts"),
    episodes: "".concat(apiURL, "/episodes"),
    episodes_harvested: "".concat(apiURL, "/harvested/search/episodes"),
    episodesByPodcast: "".concat(apiURL, "/episodes/findByPodcast"),
    ads: "".concat(apiURL, "/rolls"),
    categories: "".concat(apiURL, "/categories/all"),
    search: "".concat(apiURL, "/harvested/search"),
    login: "".concat(apiURL, "/auth"),
    login_as_user: "".concat(apiURL, "/auth/login_as_user"),
    password_recover: "".concat(apiURL, "/users/recover_password"),
    password_reset: "".concat(apiURL, "/users/reset_password"),
    user: "".concat(apiURL, "/user"),
    podcast_import_preview: "".concat(apiURL, "/import/podcast"),
    podcast_import: "".concat(apiURL, "/import/podcast"),
    listener_users: "".concat(apiURL, "/listener/users"),
    listener_dashboard: "".concat(apiURL, "/listener/dashboard"),
    podcaster_networks: "".concat(apiURL, "/podcaster/networks"),
    podcaster_stations: "".concat(apiURL, "/podcaster/networks/stations"),
    podcaster_podcasts: "".concat(apiURL, "/podcaster/podcasts"),
    podcaster_episodes: "".concat(apiURL, "/podcaster/episodes"),
    podcaster_users: "".concat(apiURL, "/podcaster/users"),
    podcaster_stats: "".concat(apiURL, "/podcaster/podcasts"),
    podcaster_recordings: "".concat(apiURL, "/podcaster/recordings"),
    podcaster_schedules: "".concat(apiURL, "/podcaster/schedules"),
    podcaster_streams: "".concat(apiURL, "/podcaster/stations"),
    advertiser_ads: "".concat(apiURL, "/advertiser/ads"),
    advertiser_scheduled_ads: "".concat(apiURL, "/advertiser/scheduledAds"),
    advertiser_users: "".concat(apiURL, "/advertiser/users"),
    admin_categories: "".concat(apiURL, "/admin/categories"),
    admin_podcasts: "".concat(apiURL, "/admin/podcasts"),
    admin_featured: "".concat(apiURL, "/admin/featured"),
    admin_highlighted: "".concat(apiURL, "/admin/podcasts/highlighted"),
    admin_episodes: "".concat(apiURL, "/admin/episodes"),
    admin_positions: "".concat(apiURL, "/admin/positions"),
    admin_users: "".concat(apiURL, "/admin/users"),
    admin_jobs: "".concat(apiURL, "/jobs"),
    admin_ads: "".concat(apiURL, "/admin/ads"),
    admin_schedule_ads: "".concat(apiURL, "/admin/scheduledAds"),
    admin_notifications: "".concat(apiURL, "/admin/notifications"),
    admin_stats_overview: "".concat(apiURL, "/admin/stats/overview"),
    admin_networks: "".concat(apiURL, "/admin/networks"),
    admin_stations: "".concat(apiURL, "/admin/networks/stations"),
    raw_stats_csv: "".concat(apiURL, "/admin/stats/raw_csv"),
    stats_csv: "".concat(apiURL, "/admin/stats/stats_csv"),
    stats_approvals: "".concat(apiURL, "/stats/approvals"),
    stats_categories: "".concat(apiURL, "/stats/categories"),
    stats_episodes: "".concat(apiURL, "/stats/episodes"),
    stats_podcasts: "".concat(apiURL, "/stats/podcasts"),
    stats_users: "".concat(apiURL, "/stats/users"),
    languages: "".concat(apiURL, "/languages"),
    locations: "".concat(apiURL, "/locations"),
    jobs: "".concat(apiURL, "/jobs"),
    africanLocations: "".concat(apiURL, "/locations/countries/african"),
    feed: "".concat(apiURL, "/feed"),
    storeToken: "".concat(apiURL, "/google/storeToken"),
    refreshToken: "".concat(apiURL, "/google/refreshToken"),
    authUrl: "".concat(apiURL, "/google/authUrl"),
    fetchRSS: "".concat(apiURL, "/import/podcast?rss="),
    ghostPages: "".concat(apiURL, "/cms/pages"),
    ghostPage: "".concat(apiURL, "/cms/pages/slug"),
    ghostPosts: "".concat(apiURL, "/cms/posts"),
    ghostFeaturedPosts: "".concat(apiURL, "/cms/posts?filter=featured:true&limit=all"),
    ghostPost: "".concat(apiURL, "/cms/posts/slug"),
    ghostTags: "".concat(apiURL, "/cms/tags"),
    ghostSettings: "".concat(apiURL, "/cms/settings"),
    paymentRevenue: "".concat(apiPayoutURL, "/revenue"),
    paymentCountries: "".concat(apiPayoutURL, "/countries"),
    paymentPayout: "".concat(apiPayoutURL, "/payout"),
    paymentBanks: "".concat(apiPayoutURL, "/banks")
  },
  upload: {
    image: "".concat(apiURL, "/creator_s3_image_upload"),
    audio: "".concat(apiURL, "/s3_audio_upload"),
    itunes: "".concat(apiURL, "/s3_itunes_image_upload")
  },
  image: {
    user: {
      thumb: "".concat(imgURL, "/author/main_image/thumbnail/"),
      main: "".concat(imgURL, "/author/main_image/"),
      cover: "".concat(imgURL, "/author/cover_image/")
    },
    network: {
      main: "".concat(imgURL, "/upload/network/main_image/"),
      cover: "".concat(imgURL, "/upload/network/cover_image/")
    },
    station: {
      main: "".concat(imgURL, "/upload/station/main_image/"),
      cover: "".concat(imgURL, "/upload/station/cover_image/")
    },
    podcast: {
      thumb: "".concat(imgURL, "/podcast/main_image/thumbnail/"),
      main: "".concat(imgURL, "/podcast/main_image/"),
      cover: "".concat(imgURL, "/podcast/cover_image/")
    },
    episode: {
      thumb: "".concat(imgURL, "/episode/main_image/thumbnail/"),
      main: "".concat(imgURL, "/episode/main_image/")
    },
    category: {
      thumb: "".concat(imgURL, "/category/main_image/thumbnail/"),
      main: "".concat(imgURL, "/category/main_image/")
    },
    ad: {
      thumb: "".concat(imgURL, "/ad/main_image/thumbnail/"),
      main: "".concat(imgURL, "/ad/main_image/")
    }
  }
});

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildVueDompurifyHTMLDirective */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return y; });
/* unused harmony export vueDompurifyHTMLPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dompurify__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_demi__ = __webpack_require__(499);


function p(o, i) {
  var _o$hooks;
  var n = (_o$hooks = o.hooks) !== null && _o$hooks !== void 0 ? _o$hooks : {};
  var t;
  for (t in n) {
    var e = n[t];
    e !== void 0 && i.addHook(t, e);
  }
}
function c() {
  return __WEBPACK_IMPORTED_MODULE_0_dompurify___default()();
}
function v() {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : c;
  var n = i();
  p(o, n);
  var t = function t(e, r) {
    var _o$default;
    var u = r.value;
    if (r.oldValue === u) return;
    var a = "".concat(u),
      s = r.arg,
      d = o.namedConfigurations,
      f = (_o$default = o.default) !== null && _o$default !== void 0 ? _o$default : {};
    if (d && s !== void 0) {
      var _d$s;
      e.innerHTML = n.sanitize(a, (_d$s = d[s]) !== null && _d$s !== void 0 ? _d$s : f);
      return;
    }
    e.innerHTML = n.sanitize(a, f);
  };
  return __WEBPACK_IMPORTED_MODULE_1_vue_demi__["isVue3"] ? {
    mounted: t,
    updated: t
  } : {
    inserted: t,
    update: t,
    unbind: function unbind(e) {
      e.innerHTML = "";
    }
  };
}
var y = {
  install: function install(o) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : c;
    o.directive("dompurify-html", v(i, n));
  }
};


/***/ }),

/***/ 645:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_03b0f893_scoped_true___ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue_vue_type_style_index_0_id_03b0f893_prod_lang_scss_scoped_true___ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue_vue_type_style_index_1_id_03b0f893_prod_lang_scss___ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_03b0f893_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_03b0f893_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "03b0f893",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_03b0f893_scoped_true___ = __webpack_require__(648);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_03b0f893_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_03b0f893_scoped_true___["b"]; });


/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: (_vm.isIframePlayer || _vm.isEmbedPlayer) && 'appDarkBackground',
    attrs: {
      "id": "app"
    }
  }, [_c('notifications', {
    attrs: {
      "duration": 5000,
      "classes": "custom-notification"
    }
  }), _vm._v(" "), _vm.isIframePlayer || _vm.isEmbedPlayer ? [_c('RouterView')] : [_vm.userLoggedIn ? [_vm.user.type === 'admin' ? _c('nav', {
    staticClass: "navbar navbar-default navbar-admin"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('RouterLink', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar-collapse-admin"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm.user.type === 'admin' ? [_c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/admin/podcasts'
      }
    }
  }, [_c('a', [_vm._v("Content")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/admin/notifications'
      }
    }
  }, [_c('a', [_vm._v("Notifications")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/admin/stats'
      }
    }
  }, [_c('a', [_vm._v("Statistics")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/admin/career'
      }
    }
  }, [_c('a', [_vm._v("Career")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/admin/users'
      }
    }
  }, [_c('a', [_vm._v("Users")])]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-mobile-item"
  }), _vm._v(" "), _c('RouterLink', {
    staticClass: "navbar-mobile-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/admin/my_account'
      }
    }
  }, [_c('a', [_vm._v("My Account")])]), _vm._v(" "), _c('li', {
    staticClass: "navbar-mobile-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logOut.apply(null, arguments);
      }
    }
  }, [_vm._v("Log out")])])] : _vm.user.type === 'advertiser' ? [_c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/advertiser/dashboard'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Dashboard")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/advertiser/ads'
      }
    }
  }, [_c('a', [_vm._v("Ads")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/advertiser/stats'
      }
    }
  }, [_c('a', [_vm._v("Statistics")])]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-mobile-item"
  }), _vm._v(" "), _c('RouterLink', {
    staticClass: "navbar-mobile-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/advertiser/my_account'
      }
    }
  }, [_c('a', [_vm._v("My Account")])]), _vm._v(" "), _c('li', {
    staticClass: "navbar-mobile-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logOut.apply(null, arguments);
      }
    }
  }, [_vm._v("Log out")])])] : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown loggedin-user-dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "profile-image bg bg-cover",
    style: {
      backgroundImage: "url(".concat(_vm.user.image, ")")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.name)), _c('span', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm.user.type === 'admin' ? [_c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/admin/my_account'
      }
    }
  }, [_c('a', [_vm._v("My Account")])])] : _vm.user.type === 'podcaster' ? [_c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/podcaster/my_account'
      }
    }
  }, [_c('a', [_vm._v("My Account")])])] : _vm._e(), _vm._v(" "), _vm.user.type === 'advertiser' ? [_c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/advertiser/my_account'
      }
    }
  }, [_c('a', [_vm._v("My Account")])])] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logOut.apply(null, arguments);
      }
    }
  }, [_vm._v("Log out")])])], 2)])], 2)])])]) : [_c('div', {
    staticClass: "searchbar"
  }, [_c('div', {
    staticClass: "search-field"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('form', [_vm.showSpinner ? _c('span', {
    staticClass: "search-spinner-container"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin afripods-spinner"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "id": "search-input",
      "type": "text",
      "placeholder": "Search...",
      "autocomplete": "off"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "search-btn search-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeSearchBar.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row gutter-40"
  }, [_vm.searchResultsNetworks.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Networks")]), _vm._v(" "), _vm._l(_vm.searchResultsNetworks, function (network, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Network',
          params: {
            slug: network.slug || network.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(network.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(network.name))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _vm.searchResultsStations.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Stations")]), _vm._v(" "), _vm._l(_vm.searchResultsStations, function (station, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Station',
          params: {
            slug: station.slug || station.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(station.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(station.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption-title__lead"
    }, [_vm._v(_vm._s(station.ownerName))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _vm.searchResultsPodcasts.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Podcasts")]), _vm._v(" "), _vm._l(_vm.searchResultsPodcasts, function (podcast, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Podcast',
          params: {
            slug: podcast.slug || podcast.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(podcast.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(podcast.title))]), _vm._v(" "), _c('span', {
      staticClass: "caption-title__lead"
    }, [_vm._v(_vm._s(podcast.author))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _vm.searchResultsEpisodes.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Episodes")]), _vm._v(" "), _vm._l(_vm.searchResultsEpisodes, function (episode, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Episode',
          params: {
            episodeId: episode.id,
            seoURL: _vm.seoURL(episode.title)
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(episode.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(episode.title))]), _vm._v(" "), _c('span', {
      staticClass: "caption-title__lead"
    }, [_vm._v(_vm._s(episode.author))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.noSearchResults,
      expression: "noSearchResults"
    }],
    staticClass: "col-sm-12 no-results"
  }, [_vm._v("\n                  No such results found for your search query\n                ")])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default navbar-listener"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(1), _vm._v(" "), _c('RouterLink', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar-collapse-listener"
    }
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-left"
  }, [_c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/listen'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Listen")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/become_advertiser'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Advertiser")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/creator'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Creator")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/b2p'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Broadcast to Podcast")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/blog'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Blog")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/about'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("About us")])]), _vm._v(" "), _vm.user.hasPodcast ? [_c('li', {
    staticClass: "menu-item-podcaster dropdown"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('RouterLink', {
    staticClass: "desktop-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/podcaster/dashboard'
      }
    }
  }, [_c('a', [_vm._v("Dashboard")])]), _vm._v(" "), _c('RouterLink', {
    staticClass: "desktop-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/podcaster/podcasts/episodes'
      }
    }
  }, [_c('a', [_vm._v("Content")])]), _vm._v(" "), _c('RouterLink', {
    staticClass: "desktop-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/podcaster/stats'
      }
    }
  }, [_c('a', [_vm._v("Statistics")])]), _vm._v(" "), _vm.canViewPayments ? _c('RouterLink', {
    staticClass: "desktop-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/podcaster/payments'
      }
    }
  }, [_c('a', [_vm._v("Payout dashboard")])]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "navbar-mobile-item orange"
  }), _vm._v(" "), !_vm.user.hasPodcast ? _c('RouterLink', {
    staticClass: "navbar-mobile-item mobile-item small orange",
    attrs: {
      "tag": "li",
      "to": {
        path: '/become_podcaster'
      }
    }
  }, [_c('a', [_vm._v("Become a podcaster")])]) : _c('RouterLink', {
    staticClass: "navbar-mobile-item mobile-item small",
    attrs: {
      "tag": "li",
      "to": {
        path: '/podcaster/my_account'
      }
    }
  }, [_c('a', [_vm._v("My Account")])]), _vm._v(" "), _c('RouterLink', {
    staticClass: "navbar-mobile-item mobile-item small",
    attrs: {
      "tag": "li",
      "to": {
        path: '/listener/shows'
      }
    }
  }, [_c('a', [_vm._v("Shows")])]), _vm._v(" "), _c('RouterLink', {
    staticClass: "navbar-mobile-item mobile-item small",
    attrs: {
      "tag": "li",
      "to": {
        path: '/listener/saved'
      }
    }
  }, [_c('a', [_vm._v("Saved")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', {
    staticClass: "navbar-mobile-item mobile-item small"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logOut.apply(null, arguments);
      }
    }
  }, [_vm._v("Log out")])])], 2), _vm._v(" "), _c('ul', {
    staticClass: "listener-menu nav navbar-nav"
  }, [_c('div', {
    staticClass: "navbar-buttons-container"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('a', {
    staticClass: "search-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.openSearchBar.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "icon-search-v2"
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown loggedin-user-dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "profile-image bg bg-cover",
    style: {
      backgroundImage: "url(".concat(_vm.user.image, ")")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.name)), _c('span', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [!_vm.user.hasPodcast ? _c('li', {
    staticClass: "podcaster-register"
  }, [_c('RouterLink', {
    attrs: {
      "tag": "a",
      "to": {
        path: '/become_podcaster'
      }
    }
  }, [_vm._v("Become a podcaster")])], 1) : _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/podcaster/my_account'
      }
    }
  }, [_c('a', [_vm._v("My Account")])]), _vm._v(" "), _c('RouterLink', {
    staticClass: "desktop-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/listener/shows'
      }
    }
  }, [_c('a', [_vm._v("Shows")])]), _vm._v(" "), _c('RouterLink', {
    staticClass: "desktop-item",
    attrs: {
      "tag": "li",
      "to": {
        path: '/listener/saved'
      }
    }
  }, [_c('a', [_vm._v("Saved")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logOut.apply(null, arguments);
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5",
      "stroke": "#111111",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.333 14.1663L17.4997 9.99967L13.333 5.83301",
      "stroke": "#111111",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.5 10H7.5",
      "stroke": "#111111",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n                        Log out")])])], 1)])])])])])]] : [_c('div', {
    staticClass: "searchbar"
  }, [_c('div', {
    staticClass: "search-field"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('form', [_vm.showSpinner ? _c('span', {
    staticClass: "search-spinner-container"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin afripods-spinner"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "id": "search-input",
      "type": "text",
      "placeholder": "Search...",
      "autocomplete": "off"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "search-btn search-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeSearchBar.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row gutter-40"
  }, [_vm.searchResultsNetworks.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Networks")]), _vm._v(" "), _vm._l(_vm.searchResultsNetworks, function (network, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Network',
          params: {
            slug: network.slug || network.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(network.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(network.name))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _vm.searchResultsStations.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Stations")]), _vm._v(" "), _vm._l(_vm.searchResultsStations, function (station, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Station',
          params: {
            slug: station.slug || station.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(station.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(station.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption-title__lead"
    }, [_vm._v(_vm._s(station.ownerName))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _vm.searchResultsPodcasts.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Podcasts")]), _vm._v(" "), _vm._l(_vm.searchResultsPodcasts, function (podcast, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Podcast',
          params: {
            slug: podcast.slug || podcast.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(podcast.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(podcast.title))]), _vm._v(" "), _c('span', {
      staticClass: "caption-title__lead"
    }, [_vm._v(_vm._s(podcast.author))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _vm.searchResultsEpisodes.length > 0 ? _c('div', {
    staticClass: "search-results__category col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "heading heading__xs"
  }, [_vm._v("Episodes")]), _vm._v(" "), _vm._l(_vm.searchResultsEpisodes, function (episode, index) {
    return [index < 5 ? _c('RouterLink', {
      key: index,
      staticClass: "search-results__list",
      attrs: {
        "to": {
          name: 'Episode',
          params: {
            episodeId: episode.id,
            seoURL: _vm.seoURL(episode.title)
          }
        }
      }
    }, [_c('div', {
      staticClass: "image bg bg-cover",
      style: {
        backgroundImage: "url(".concat(episode.image, ")")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('strong', {
      staticClass: "caption-title"
    }, [_vm._v(_vm._s(episode.title))]), _vm._v(" "), _c('span', {
      staticClass: "caption-title__lead"
    }, [_vm._v(_vm._s(episode.author))])])]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.noSearchResults,
      expression: "noSearchResults"
    }],
    staticClass: "col-sm-12 no-results"
  }, [_vm._v("\n                No such results found for your search query\n              ")])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default navbar-general",
    class: {
      transparent: _vm.transparentNav
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(8), _vm._v(" "), _c('RouterLink', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar-collapse-general"
    }
  }, [_vm._m(9), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right navbar-custom-mod"
  }, [_c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/creator'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Create")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/listen'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Listen")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'GhostPage',
        params: {
          slug: 'monetization'
        }
      }
    }
  }, [_c('a', [_vm._v("Monetization")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/blog'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Blog")])]), _vm._v(" "), _c('RouterLink', {
    attrs: {
      "tag": "li",
      "to": {
        path: '/b2p'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Broadcast to Podcast")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-buttons-container"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('a', {
    staticClass: "search-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.openSearchBar.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "icon-search-v2"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-orange navbar-login-button desktop-item",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loginModal"
    },
    on: {
      "click": function click() {
        _vm.collapseAllNavbars();
        _vm.setLoginType('podcaster');
      }
    }
  }, [_vm._v("\n                  Log in / Register\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "mobile-item button-arrow btn btn-sm btn-blue mobile-login-btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loginModal"
    },
    on: {
      "click": function click() {
        _vm.collapseAllNavbars();
        _vm.setLoginType('listener');
      }
    }
  }, [_vm._v("Log in to your account "), _c('i', {
    staticClass: "button-arrow-icon icon-arrow"
  })]), _vm._v(" "), _c('RouterLink', {
    staticClass: "mobile-item button-arrow btn btn-sm mobile-register-btn",
    attrs: {
      "tag": "span",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse-general",
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Create an account "), _c('i', {
    staticClass: "button-arrow-icon icon-arrow"
  })])], 1)], 1)])])])], _vm._v(" "), _c('div', {
    attrs: {
      "id": "afripods-content"
    }
  }, [_c('SkeletonBody', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('RouterView')];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('FooterSection', {
    attrs: {
      "lt": _vm.lt,
      "user-logged-in": _vm.userLoggedIn
    },
    on: {
      "ltchanged": _vm.updatelt
    }
  }), _vm._v(" "), _c('AudioPlayer')], 1)]], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse-admin",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('i', {
    staticClass: "icon-menu"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse-listener",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('i', {
    staticClass: "icon-menu"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "navbar-exit-icon-mobile"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse-listener",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v("Podcaster dashboard"), _c('span', {
    staticClass: "caret"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "navbar-mobile-item mobile-item small",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#changePasswordModal"
    }
  }, [_c('a', [_vm._v("Change Password")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "navbar-mobile-item mobile-item small",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#changeEmailModal"
    }
  }, [_c('a', [_vm._v("Change Email")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": "#changePasswordModal"
    }
  }, [_vm._v("Change Password")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": "#changeEmailModal"
    }
  }, [_vm._v("Change Email")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse-general",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('i', {
    staticClass: "icon-menu"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "navbar-exit-icon-mobile"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse-general",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]);
}];


/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_conf__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_cookies__ = __webpack_require__(652);
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// src/auth/index.js





/* harmony default export */ __webpack_exports__["a"] = ({
  user: {
    authenticated: false
  },
  // Login request to the server
  login: function login(context, creds, redirect) {
    var self = this;
    $('.btn-submit').buttonLoader('start');

    // this.checkAuth(context,localStorage.getItem('afripodsLoggedInAccountType'))

    context.$http.post(__WEBPACK_IMPORTED_MODULE_1_conf__["a" /* default */].url.login, creds).then(function (response) {
      $('.btn-submit').buttonLoader('stop');
      var token = response.body.data.token;
      if (token !== '' && token !== null) {
        self.user.authenticated = true;
        localStorage.setItem('afripodsToken', token);
        Object(__WEBPACK_IMPORTED_MODULE_3_utils_cookies__["b" /* setCookie */])('legacyToken', token);
        self.getUserProfile(context, redirect);
      }
      document.getElementById('loginModal').remove();
      document.getElementsByClassName('modal-backdrop')[0].remove();
    }, function (error) {
      $('.btn-submit').buttonLoader('stop');
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
        title: 'Authentication Error',
        text: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.getErrorMessage(error),
        type: 'error'
      });
    });
  },
  loginAsUser: function loginAsUser(context, id, redirect) {
    var self = this;
    context.$http.get("".concat(__WEBPACK_IMPORTED_MODULE_1_conf__["a" /* default */].url.login_as_user, "/").concat(id), {
      params: {},
      headers: this.getAuthHeader()
    }).then(function (response) {
      var token = response.body.data.token;
      if (token !== '' && token !== null) {
        self.user.authenticated = true;
        localStorage.setItem('afripodsToken', token);
        Object(__WEBPACK_IMPORTED_MODULE_3_utils_cookies__["b" /* setCookie */])('legacyToken', token);
        self.getUserProfile(context, redirect);
      }
    }, function () {
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
        title: 'Login as user failed',
        type: 'error'
      });
    });
  },
  getUserProfile: function getUserProfile(context, redirect) {
    context.$http.get(__WEBPACK_IMPORTED_MODULE_1_conf__["a" /* default */].url.user, {
      params: {},
      headers: this.getAuthHeader()
    }).then(function (response) {
      localStorage.setItem('afripodsLoggedInUserId', response.body.data.id);
      localStorage.setItem('afripodsLoggedInUserName', response.body.data.name);
      localStorage.setItem('afripodsLoggedInUserImage', response.body.data.image);
      localStorage.setItem('afripodsLoggedInUserEmail', response.body.data.email);
      localStorage.setItem('afripodsLoggedInAccountType', response.body.data.type);
      localStorage.setItem('afripodsLoggedInUserHasPodcasts', response.body.data.has_podcast);
      var userInfo = _extends({}, (_objectDestructuringEmpty(response.body.data), response.body.data));
      Object(__WEBPACK_IMPORTED_MODULE_3_utils_cookies__["b" /* setCookie */])('userInfo', userInfo);
      __WEBPACK_IMPORTED_MODULE_2_utils__["c" /* event */].$emit('setLoggedInUserInfo');
      var redirectPath = '';
      var accountType = response.body.data.type;
      if (accountType === 'admin') {
        redirectPath = '/admin/podcasts';
      } else if (accountType === 'podcaster') {
        if (redirect === '' || !response.body.data.has_podcast) {
          redirectPath = '';
          __WEBPACK_IMPORTED_MODULE_2_utils__["c" /* event */].$emit('setLoggedInUserInfo');
        } else {
          redirectPath = '/podcaster/dashboard';
        }
      } else if (accountType === 'advertiser') {
        redirectPath = '/advertiser/dashboard';
      } else if (accountType === 'listener') {
        redirectPath = '/';
      }
      context.$router.push({
        path: redirectPath
      });
    }, function () {});
  },
  // Password retrieve request to the server
  retrievePassword: function retrievePassword(context, creds) {
    $('.btn-submit').buttonLoader('start');
    context.$http.post("".concat(__WEBPACK_IMPORTED_MODULE_1_conf__["a" /* default */].url.password_recover, "?email=").concat(creds.email)).then(function () {
      $('.btn-submit').buttonLoader('stop');
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
        title: 'Request Sent',
        text: 'Password reset request has been sent to your email address.',
        type: 'success'
      });
      $('#retrieve-password-form')[0].reset();
    }, function (error) {
      $('.btn-submit').buttonLoader('stop');
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
        title: 'Response Error',
        text: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.getErrorMessage(error),
        type: 'error'
      });
    });
  },
  // Reset password
  resetPassword: function resetPassword(context, creds) {
    $('.btn-submit').buttonLoader('start');
    context.$http.post("".concat(__WEBPACK_IMPORTED_MODULE_1_conf__["a" /* default */].url.password_reset, "?user_id=").concat(creds.user_id, "&recovery_key=").concat(creds.recovery_key, "&password=").concat(creds.password)).then(function () {
      $('.btn-submit').buttonLoader('stop');
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
        title: 'Password Changed',
        text: 'Your account password has been changed. You can now login to your account with your new chosen password',
        type: 'success'
      });
      document.getElementById('retrievePasswordModal').remove();
      document.getElementsByClassName('modal-backdrop')[0].remove();
      $('#password-reset-form')[0].reset();
    }, function (error) {
      $('.btn-submit').buttonLoader('stop');
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
        title: 'Response Error',
        text: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.getErrorMessage(error),
        type: 'error'
      });
    });
  },
  // Logout user
  logout: function logout() {
    this.user.authenticated = false;
    localStorage.removeItem('afripodsToken');
    localStorage.removeItem('afripodsLoggedInUserId');
    localStorage.removeItem('afripodsLoggedInUserName');
    localStorage.removeItem('afripodsLoggedInUserPodcasts');
    localStorage.removeItem('afripodsLoggedInUserImage');
    localStorage.removeItem('afripodsLoggedInUserEmail');
    localStorage.removeItem('afripodsLoggedInAccountType');
    localStorage.removeItem('userShows');
    localStorage.removeItem('userBookmarks');

    // Clear auth cookies used by new frontend
    Object(__WEBPACK_IMPORTED_MODULE_3_utils_cookies__["a" /* removeCookie */])('legacyToken');
    Object(__WEBPACK_IMPORTED_MODULE_3_utils_cookies__["a" /* removeCookie */])('userInfo');
    __WEBPACK_IMPORTED_MODULE_2_utils__["c" /* event */].$emit('logOutUser');
  },
  getLoggedInUserId: function getLoggedInUserId() {
    return localStorage.getItem('afripodsLoggedInUserId');
  },
  checkToken: function checkToken() {
    var token = localStorage.getItem('afripodsToken');
    var accountType = localStorage.getItem('afripodsLoggedInAccountType');
    return !!(token != null || accountType != null);
  },
  // Check user logged in
  checkAuth: function checkAuth(context, type) {
    var token = localStorage.getItem('afripodsToken');
    var accountType = localStorage.getItem('afripodsLoggedInAccountType');
    if (token !== '' && accountType !== type) {
      this.logout();
      context.$router.push({
        path: '/home'
      });
    } else {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_utils__["c" /* event */].$emit('setLoggedInUserInfo');
      }, 200);
    }
  },
  checkAuthentication: function checkAuthentication(type) {
    var token = localStorage.getItem('afripodsToken');
    var accountType = localStorage.getItem('afripodsLoggedInAccountType');
    return token && accountType === type;
  },
  // The object to be passed as a header for authenticated requests
  getAuthHeader: function getAuthHeader() {
    return {
      Authorization: "Bearer ".concat(localStorage.getItem('afripodsToken'))
    };
  }
});

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 263,
	"./af.js": 263,
	"./ar": 264,
	"./ar-dz": 265,
	"./ar-dz.js": 265,
	"./ar-kw": 266,
	"./ar-kw.js": 266,
	"./ar-ly": 267,
	"./ar-ly.js": 267,
	"./ar-ma": 268,
	"./ar-ma.js": 268,
	"./ar-sa": 269,
	"./ar-sa.js": 269,
	"./ar-tn": 270,
	"./ar-tn.js": 270,
	"./ar.js": 264,
	"./az": 271,
	"./az.js": 271,
	"./be": 272,
	"./be.js": 272,
	"./bg": 273,
	"./bg.js": 273,
	"./bm": 274,
	"./bm.js": 274,
	"./bn": 275,
	"./bn-bd": 276,
	"./bn-bd.js": 276,
	"./bn.js": 275,
	"./bo": 277,
	"./bo.js": 277,
	"./br": 278,
	"./br.js": 278,
	"./bs": 279,
	"./bs.js": 279,
	"./ca": 280,
	"./ca.js": 280,
	"./cs": 281,
	"./cs.js": 281,
	"./cv": 282,
	"./cv.js": 282,
	"./cy": 283,
	"./cy.js": 283,
	"./da": 284,
	"./da.js": 284,
	"./de": 285,
	"./de-at": 286,
	"./de-at.js": 286,
	"./de-ch": 287,
	"./de-ch.js": 287,
	"./de.js": 285,
	"./dv": 288,
	"./dv.js": 288,
	"./el": 289,
	"./el.js": 289,
	"./en-au": 290,
	"./en-au.js": 290,
	"./en-ca": 291,
	"./en-ca.js": 291,
	"./en-gb": 292,
	"./en-gb.js": 292,
	"./en-ie": 293,
	"./en-ie.js": 293,
	"./en-il": 294,
	"./en-il.js": 294,
	"./en-in": 295,
	"./en-in.js": 295,
	"./en-nz": 296,
	"./en-nz.js": 296,
	"./en-sg": 297,
	"./en-sg.js": 297,
	"./eo": 298,
	"./eo.js": 298,
	"./es": 299,
	"./es-do": 300,
	"./es-do.js": 300,
	"./es-mx": 301,
	"./es-mx.js": 301,
	"./es-us": 302,
	"./es-us.js": 302,
	"./es.js": 299,
	"./et": 303,
	"./et.js": 303,
	"./eu": 304,
	"./eu.js": 304,
	"./fa": 305,
	"./fa.js": 305,
	"./fi": 306,
	"./fi.js": 306,
	"./fil": 307,
	"./fil.js": 307,
	"./fo": 308,
	"./fo.js": 308,
	"./fr": 309,
	"./fr-ca": 310,
	"./fr-ca.js": 310,
	"./fr-ch": 311,
	"./fr-ch.js": 311,
	"./fr.js": 309,
	"./fy": 312,
	"./fy.js": 312,
	"./ga": 313,
	"./ga.js": 313,
	"./gd": 314,
	"./gd.js": 314,
	"./gl": 315,
	"./gl.js": 315,
	"./gom-deva": 316,
	"./gom-deva.js": 316,
	"./gom-latn": 317,
	"./gom-latn.js": 317,
	"./gu": 318,
	"./gu.js": 318,
	"./he": 319,
	"./he.js": 319,
	"./hi": 320,
	"./hi.js": 320,
	"./hr": 321,
	"./hr.js": 321,
	"./hu": 322,
	"./hu.js": 322,
	"./hy-am": 323,
	"./hy-am.js": 323,
	"./id": 324,
	"./id.js": 324,
	"./is": 325,
	"./is.js": 325,
	"./it": 326,
	"./it-ch": 327,
	"./it-ch.js": 327,
	"./it.js": 326,
	"./ja": 328,
	"./ja.js": 328,
	"./jv": 329,
	"./jv.js": 329,
	"./ka": 330,
	"./ka.js": 330,
	"./kk": 331,
	"./kk.js": 331,
	"./km": 332,
	"./km.js": 332,
	"./kn": 333,
	"./kn.js": 333,
	"./ko": 334,
	"./ko.js": 334,
	"./ku": 335,
	"./ku.js": 335,
	"./ky": 336,
	"./ky.js": 336,
	"./lb": 337,
	"./lb.js": 337,
	"./lo": 338,
	"./lo.js": 338,
	"./lt": 339,
	"./lt.js": 339,
	"./lv": 340,
	"./lv.js": 340,
	"./me": 341,
	"./me.js": 341,
	"./mi": 342,
	"./mi.js": 342,
	"./mk": 343,
	"./mk.js": 343,
	"./ml": 344,
	"./ml.js": 344,
	"./mn": 345,
	"./mn.js": 345,
	"./mr": 346,
	"./mr.js": 346,
	"./ms": 347,
	"./ms-my": 348,
	"./ms-my.js": 348,
	"./ms.js": 347,
	"./mt": 349,
	"./mt.js": 349,
	"./my": 350,
	"./my.js": 350,
	"./nb": 351,
	"./nb.js": 351,
	"./ne": 352,
	"./ne.js": 352,
	"./nl": 353,
	"./nl-be": 354,
	"./nl-be.js": 354,
	"./nl.js": 353,
	"./nn": 355,
	"./nn.js": 355,
	"./oc-lnc": 356,
	"./oc-lnc.js": 356,
	"./pa-in": 357,
	"./pa-in.js": 357,
	"./pl": 358,
	"./pl.js": 358,
	"./pt": 359,
	"./pt-br": 360,
	"./pt-br.js": 360,
	"./pt.js": 359,
	"./ro": 361,
	"./ro.js": 361,
	"./ru": 362,
	"./ru.js": 362,
	"./sd": 363,
	"./sd.js": 363,
	"./se": 364,
	"./se.js": 364,
	"./si": 365,
	"./si.js": 365,
	"./sk": 366,
	"./sk.js": 366,
	"./sl": 367,
	"./sl.js": 367,
	"./sq": 368,
	"./sq.js": 368,
	"./sr": 369,
	"./sr-cyrl": 370,
	"./sr-cyrl.js": 370,
	"./sr.js": 369,
	"./ss": 371,
	"./ss.js": 371,
	"./sv": 372,
	"./sv.js": 372,
	"./sw": 373,
	"./sw.js": 373,
	"./ta": 374,
	"./ta.js": 374,
	"./te": 375,
	"./te.js": 375,
	"./tet": 376,
	"./tet.js": 376,
	"./tg": 377,
	"./tg.js": 377,
	"./th": 378,
	"./th.js": 378,
	"./tk": 379,
	"./tk.js": 379,
	"./tl-ph": 380,
	"./tl-ph.js": 380,
	"./tlh": 381,
	"./tlh.js": 381,
	"./tr": 382,
	"./tr.js": 382,
	"./tzl": 383,
	"./tzl.js": 383,
	"./tzm": 384,
	"./tzm-latn": 385,
	"./tzm-latn.js": 385,
	"./tzm.js": 384,
	"./ug-cn": 386,
	"./ug-cn.js": 386,
	"./uk": 387,
	"./uk.js": 387,
	"./ur": 388,
	"./ur.js": 388,
	"./uz": 389,
	"./uz-latn": 390,
	"./uz-latn.js": 390,
	"./uz.js": 389,
	"./vi": 391,
	"./vi.js": 391,
	"./x-pseudo": 392,
	"./x-pseudo.js": 392,
	"./yo": 393,
	"./yo.js": 393,
	"./zh-cn": 394,
	"./zh-cn.js": 394,
	"./zh-hk": 395,
	"./zh-hk.js": 395,
	"./zh-mo": 396,
	"./zh-mo.js": 396,
	"./zh-tw": 397,
	"./zh-tw.js": 397
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 651;

/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCookie; });
/* unused harmony export getCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeCookie; });
/* unused harmony export isCookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

var setCookie = function setCookie(token, value) {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.$cookies.set(token, value);
};
var getCookie = function getCookie(token) {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.$cookies.get(token);
};
var removeCookie = function removeCookie(token) {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.$cookies.remove(token);
};
var isCookie = function isCookie(token) {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.$cookies.isKey(token);
};


/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_template_id_5fdcabd7_scoped_true___ = __webpack_require__(654);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_template_id_5fdcabd7_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_template_id_5fdcabd7_scoped_true___["b"]; });


/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.audioPlayer.showAudioPlayer ? _c('div', {
    staticClass: "audio-player",
    attrs: {
      "id": "audio-player"
    }
  }, [_vm.view == 'desktop' ? _c('div', {
    staticClass: "audio-player__container"
  }, [_c('div', {
    staticClass: "track-info"
  }, [_c('div', {
    staticClass: "track-info-text"
  }, [_c('a', {
    staticClass: "track-show",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goToPodcast.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.audioPlayer.author))]), _vm._v(" "), _c('div', {
    staticClass: "track-name truncate"
  }, [_vm._v("Episode " + _vm._s(_vm.audioPlayer.episodeIndex) + ". " + _vm._s(_vm.audioPlayer.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "audio-play-controls"
  }, [_c('a', {
    staticClass: "track-control-prev button-animation",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.buttonClick('controlPrev');
      }
    }
  }, [_c('i', {
    staticClass: "icon-prev"
  })]), _vm._v(" "), _vm.currentPlayObject.playState === 'paused' ? _c('a', {
    staticClass: "track-control-play",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        return _vm.buttonClick('controlPlayPause', 'playing');
      }
    }
  }, [_c('i', {
    staticClass: "icon-play"
  })]) : _vm._e(), _vm._v(" "), _vm.currentPlayObject.playState !== 'paused' ? _c('a', {
    staticClass: "track-control-play",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        return _vm.buttonClick('controlPlayPause', 'paused');
      }
    }
  }, [_c('i', {
    staticClass: "icon-pause"
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "track-control-next button-animation",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.buttonClick('controlNext');
      }
    }
  }, [_c('i', {
    staticClass: "icon-prev"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "audio-player-progress"
  }, [_c('vue-slider', {
    attrs: {
      "tooltip": "none",
      "max": _vm.audioPlayer.durationInSeconds,
      "lazy": true
    },
    on: {
      "change": _vm.seekSelect,
      "drag-start": function dragStart($event) {
        return _vm.rangeSliderEvent('start');
      },
      "drag-end": function dragEnd($event) {
        return _vm.rangeSliderEvent('stop', $event);
      }
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.rangeSliderEvent('click');
      }
    },
    model: {
      value: _vm.rangeSlider.current,
      callback: function callback($$v) {
        _vm.$set(_vm.rangeSlider, "current", $$v);
      },
      expression: "rangeSlider.current"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "track-time"
  }, [_c('span', {
    staticClass: "audio-current-time"
  }, [_vm._v("\n            " + _vm._s(_vm.audioPlayer.playerEpisodeCurrentTime) + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "audio-total-time"
  }, [_vm._v("\n            " + _vm._s(_vm.audioPlayer.playerEpisodeDuration) + "\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "volume-slider"
  }, [_c('div', {
    staticClass: "dropup afripods-dropup"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle sm-button",
    attrs: {
      "id": "dropdownMenu3",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 5L6 9H2V15H6L11 19V5Z",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.07 4.92993C20.9447 6.80521 21.9978 9.34829 21.9978 11.9999C21.9978 14.6516 20.9447 17.1947 19.07 19.0699M15.54 8.45993C16.4773 9.39757 17.0039 10.6691 17.0039 11.9949C17.0039 13.3208 16.4773 14.5923 15.54 15.5299",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu afripods-dropup-menu volume-slider-range",
    attrs: {
      "aria-labelledby": "dropdownMenu3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.volume,
      expression: "audioPlayer.volume"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.audioPlayer.volume
    },
    on: {
      "change": _vm.volumeControl,
      "__r": function __r($event) {
        return _vm.$set(_vm.audioPlayer, "volume", $event.target.value);
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dropup afripods-dropup"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle sm-button",
    attrs: {
      "id": "dropdownMenu4",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.player.playbackRate) + "x\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu afripods-dropup-menu speed-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu4"
    }
  }, [_c('div', {
    staticClass: "speed-slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speed,
      expression: "audioPlayer.speed"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "min": "1",
      "max": "9",
      "step": "1",
      "value": "3"
    },
    domProps: {
      "value": _vm.audioPlayer.speed
    },
    on: {
      "change": _vm.speedControl,
      "__r": function __r($event) {
        return _vm.$set(_vm.audioPlayer, "speed", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('9');
      }
    }
  }, [_vm._v("3x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('8');
      }
    }
  }, [_vm._v("2.5x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('7');
      }
    }
  }, [_vm._v("2x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('6');
      }
    }
  }, [_vm._v("1.75x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('5');
      }
    }
  }, [_vm._v("1.5x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('4');
      }
    }
  }, [_vm._v("1.25x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('3');
      }
    }
  }, [_vm._v("1x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('2');
      }
    }
  }, [_vm._v("0.75x")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.speedControlToggle('1');
      }
    }
  }, [_vm._v("0.5x")])])])])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "like-btn"
    },
    on: {
      "click": function click($event) {
        return _vm.handleSave();
      }
    }
  }, [!_vm.episodeSaved ? _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z",
      "stroke": "#FDD366",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]) : _c('svg', {
    attrs: {
      "width": "16",
      "height": "20",
      "viewBox": "0 0 16 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 19L8 14L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H13C13.5304 1 14.0391 1.21071 14.4142 1.58579C14.7893 1.96086 15 2.46957 15 3V19Z",
      "fill": "#FDD366",
      "stroke": "#FDD366",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dropup afripods-dropup"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu afripods-dropup-menu social-share-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu2"
    }
  }, [_c('div', [_c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "email"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "16",
            "fill": "white"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M10 10H22C22.825 10 23.5 10.675 23.5 11.5V20.5C23.5 21.325 22.825 22 22 22H10C9.175 22 8.5 21.325 8.5 20.5V11.5C8.5 10.675 9.175 10 10 10Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M23.5 11.5L16 16.75L8.5 11.5",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })]), _vm._v("\n                    Email\n                  ")]);
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item",
    on: {
      "click": _vm.copyUrl
    }
  }, [_c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "16",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.5 16.75C14.8221 17.1806 15.233 17.5369 15.7049 17.7947C16.1768 18.0525 16.6986 18.2058 17.235 18.2443C17.7713 18.2827 18.3097 18.2053 18.8135 18.0173C19.3173 17.8294 19.7748 17.5353 20.155 17.155L22.405 14.905C23.0881 14.1977 23.4661 13.2505 23.4575 12.2672C23.449 11.284 23.0546 10.3435 22.3593 9.64818C21.664 8.9529 20.7235 8.55852 19.7403 8.54998C18.757 8.54143 17.8098 8.91941 17.1025 9.6025L15.8125 10.885",
      "stroke": "#1D1F24",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.5 15.25C17.1779 14.8194 16.767 14.4631 16.2951 14.2053C15.8232 13.9475 15.3014 13.7941 14.765 13.7557C14.2287 13.7173 13.6903 13.7947 13.1865 13.9826C12.6827 14.1706 12.2252 14.4647 11.845 14.845L9.59503 17.095C8.91194 17.8022 8.53396 18.7495 8.5425 19.7327C8.55104 20.716 8.94543 21.6565 9.64071 22.3518C10.336 23.0471 11.2765 23.4415 12.2598 23.45C13.243 23.4586 14.1903 23.0806 14.8975 22.3975L16.18 21.115",
      "stroke": "#1D1F24",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n                Link\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "facebook"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "14",
            "fill": "#1D1F24"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            "d": "M20.155 10.656L18.649 10.657C17.468 10.657 17.239 11.218 17.239 12.041V13.857H20.056L19.689 16.702H17.239V24H14.302V16.702H11.846V13.857H14.302V11.76C14.302 9.325 15.789 8 17.96 8C19 8 19.894 8.077 20.155 8.112V10.656ZM16 0C7.164 0 0 7.163 0 16C0 24.836 7.164 32 16 32C24.837 32 32 24.836 32 16C32 7.163 24.837 0 16 0Z",
            "fill": "white"
          }
        })]), _vm._v("\n                    Facebook\n                  ")]);
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "linkedin"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "16",
            "fill": "white"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M19 13C20.1935 13 21.3381 13.4741 22.182 14.318C23.0259 15.1619 23.5 16.3065 23.5 17.5V22.75H20.5V17.5C20.5 17.1022 20.342 16.7206 20.0607 16.4393C19.7794 16.158 19.3978 16 19 16C18.6022 16 18.2206 16.158 17.9393 16.4393C17.658 16.7206 17.5 17.1022 17.5 17.5V22.75H14.5V17.5C14.5 16.3065 14.9741 15.1619 15.818 14.318C16.6619 13.4741 17.8065 13 19 13V13Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M11.5 13.75H8.5V22.75H11.5V13.75Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })]), _vm._v("\n                    LinkedIn\n                  ")]);
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "twitter"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "16",
            "fill": "white"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M25.25 9.25C24.5318 9.75661 23.7366 10.1441 22.895 10.3975C22.4433 9.87814 21.843 9.51002 21.1753 9.34295C20.5076 9.17587 19.8046 9.2179 19.1616 9.46334C18.5185 9.70879 17.9663 10.1458 17.5797 10.7153C17.1931 11.2848 16.9908 11.9593 17 12.6475V13.3975C15.682 13.4317 14.376 13.1394 13.1983 12.5466C12.0206 11.9538 11.0077 11.079 10.25 10C10.25 10 7.25 16.75 14 19.75C12.4554 20.7985 10.6154 21.3242 8.75 21.25C15.5 25 23.75 21.25 23.75 12.625C23.7493 12.4161 23.7292 12.2077 23.69 12.0025C24.4555 11.2476 24.9956 10.2945 25.25 9.25Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })]), _vm._v("\n                    Twitter\n                  ")]);
      },
      staticRenderFns: []
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "dropup afripods-dropup"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle sm-button btn-close",
    attrs: {
      "id": "dropdownMenu6",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n            ⋮\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu afripods-dropup-menu social-share-menu close-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu6"
    }
  }, [_c('a', {
    attrs: {
      "id": "player-close",
      "href": "#"
    },
    on: {
      "click": _vm.closePlayer
    }
  }, [_vm._v("Close player")])])])])]) : _vm._e(), _vm._v(" "), _vm.view == 'mobile' ? _c('div', {
    staticClass: "audio-player__container audio-player-mobile"
  }, [_vm.viewSize !== 'fullscreen' ? _c('div', {
    staticClass: "mobile-audioplayer-fullscreen",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.mediaPlayerFullscreen.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.viewSize == 'fullscreen' ? _c('div', {
    staticClass: "mobile-player-close"
  }, [_c('span', {
    staticClass: "chevron",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.minimizeFullscreen.apply(null, arguments);
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "8",
      "viewBox": "0 0 14 8",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 1L7 7L13 1",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "media-player-close",
    on: {
      "click": _vm.closePlayer
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 6L6 18",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6 6L18 18",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _vm.viewSize == 'fullscreen' ? _c('div', {
    staticClass: "track-image bg bg-cover",
    style: {
      backgroundImage: 'url(' + _vm.audioPlayer.image + ')'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "track-info",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.trackInfoClick.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "track-info-text"
  }, [_c('span', {
    staticClass: "track-show",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goToPodcast.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.audioPlayer.author))]), _vm._v(" "), _c('div', {
    staticClass: "track-name truncate"
  }, [_vm._v("Episode " + _vm._s(_vm.audioPlayer.episodeIndex) + ". " + _vm._s(_vm.audioPlayer.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "audio-player-progress"
  }, [_c('vue-slider', {
    attrs: {
      "tooltip": "none",
      "max": _vm.audioPlayer.durationInSeconds,
      "lazy": true
    },
    on: {
      "change": _vm.seekSelect,
      "drag-start": function dragStart($event) {
        return _vm.rangeSliderEvent('start');
      },
      "drag-end": function dragEnd($event) {
        return _vm.rangeSliderEvent('stop');
      }
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.rangeSliderEvent('click');
      }
    },
    model: {
      value: _vm.rangeSlider.current,
      callback: function callback($$v) {
        _vm.$set(_vm.rangeSlider, "current", $$v);
      },
      expression: "rangeSlider.current"
    }
  }), _vm._v(" "), _vm.viewSize == 'fullscreen' ? _c('span', {
    staticClass: "track-time"
  }, [_c('span', {
    staticClass: "audio-current-time"
  }, [_vm._v("\n            " + _vm._s(_vm.audioPlayer.playerEpisodeCurrentTime) + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "audio-total-time"
  }, [_vm._v("\n            " + _vm._s(_vm.audioPlayer.playerEpisodeDuration) + "\n          ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "audio-play-controls"
  }, [_c('a', {
    staticClass: "track-control-prev button-animation",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.buttonClick('controlPrev');
      }
    }
  }, [_c('i', {
    staticClass: "icon-prev"
  })]), _vm._v(" "), _vm.currentPlayObject.playState === 'paused' ? _c('a', {
    staticClass: "track-control-play",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        return _vm.buttonClick('controlPlayPause', 'playing');
      }
    }
  }, [_c('i', {
    staticClass: "icon-play"
  })]) : _vm._e(), _vm._v(" "), _vm.currentPlayObject.playState !== 'paused' ? _c('a', {
    staticClass: "track-control-play",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        return _vm.buttonClick('controlPlayPause', 'paused');
      }
    }
  }, [_c('i', {
    staticClass: "icon-pause"
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "track-control-next button-animation",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.buttonClick('controlNext');
      }
    }
  }, [_c('i', {
    staticClass: "icon-prev"
  })])]), _vm._v(" "), _vm.viewSize == 'fullscreen' ? _c('div', {
    staticClass: "volume-slider-mobile"
  }, [_c('svg', {
    attrs: {
      "width": "8",
      "height": "12",
      "viewBox": "0 0 8 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.3335 1.3335L4.00016 4.00016H1.3335V8.00016H4.00016L7.3335 10.6668V1.3335Z",
      "stroke": "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.volume,
      expression: "audioPlayer.volume"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.audioPlayer.volume
    },
    on: {
      "change": _vm.volumeControl,
      "__r": function __r($event) {
        return _vm.$set(_vm.audioPlayer, "volume", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.3335 3.3335L4.00016 6.00016H1.3335V10.0002H4.00016L7.3335 12.6668V3.3335Z",
      "stroke": "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.7132 3.28662C13.963 4.53681 14.6651 6.23219 14.6651 7.99995C14.6651 9.76772 13.963 11.4631 12.7132 12.7133M10.3599 5.63995C10.9848 6.26505 11.3358 7.11274 11.3358 7.99662C11.3358 8.8805 10.9848 9.7282 10.3599 10.3533",
      "stroke": "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm.viewSize == 'fullscreen' ? _c('div', {
    staticClass: "speed-bookmark-share"
  }, [_c('div', {
    attrs: {
      "id": "speed-menu"
    }
  }, [_c('button', {
    staticClass: "menu-back",
    on: {
      "click": _vm.speedMenuClose
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 18L9 12L15 6",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "speed-menu-content"
  }, [_c('h3', {
    staticClass: "mobile-menu-headline"
  }, [_vm._v("Change speed")]), _vm._v(" "), _c('div', {
    staticClass: "speed-picker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "1")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "1");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("0.5x")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "2")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "2");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("0.75x")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "3")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "3");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("1x")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "4")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "4");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("1.25x")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "5")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "5");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("1.5x")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "6")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "6");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("1.75x")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "7"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "7")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "7");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("2x")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "8"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "8")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "8");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("2.5x")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.audioPlayer.speedRadio,
      expression: "audioPlayer.speedRadio"
    }],
    attrs: {
      "type": "radio",
      "name": "speedRadio",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.audioPlayer.speedRadio, "9")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.audioPlayer, "speedRadio", "9");
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("3x")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-orange speed-menu-save",
    on: {
      "click": function click($event) {
        _vm.speedControlToggle(_vm.audioPlayer.speedRadio);
        _vm.speedMenuClose();
      }
    }
  }, [_c('span', [_vm._v("Save")]), _vm._v(" "), _c('i', {
    staticClass: "button-arrow-icon icon-arrow"
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mobile-share-menu"
    }
  }, [_c('button', {
    staticClass: "menu-back",
    on: {
      "click": _vm.shareMenuClose
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 18L9 12L15 6",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "mobile-menu-headline"
  }, [_vm._v("Share")]), _vm._v(" "), _c('div', {
    staticClass: "shared-content"
  }, [_vm.viewSize == 'fullscreen' ? _c('div', {
    staticClass: "track-image bg bg-cover",
    style: {
      backgroundImage: 'url(' + _vm.audioPlayer.image + ')'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "track-info-text"
  }, [_c('div', {
    staticClass: "track-name truncate"
  }, [_vm._v("Episode " + _vm._s(_vm.audioPlayer.episodeIndex) + ". " + _vm._s(_vm.audioPlayer.title))]), _vm._v(" "), _c('span', {
    staticClass: "track-show"
  }, [_vm._v(_vm._s(_vm.audioPlayer.author))])])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "email"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "16",
            "fill": "white"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M10 10H22C22.825 10 23.5 10.675 23.5 11.5V20.5C23.5 21.325 22.825 22 22 22H10C9.175 22 8.5 21.325 8.5 20.5V11.5C8.5 10.675 9.175 10 10 10Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M23.5 11.5L16 16.75L8.5 11.5",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })]), _vm._v("\n                  Email "), _c('i', {
          staticClass: "button-arrow-icon icon-arrow"
        })]);
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item",
    on: {
      "click": _vm.copyUrl
    }
  }, [_c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "16",
      "cy": "16",
      "r": "16",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.5 16.75C14.8221 17.1806 15.233 17.5369 15.7049 17.7947C16.1768 18.0525 16.6986 18.2058 17.235 18.2443C17.7713 18.2827 18.3097 18.2053 18.8135 18.0173C19.3173 17.8294 19.7748 17.5353 20.155 17.155L22.405 14.905C23.0881 14.1977 23.4661 13.2505 23.4575 12.2672C23.449 11.284 23.0546 10.3435 22.3593 9.64818C21.664 8.9529 20.7235 8.55852 19.7403 8.54998C18.757 8.54143 17.8098 8.91941 17.1025 9.6025L15.8125 10.885",
      "stroke": "#1D1F24",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.5 15.25C17.1779 14.8194 16.767 14.4631 16.2951 14.2053C15.8232 13.9475 15.3014 13.7941 14.765 13.7557C14.2287 13.7173 13.6903 13.7947 13.1865 13.9826C12.6827 14.1706 12.2252 14.4647 11.845 14.845L9.59503 17.095C8.91194 17.8022 8.53396 18.7495 8.5425 19.7327C8.55104 20.716 8.94543 21.6565 9.64071 22.3518C10.336 23.0471 11.2765 23.4415 12.2598 23.45C13.243 23.4586 14.1903 23.0806 14.8975 22.3975L16.18 21.115",
      "stroke": "#1D1F24",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n              Link "), _c('i', {
    staticClass: "button-arrow-icon icon-arrow"
  })]), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "facebook"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "14",
            "fill": "#1D1F24"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            "d": "M20.155 10.656L18.649 10.657C17.468 10.657 17.239 11.218 17.239 12.041V13.857H20.056L19.689 16.702H17.239V24H14.302V16.702H11.846V13.857H14.302V11.76C14.302 9.325 15.789 8 17.96 8C19 8 19.894 8.077 20.155 8.112V10.656ZM16 0C7.164 0 0 7.163 0 16C0 24.836 7.164 32 16 32C24.837 32 32 24.836 32 16C32 7.163 24.837 0 16 0Z",
            "fill": "white"
          }
        })]), _vm._v("\n                  Facebook "), _c('i', {
          staticClass: "button-arrow-icon icon-arrow"
        })]);
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "linkedin"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "16",
            "fill": "white"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M19 13C20.1935 13 21.3381 13.4741 22.182 14.318C23.0259 15.1619 23.5 16.3065 23.5 17.5V22.75H20.5V17.5C20.5 17.1022 20.342 16.7206 20.0607 16.4393C19.7794 16.158 19.3978 16 19 16C18.6022 16 18.2206 16.158 17.9393 16.4393C17.658 16.7206 17.5 17.1022 17.5 17.5V22.75H14.5V17.5C14.5 16.3065 14.9741 15.1619 15.818 14.318C16.6619 13.4741 17.8065 13 19 13V13Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M11.5 13.75H8.5V22.75H11.5V13.75Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })]), _vm._v("\n                  LinkedIn "), _c('i', {
          staticClass: "button-arrow-icon icon-arrow"
        })]);
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "afripods-sm-item"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.socialShareLink
    },
    inlineTemplate: {
      render: function render() {
        var _vm = this,
          _c = _vm._self._c;
        return _c('network', {
          attrs: {
            "network": "twitter"
          }
        }, [_c('svg', {
          attrs: {
            "width": "32",
            "height": "32",
            "viewBox": "0 0 32 32",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('circle', {
          attrs: {
            "cx": "16",
            "cy": "16",
            "r": "16",
            "fill": "white"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M25.25 9.25C24.5318 9.75661 23.7366 10.1441 22.895 10.3975C22.4433 9.87814 21.843 9.51002 21.1753 9.34295C20.5076 9.17587 19.8046 9.2179 19.1616 9.46334C18.5185 9.70879 17.9663 10.1458 17.5797 10.7153C17.1931 11.2848 16.9908 11.9593 17 12.6475V13.3975C15.682 13.4317 14.376 13.1394 13.1983 12.5466C12.0206 11.9538 11.0077 11.079 10.25 10C10.25 10 7.25 16.75 14 19.75C12.4554 20.7985 10.6154 21.3242 8.75 21.25C15.5 25 23.75 21.25 23.75 12.625C23.7493 12.4161 23.7292 12.2077 23.69 12.0025C24.4555 11.2476 24.9956 10.2945 25.25 9.25Z",
            "stroke": "#1D1F24",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })]), _vm._v("\n                  Twitter "), _c('i', {
          staticClass: "button-arrow-icon icon-arrow"
        })]);
      },
      staticRenderFns: []
    }
  })], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "speed-btn",
    on: {
      "click": function click($event) {
        return _vm.mobileSpeedMenu();
      }
    }
  }, [_vm._v(_vm._s(_vm.player.playbackRate) + "x")]), _vm._v(" "), _c('button', {
    staticClass: "bookmark-btn",
    on: {
      "click": function click($event) {
        return _vm.handleSave();
      }
    }
  }, [!_vm.episodeSaved ? _c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M25.3332 28L15.9998 21.3333L6.6665 28V6.66667C6.6665 5.95942 6.94746 5.28115 7.44755 4.78105C7.94765 4.28095 8.62593 4 9.33317 4H22.6665C23.3737 4 24.052 4.28095 24.5521 4.78105C25.0522 5.28115 25.3332 5.95942 25.3332 6.66667V28Z",
      "stroke": "#FDD366",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]) : _c('svg', {
    attrs: {
      "width": "16",
      "height": "20",
      "viewBox": "0 0 16 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 19L8 14L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H13C13.5304 1 14.0391 1.21071 14.4142 1.58579C14.7893 1.96086 15 2.46957 15 3V19Z",
      "fill": "#FDD366",
      "stroke": "#FDD366",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "share-btn",
    on: {
      "click": function click($event) {
        return _vm.mobileShareMenu();
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-share-alt fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "data-prefix": "fa",
      "data-icon": "share-alt",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "data-fa-i2svg": ""
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
    }
  })])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "audioplayer",
      "preload": "none"
    }
  })]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle sm-button",
    attrs: {
      "id": "dropdownMenu2",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}];


/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(501);


/**
 * Configuration file for axios
 * @type {AxiosInstance}
 */
var instance = __WEBPACK_IMPORTED_MODULE_0_axios__["a" /* default */].create({
  baseURL: "https://api.afripods.com"
});
instance.defaults.headers.common['Authorization'] = 'AUTH TOKEN FROM INSTANCE';
/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Data = /*#__PURE__*/_createClass(function Data(dataType, adId, episodeId, startTimeMinutes, endTimeMinutes, event, state, podcastId, podcastFollowState, pageName, listName, buttonName) {
  _classCallCheck(this, Data);
  switch (dataType) {
    case 'streamedDuration':
      this.dataType = dataType;
      this.episodeId = episodeId;
      this.state = event;
      this.startTimeMinutes = startTimeMinutes;
      this.endTimeMinutes = endTimeMinutes;
      break;
    case 'stream':
      this.dataType = dataType;
      this.episodeId = episodeId;
      this.state = event;
      this.startTimeMinutes = startTimeMinutes;
      this.endTimeMinutes = endTimeMinutes;
      break;
    case 'favouriteUpdate':
      ;
      this.dataType = dataType, this.buttonName = 'epsiodeItem', this.buttonState = state, this.episodeDownloaded = false, this.episodeFavoriteMarked = state, this.episodeId = episodeId, this.followingPodcast = podcastFollowState, this.itemNumber = 0, this.listName = listName, this.pageName = pageName;
      break;
    case 'followUpdate':
      ;
      this.dataType = dataType, this.buttonName = 'podcastFollow', this.buttonState = state, this.followingPodcast = state, this.listName = listName, this.pageName = pageName, this.podcastId = podcastId;
      break;
    case 'button':
      ;
      this.dataType = dataType, this.buttonName = buttonName, this.buttonState = state, this.episodeId = episodeId;
      break;
    default:
      this.dataType = dataType;
      this.adId = adId;
      this.episodeId = episodeId;
      break;
  }
});

/***/ }),

/***/ 685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var User = /*#__PURE__*/_createClass(function User(device) {
  _classCallCheck(this, User);
  this.device = device;
});

/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Device; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Device = /*#__PURE__*/_createClass(function Device(deviceType, deviceId, appVersion, screenSize, viewportSize, userAgent, abTestNumber) {
  _classCallCheck(this, Device);
  this.deviceType = deviceType;
  this.deviceId = deviceId;
  this.appVersion = appVersion;
  this.screenSize = screenSize;
  this.viewportSize = viewportSize;
  this.userAgent = userAgent;
  this.abTestNumber = abTestNumber;
});

/***/ }),

/***/ 687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScreenSize; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var ScreenSize = /*#__PURE__*/_createClass(function ScreenSize(width, height) {
  _classCallCheck(this, ScreenSize);
  this.width = width;
  this.height = height;
});

/***/ }),

/***/ 688:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewportSize; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var ViewportSize = /*#__PURE__*/_createClass(function ViewportSize(width, height) {
  _classCallCheck(this, ViewportSize);
  this.width = width;
  this.height = height;
});

/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatisticsData; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var StatisticsData = /*#__PURE__*/_createClass(function StatisticsData(creationDate, schemeVersion, statisticsType, data, networkConnection, user, sessionId) {
  _classCallCheck(this, StatisticsData);
  this.creationDate = creationDate;
  this.schemeVersion = schemeVersion;
  this.statisticsType = statisticsType;
  this.data = data;
  this.networkConnection = networkConnection;
  this.user = user;
  this.sessionId = sessionId;
});

/***/ }),

/***/ 690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AFRIPODS_SESSION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEVICE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTEST_ID; });
var AFRIPODS_SESSION_ID = 'AFRIPODS_SESSION_ID';
var DEVICE_ID = 'AFRIPODS_DEVICE_ID';
var ABTEST_ID = 'AFRIPODS_ABTEST_ID';

/***/ }),

/***/ 691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AudioPlayer; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * This represents the data needed by the audio player for visual representation of data
 * provided by a PlayObject
 */
var AudioPlayer = /*#__PURE__*/_createClass(function AudioPlayer() {
  _classCallCheck(this, AudioPlayer);
  this.volume = 75;
  this.title = '';
  this.image = '';
  this.currentTimeInSeconds = 0;
  this.durationInSeconds = 0;
  this.playerEpisodeCurrentTime = '';
  this.playerEpisodeDuration = '';
  this.showAudioPlayer = false;
  this.playerSliderStyle = {
    backgroundColor: '#E9705E'
  };
  this.volumeSliderStyle = {
    backgroundColor: '#F6D67B'
  };
});

/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_PlayState__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_ObjectType__ = __webpack_require__(410);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * This represents an episode, its ads, and other data that is necessary for the
 * player to be able to function properly.
 */
var PlayObject = /*#__PURE__*/_createClass(function PlayObject(indexInList, episode, preRollAds, midRollAds) {
  _classCallCheck(this, PlayObject);
  this.episodeIndex = indexInList;
  this.episode = episode;
  this.currentMidroll = -99;
  this.preRollAds = preRollAds;
  this.midRollads = midRollAds;
  this.idOfLastPlayedAd = '-1';
  this.playState = __WEBPACK_IMPORTED_MODULE_0__constants_PlayState__["a" /* NOT_STARTED */];
  this.currentObjectType = __WEBPACK_IMPORTED_MODULE_1__constants_ObjectType__["c" /* NONE */];
});

/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_style_index_0_id_5fdcabd7_prod_lang_scss___ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_style_index_0_id_5fdcabd7_prod_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_style_index_0_id_5fdcabd7_prod_lang_scss___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 694:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_style_index_1_id_5fdcabd7_prod_lang_scss_scoped_true___ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_style_index_1_id_5fdcabd7_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AudioPlayer_vue_vue_type_style_index_1_id_5fdcabd7_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 697:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FooterSection_vue_vue_type_template_id_367a388e___ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterSection_vue_vue_type_script_lang_js___ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FooterSection_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__FooterSection_vue_vue_type_template_id_367a388e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FooterSection_vue_vue_type_template_id_367a388e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FooterSection_vue_vue_type_template_id_367a388e___ = __webpack_require__(700);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FooterSection_vue_vue_type_template_id_367a388e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FooterSection_vue_vue_type_template_id_367a388e___["b"]; });


/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-stripes"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "afripods-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "sitemap"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Connect With Us")]), _vm._v(" "), _c('div', {
    staticClass: "nav-items-wrapper"
  }, [_c('RouterLink', {
    staticClass: "sitemap__link",
    attrs: {
      "to": {
        path: '/about'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("About us")])]), _vm._v(" "), _c('RouterLink', {
    staticClass: "sitemap__link",
    attrs: {
      "to": {
        path: '/become_advertiser'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Advertising")])]), _vm._v(" "), _c('a', {
    staticClass: "sitemap__link",
    attrs: {
      "href": "mailto:contactus@afripods.com?subject=Contact Us"
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('RouterLink', {
    staticClass: "sitemap__link",
    attrs: {
      "to": {
        path: '/help'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Help")])])], 1)]), _vm._v(" "), !_vm.userLoggedIn ? _c('LoginButton', {
    staticClass: "hide-on-desktop btn-black login-button"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "social-icons"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "social-icon-link",
    attrs: {
      "href": "https://twitter.com/Afripods",
      "rel": "external"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Twitter")]), _vm._v(" "), _c('i', {
    staticClass: "icon-twitter"
  }, [_c('svg', {
    staticClass: "twitter-icon",
    attrs: {
      "width": "35",
      "height": "35",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "24",
      "cy": "24",
      "r": "24",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#clip0_14618_14390)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M27.0333 22.3857L35.9678 12H33.8506L26.0927 21.0177L19.8966 12H12.75L22.1198 25.6364L12.75 36.5274H14.8673L23.0598 27.0044L29.6034 36.5274H36.75L27.0333 22.3857ZM24.1333 25.7566L23.1839 24.3987L15.6302 13.5939H18.8823L24.9782 22.3137L25.9276 23.6716L33.8516 35.006H30.5995L24.1333 25.7566Z",
      "fill": "#222222"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_14618_14390"
    }
  }, [_c('rect', {
    attrs: {
      "width": "24",
      "height": "24.54",
      "fill": "white",
      "transform": "translate(12 12)"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "store-icons"
  }, [_c('a', {
    staticClass: "store-icon",
    attrs: {
      "href": "https://apps.apple.com/se/app/afripods/id1242318633?l=en"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Afripods on the Apple App Store")]), _vm._v(" "), _c('svg', {
    attrs: {
      "height": "35",
      "width": "117",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "store-icon-background",
    attrs: {
      "d": "M112.667 0H4.333A4.366 4.366 0 0 0 0 4.375v26.25A4.366 4.366 0 0 0 4.333 35h108.334A4.366 4.366 0 0 0 117 30.625V4.375A4.366 4.366 0 0 0 112.667 0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "store-icon-content",
    attrs: {
      "d": "M26.91 17.306c.02-1.466.79-2.82 2.042-3.589a4.39 4.39 0 0 0-3.46-1.864c-1.454-.153-2.866.869-3.606.869-.757 0-1.902-.853-3.128-.829a4.609 4.609 0 0 0-3.876 2.358c-1.676 2.894-.425 7.146 1.18 9.485.804 1.145 1.742 2.425 2.971 2.38 1.201-.05 1.651-.764 3.103-.764 1.437 0 1.858.763 3.112.735 1.29-.02 2.101-1.15 2.877-2.307a9.49 9.49 0 0 0 1.317-2.671 4.136 4.136 0 0 1-2.53-3.803M24.543 10.315a4.212 4.212 0 0 0 .967-3.017 4.302 4.302 0 0 0-2.78 1.434 4.003 4.003 0 0 0-.99 2.905 3.553 3.553 0 0 0 2.804-1.322M38.429 21.875h3.252l-1.602-4.707h-.045Zm3.677 1.339h-4.102l-.986 2.9h-1.736l3.885-10.729h1.806l3.885 10.732H43.09ZM51.595 22.205c0-1.583-.821-2.625-2.074-2.625-1.23 0-2.058 1.063-2.058 2.625 0 1.576.828 2.632 2.058 2.632 1.253 0 2.074-1.034 2.074-2.632m1.655 0c0 2.432-1.306 3.995-3.274 3.995a2.663 2.663 0 0 1-2.47-1.37h-.037v3.876H45.86V18.293h1.56v1.301h.03a2.785 2.785 0 0 1 2.498-1.385c1.993 0 3.305 1.569 3.305 3.994M60.23 22.205c0-1.583-.82-2.625-2.073-2.625-1.23 0-2.058 1.063-2.058 2.625 0 1.576.828 2.632 2.058 2.632 1.253 0 2.074-1.034 2.074-2.632m1.655 0c0 2.432-1.306 3.995-3.274 3.995a2.663 2.663 0 0 1-2.47-1.37h-.037v3.876h-1.609V18.293h1.56v1.301h.03a2.786 2.786 0 0 1 2.498-1.385c1.993 0 3.305 1.569 3.305 3.994M67.594 23.127c.119 1.065 1.156 1.763 2.573 1.763 1.358 0 2.334-.7 2.334-1.659 0-.832-.588-1.331-1.984-1.677l-1.395-.335c-1.974-.475-2.892-1.397-2.892-2.892 0-1.851 1.618-3.124 3.916-3.124 2.274 0 3.832 1.273 3.885 3.124h-1.627c-.097-1.071-.984-1.718-2.283-1.718s-2.184.656-2.184 1.604c0 .758.567 1.205 1.954 1.547l1.186.291c2.208.522 3.126 1.407 3.126 2.975 0 2.008-1.604 3.266-4.155 3.266-2.388 0-3.999-1.228-4.104-3.17ZM77.678 16.441v1.852h1.492v1.272h-1.492v4.312c0 .67.299.983.956.983a5.24 5.24 0 0 0 .53-.037v1.264a4.473 4.473 0 0 1-.895.073c-1.588 0-2.208-.595-2.208-2.114v-4.481h-1.142v-1.272h1.142V16.44ZM85.837 22.205c0-1.688-.777-2.685-2.081-2.685-1.304 0-2.081 1.005-2.081 2.685 0 1.696.776 2.684 2.08 2.684 1.306 0 2.082-.988 2.082-2.684m-5.803 0c0-2.462 1.454-4.01 3.722-4.01s3.722 1.546 3.722 4.01c0 2.464-1.44 4.01-3.722 4.01s-3.722-1.54-3.722-4.01M88.806 18.293h1.536v1.331h.037a1.87 1.87 0 0 1 1.887-1.413c.186 0 .37.02.552.059v1.503a2.251 2.251 0 0 0-.724-.098 1.626 1.626 0 0 0-1.256.514 1.616 1.616 0 0 0-.426 1.286v4.64h-1.608ZM94.8 21.483h3.922a1.878 1.878 0 0 0-.527-1.412 1.89 1.89 0 0 0-1.397-.573 1.99 1.99 0 0 0-1.414.578c-.375.373-.585.88-.584 1.407m5.445 2.334c-.22 1.42-1.604 2.394-3.38 2.394-2.282 0-3.698-1.524-3.698-3.97s1.424-4.046 3.63-4.046c2.173 0 3.538 1.486 3.538 3.859v.55h-5.542v.098c-.051.582.15 1.158.554 1.582.403.424.97.655 1.556.633a1.776 1.776 0 0 0 1.816-1.098ZM37.163 11.734h.975c.488.03.964-.162 1.295-.522.33-.36.482-.849.41-1.332a1.622 1.622 0 0 0-.416-1.323 1.632 1.632 0 0 0-1.29-.52h-.974Zm1.065-4.426c1.535 0 2.433.94 2.433 2.561 0 1.647-.893 2.595-2.433 2.595h-1.869V7.308ZM44.456 10.517c0-.844-.38-1.338-1.046-1.338s-1.046.494-1.046 1.338c0 .843.377 1.34 1.046 1.34s1.046-.494 1.046-1.34m-2.888 0a1.842 1.842 0 0 1 .865-1.742 1.853 1.853 0 0 1 1.95 0c.597.37.932 1.044.865 1.742 0 1.261-.698 2.022-1.839 2.022-1.14 0-1.841-.76-1.841-2.022M50.141 12.464h-.798l-.807-2.867h-.06l-.804 2.867h-.792l-1.076-3.892h.781l.7 2.97h.058l.802-2.97h.738l.803 2.97h.062l.695-2.97h.77l-1.072 3.892ZM52.118 8.573h.74v.614h.058a1.17 1.17 0 0 1 1.164-.691 1.27 1.27 0 0 1 1.024.4c.262.282.382.668.325 1.048v2.52h-.767v-2.329c0-.624-.272-.936-.842-.936a.896.896 0 0 0-.932.986v2.278h-.77ZM56.66 7.053h.77v5.41h-.77ZM61.388 10.517c0-.844-.38-1.338-1.046-1.338s-1.046.494-1.046 1.338c0 .843.377 1.34 1.046 1.34.67 0 1.046-.494 1.046-1.34m-2.888 0a1.842 1.842 0 0 1 .865-1.742 1.853 1.853 0 0 1 1.95 0c.597.37.932 1.044.865 1.742 0 1.261-.698 2.022-1.839 2.022-1.14 0-1.841-.76-1.841-2.022M65.5 11.032v-.326l-.95.06c-.539.037-.781.22-.781.562 0 .343.304.555.723.555a.922.922 0 0 0 1.01-.851m-2.508.332c0-.7.523-1.104 1.452-1.162l1.056-.06v-.335c0-.411-.272-.644-.797-.644-.43 0-.732.157-.815.433h-.747c.079-.669.709-1.098 1.594-1.098.979 0 1.53.486 1.53 1.309v2.657h-.74v-.546h-.061a1.317 1.317 0 0 1-1.17.611 1.182 1.182 0 0 1-1.301-1.166M68.075 10.517c0 .826.391 1.322 1.044 1.322s1.05-.505 1.05-1.32c0-.814-.406-1.32-1.05-1.32s-1.044.499-1.044 1.319m-.795 0c0-1.23.633-2.01 1.62-2.01.498-.022.964.244 1.197.683h.058V7.053h.77v5.411h-.739v-.614h-.06c-.25.435-.721.696-1.224.678-.993 0-1.62-.779-1.62-2.012M77 10.517c0-.844-.38-1.338-1.046-1.338s-1.046.494-1.046 1.338c0 .843.377 1.34 1.046 1.34.67 0 1.047-.494 1.047-1.34m-2.889 0a1.842 1.842 0 0 1 .866-1.742 1.853 1.853 0 0 1 1.95 0c.596.37.932 1.044.865 1.742 0 1.261-.699 2.022-1.84 2.022-1.14 0-1.84-.76-1.84-2.022M78.825 8.573h.74v.614h.059a1.17 1.17 0 0 1 1.164-.691 1.27 1.27 0 0 1 1.024.399c.262.281.383.666.326 1.046v2.52h-.77v-2.326c0-.624-.272-.936-.841-.936a.896.896 0 0 0-.932.986v2.278h-.77ZM86.492 7.604v.987h.846v.647h-.846v2c0 .408.168.583.55.583.099 0 .196-.006.293-.018v.64a2.44 2.44 0 0 1-.419.04c-.857 0-1.198-.3-1.198-1.051V9.237h-.62V8.59h.62v-.986ZM88.39 7.053h.763v2.144h.06c.21-.46.686-.738 1.19-.696.382-.021.754.13 1.014.41.26.28.38.661.33 1.04v2.512h-.771v-2.321c0-.622-.293-.938-.834-.938a.913.913 0 0 0-.983.988v2.272h-.77ZM93.527 10.159H95.5a.938.938 0 0 0-.96-1.008.999.999 0 0 0-1.01 1.008m2.706 1.255a1.585 1.585 0 0 1-1.686 1.128c-1.12 0-1.804-.765-1.804-2.01 0-1.243.7-2.033 1.8-2.033 1.086 0 1.741.74 1.741 1.962v.268h-2.761v.044a1.026 1.026 0 0 0 1.038 1.115.938.938 0 0 0 .93-.472Z"
    }
  })])]), _c('a', {
    staticClass: "store-icon store-icon-googleplay",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.afripods.mobileapp&pli=1"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Afripods on the Google Play Store")]), _vm._v(" "), _c('svg', {
    attrs: {
      "height": "35",
      "width": "117",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "store-icon-background",
    attrs: {
      "d": "M0 31a4 4 0 0 0 4 4h109a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "store-icon-content",
    attrs: {
      "d": "M50.426 18.518a3.61 3.61 0 0 0-3.589 3.626 3.61 3.61 0 0 0 3.609 3.606 3.61 3.61 0 0 0 3.598-3.616 3.575 3.575 0 0 0-1.046-2.577 3.55 3.55 0 0 0-2.572-1.039Zm0 5.812c-1.095 0-2.037-.904-2.037-2.192 0-1.289.948-2.195 2.037-2.195 1.088 0 2.035.891 2.035 2.195 0 1.303-.943 2.192-2.035 2.192ZM105.472 18.731l-1.813 4.611h-.055l-1.882-4.61h-1.705l2.822 6.445-1.608 3.585h1.65l4.35-10.03h-1.76ZM96.69 18.499c-1.137 0-2.332.506-2.823 1.629l1.405.588c.3-.588.86-.78 1.445-.78.818 0 1.65.493 1.664 1.368v.118a3.495 3.495 0 0 0-1.65-.41c-1.518 0-3.056.834-3.056 2.395 0 1.423 1.243 2.34 2.633 2.34 1.064 0 1.65-.479 2.018-1.04h.055v.822h1.528V21.44c0-1.888-1.405-2.942-3.218-2.942Zm-.189 5.829c-.518 0-1.242-.26-1.242-.904 0-.82.9-1.142 1.678-1.142a2.805 2.805 0 0 1 1.446.356 1.92 1.92 0 0 1-1.884 1.69ZM41.03 19.63v1.533h3.662c-.11.864-.396 1.494-.834 1.934-.533.535-1.366 1.124-2.828 1.124a4.08 4.08 0 0 1-3.984-4.084 4.08 4.08 0 0 1 3.984-4.085 3.894 3.894 0 0 1 2.76 1.096l1.079-1.083a5.323 5.323 0 0 0-3.839-1.549c-3.087 0-5.69 2.522-5.69 5.62 0 3.098 2.595 5.62 5.69 5.62 1.667 0 2.925-.549 3.907-1.576 1.01-1.015 1.328-2.44 1.328-3.591a4.997 4.997 0 0 0-.082-.952ZM86.87 14.9h-3.792v10.636h1.581v-4.03h2.21c1.754 0 3.478-1.273 3.478-3.302S88.625 14.9 86.871 14.9Zm.042 5.127h-2.25v-3.646h2.25a1.82 1.82 0 0 1 1.817 1.823 1.82 1.82 0 0 1-1.817 1.823ZM91.221 14.9h1.582v10.636h-1.582ZM58.323 18.518a3.61 3.61 0 0 0-3.589 3.626 3.61 3.61 0 0 0 3.609 3.606 3.61 3.61 0 0 0 3.598-3.616 3.575 3.575 0 0 0-1.046-2.577 3.55 3.55 0 0 0-2.572-1.039Zm0 5.812c-1.095 0-2.037-.904-2.037-2.192 0-1.289.948-2.195 2.037-2.195 1.088 0 2.035.891 2.035 2.195 0 1.303-.943 2.192-2.035 2.192ZM79.448 20.82c-.3-.808-1.216-2.302-3.086-2.302-1.87 0-3.402 1.467-3.402 3.616-.02.96.35 1.888 1.024 2.57a3.523 3.523 0 0 0 2.555 1.046 3.587 3.587 0 0 0 3.006-1.603l-1.22-.822c-.411.603-.971 1.001-1.777 1.001a1.833 1.833 0 0 1-1.749-1.096l4.814-1.998Zm-4.916 1.207a1.99 1.99 0 0 1 .501-1.452 1.975 1.975 0 0 1 1.384-.658c.63 0 1.163.316 1.34.761ZM70.61 14.9h1.586v10.636H70.61ZM68.016 19.329h-.055a2.501 2.501 0 0 0-1.897-.809c-1.803 0-3.457 1.59-3.457 3.633 0 2.042 1.654 3.604 3.457 3.604a2.462 2.462 0 0 0 1.897-.822h.055v.522c0 1.383-.738 2.123-1.927 2.123-.97 0-1.57-.698-1.817-1.288l-1.38.57A3.438 3.438 0 0 0 66.088 29c1.858 0 3.429-1.096 3.429-3.768v-6.495h-1.502Zm-1.817 5.003c-1.094 0-2.009-.917-2.009-2.18 0-1.26.915-2.207 2.009-2.207 1.094 0 1.925.933 1.925 2.208 0 1.275-.846 2.177-1.925 2.177ZM38.22 11.058c1.426 0 2.365-.828 2.365-2.577h-2.19v.571h1.418c-.044.83-.694 1.353-1.593 1.353-.5-.004-.976-.21-1.323-.571a1.874 1.874 0 0 1-.523-1.347 1.88 1.88 0 0 1 .528-1.339c.346-.358.82-.563 1.318-.57.443.003.871.168 1.202.465l.486-.465a2.46 2.46 0 0 0-1.688-.662 2.565 2.565 0 0 0-2.56 2.57 2.565 2.565 0 0 0 2.56 2.568ZM44.527 10.354h-2.353v-1.51h1.991V8.21h-1.991V6.613h2.281V5.98h-2.954v5.005h3.026v-.632ZM47.308 10.986V6.62h1.513v-.64h-3.708v.64h1.514v4.366h.68ZM51.378 5.98h.673v5.006h-.673ZM55.127 10.986V6.62h1.513v-.64h-3.705v.64h1.513v4.366h.679ZM61.391 11.058a2.56 2.56 0 0 0 2.394-1.56 2.576 2.576 0 0 0-.531-2.813 2.554 2.554 0 0 0-2.797-.571 2.57 2.57 0 0 0-1.586 2.38 2.541 2.541 0 0 0 .728 1.81 2.524 2.524 0 0 0 1.792.754Zm0-4.481c1.054 0 1.908.857 1.908 1.914a1.911 1.911 0 0 1-1.908 1.914 1.854 1.854 0 0 1-1.32-.563 1.867 1.867 0 0 1-.525-1.34c-.015-.502.172-.989.52-1.35a1.86 1.86 0 0 1 1.325-.574ZM65.636 7.216l2.272 3.77h.644V5.98h-.673v3.741l-2.251-3.741h-.666v5.005h.674v-3.77ZM20.398 16.579l3.287-3.298-12.102-6.893c-.557-.316-1.064-.36-1.447-.177ZM9.685 6.613a1.881 1.881 0 0 0-.254 1.014v18.802c-.012.33.061.658.212.951l10.325-10.362ZM28.104 15.8l-3.871-2.207-3.414 3.425 3.414 3.449 3.869-2.206c1.187-.681 1.187-1.787.002-2.46ZM20.396 17.445 10.062 27.812c.39.227.928.19 1.517-.137l12.106-6.902Z"
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-content-wrapper-desktop"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n          Copyright © " + _vm._s(_vm.year) + " Afripods AB. All rights reserved."), _c('br'), _vm._v("We improve our products and advertising by\n          using Microsoft Clarity to see how you use our website."), _c('br'), _vm._v("By using our site, you agree that we and\n          Microsoft can collect and use this data. Our\n          "), _c('a', {
    attrs: {
      "href": "https://afripods.africa/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("privacy statement")]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "href": "https://afripods.africa/cookie-policy",
      "target": "_blank"
    }
  }, [_vm._v("cookie policy")]), _vm._v(" have more details.\n        ")]), _vm._v(" "), !_vm.userLoggedIn ? _c('LoginButton', {
    staticClass: "hide-on-mobile btn-black"
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "loginModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [!_vm.userLoggedIn ? _c('LoginForm', {
    attrs: {
      "lt": _vm.loginType,
      "on-exit": _vm.closeLogin,
      "on-password-retrieval": _vm.closeLogin
    },
    on: {
      "ltchange": _vm.updatelt
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "changeEmailModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('ChangeEmailForm')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "changePasswordModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('ChangeForm')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "retrievePasswordModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('RetrievePasswordForm')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "promptModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "login-prompt"
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closePrompt.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('h2', [_vm._v("Join Afripods!")]), _vm._v(" "), _c('p', [_vm._v("You need to be logged in to use this feature.")]), _vm._v(" "), _c('button', {
    staticClass: "button-arrow btn-orange btn",
    attrs: {
      "data-target": "#loginModal",
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.closePrompt
    }
  }, [_vm._v("\n            I want to log in "), _c('i', {
    staticClass: "button-arrow-icon icon-arrow"
  })])])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "social-icon-link",
    attrs: {
      "href": "https://www.facebook.com/afripods",
      "rel": "external"
    }
  }, [_c('i', {
    staticClass: "icon-facebook"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Facebook")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "social-icon-link",
    attrs: {
      "href": "https://instagram.com/afripods",
      "rel": "external"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Instagram")]), _c('i', {
    staticClass: "icon-instagram"
  })]);
}];


/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangeEmail_vue_vue_type_template_id_307f5550___ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangeEmail_vue_vue_type_script_lang_js___ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChangeEmail_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChangeEmail_vue_vue_type_template_id_307f5550___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChangeEmail_vue_vue_type_template_id_307f5550___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEmail_vue_vue_type_template_id_307f5550___ = __webpack_require__(703);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEmail_vue_vue_type_template_id_307f5550___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangeEmail_vue_vue_type_template_id_307f5550___["b"]; });


/***/ }),

/***/ 703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('div', {
    staticClass: "close-button mobile-only"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "login-form-login-section",
    attrs: {
      "id": "email-change-form"
    }
  }, [_c('h1', {
    staticClass: "heading heading__sm"
  }, [_vm._v("Change Email")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "currentEmail"
    }
  }, [_vm._v("Enter current Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.change.email,
      expression: "change.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "currentEmail",
      "data-validation": "required",
      "autocomplete": "email"
    },
    domProps: {
      "value": _vm.change.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.change, "email", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "changeEmail"
    }
  }, [_vm._v("Enter new Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.email,
      expression: "formData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "changeEmail",
      "data-validation": "required",
      "autocomplete": "email"
    },
    domProps: {
      "value": _vm.formData.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "email", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v("Repeat new Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.change.confirmEmail,
      expression: "change.confirmEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "confirm_email",
      "name": "confirmEmail",
      "data-validation": "required confirmation",
      "data-validation-confirm": "changeEmail",
      "data-validation-error-msg": "Email adress does not match.",
      "autocomplete": "email"
    },
    domProps: {
      "value": _vm.change.confirmEmail
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.change, "confirmEmail", $event.target.value);
      }
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "login-form-image"
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "row button-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-yellow btn-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])]);
}];


/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangePassword_vue_vue_type_template_id_ed55fcee___ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangePassword_vue_vue_type_script_lang_js___ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChangePassword_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChangePassword_vue_vue_type_template_id_ed55fcee___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChangePassword_vue_vue_type_template_id_ed55fcee___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangePassword_vue_vue_type_template_id_ed55fcee___ = __webpack_require__(706);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangePassword_vue_vue_type_template_id_ed55fcee___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChangePassword_vue_vue_type_template_id_ed55fcee___["b"]; });


/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('div', {
    staticClass: "close-button mobile-only"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "login-form-login-section",
    attrs: {
      "id": "password-change-form"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Current Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.currentPassword,
      expression: "formData.currentPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "currentPassword",
      "data-validation": "required length",
      "data-validation-length": "8-100",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": _vm.formData.currentPassword
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "currentPassword", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Enter new password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.password,
      expression: "formData.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "data-validation": "required length",
      "data-validation-length": "8-100",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": _vm.formData.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "password", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v("Repeat new password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.change.confirmPassword,
      expression: "change.confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "confirm_password",
      "name": "pass",
      "data-validation": "required confirmation",
      "data-validation-confirm": "password",
      "data-validation-length": "8-100",
      "data-validation-error-msg": "Password does not match with repeat password",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": _vm.change.confirmPassword
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.change, "confirmPassword", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row button-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-yellow btn-submit",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.changePassword.apply(null, arguments);
      }
    }
  }, [_vm._v("\n            Submit\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "login-form-image"
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h1', {
    staticClass: "heading heading__sm"
  }, [_vm._v("Change "), _c('span', {
    staticClass: "yellow-line"
  }, [_vm._v("password")])]);
}];


/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginButton_vue_vue_type_template_id_6d751ce2___ = __webpack_require__(708);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginButton_vue_vue_type_template_id_6d751ce2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginButton_vue_vue_type_template_id_6d751ce2___["b"]; });


/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ButtonArrow', {
    staticClass: "login-button",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#loginModal"
    }
  }, [_vm._v(" Log in to your account ")]);
};
var staticRenderFns = [];


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonArrow_vue_vue_type_template_id_e137ccf6___ = __webpack_require__(710);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonArrow_vue_vue_type_template_id_e137ccf6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonArrow_vue_vue_type_template_id_e137ccf6___["b"]; });


/***/ }),

/***/ 710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', _vm._g({
    staticClass: "button-arrow btn btn-sm",
    class: [_vm.icon === '' ? '' : 'use-smallscreen-icon'],
    attrs: {
      "type": _vm.type
    }
  }, _vm.$listeners), [_c('span', [_vm._t("default")], 2), _vm._v(" "), _c('i', {
    staticClass: "smallscreen-icon",
    class: _vm.icon
  }), _vm._v(" "), _c('i', {
    staticClass: "button-arrow-icon icon-arrow"
  })]);
};
var staticRenderFns = [];


/***/ }),

/***/ 711:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginForm_vue_vue_type_template_id_b65d6e7c___ = __webpack_require__(712);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginForm_vue_vue_type_template_id_b65d6e7c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoginForm_vue_vue_type_template_id_b65d6e7c___["b"]; });


/***/ }),

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('form', {
    staticClass: "login-form-login-section",
    class: {
      active: _vm.panel === 'login'
    },
    attrs: {
      "id": "login-form"
    }
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onExit.apply(null, arguments);
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.loginUsername,
      expression: "loginUsername",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "username",
      "data-validation": "required",
      "type": "text"
    },
    domProps: {
      "value": _vm.loginUsername
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.loginUsername = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v(" Email ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.loginPassword,
      expression: "loginPassword",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "data-validation": "required",
      "type": "password"
    },
    domProps: {
      "value": _vm.loginPassword
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.loginPassword = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(" Password ")])]), _vm._v(" "), _c('ButtonArrow', {
    staticClass: "btn-yellow btn-login",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Login")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onExit.apply(null, arguments);
      }
    }
  }, [_c('ButtonArrow', {
    staticClass: "btn-white btn-register",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Create new account")])], 1), _vm._v(" "), _c('a', {
    staticClass: "link-orange",
    attrs: {
      "id": "#retrieve-password",
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.switchPanel.apply(null, arguments);
      }
    }
  }, [_vm._v(" Forgot password? ")])], 1), _vm._v(" "), _c('form', {
    staticClass: "login-form-forgotten-section",
    class: {
      active: _vm.panel === 'retrieve'
    },
    attrs: {
      "id": "retrieve-password-form"
    }
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onExit.apply(null, arguments);
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(" Enter your e-mail address to retrieve your password ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.retrieve.email,
      expression: "retrieve.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "data-validation": "email",
      "type": "text"
    },
    domProps: {
      "value": _vm.retrieve.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.retrieve, "email", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._v(" "), _c('ButtonArrow', {
    staticClass: "btn-yellow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Retrieve Password")]), _vm._v(" "), _c('a', {
    staticClass: "link-orange",
    attrs: {
      "id": "#back-to-login",
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.switchPanel.apply(null, arguments);
      }
    }
  }, [_vm._v(" Back to Login ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-form-image listener"
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onExit.apply(null, arguments);
      }
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h1', {
    staticClass: "heading heading__sm"
  }, [_c('span', {
    staticClass: "orange-line"
  }, [_vm._v("Log in")]), _vm._v(" to your account")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h2', {
    staticClass: "heading heading__sm"
  }, [_c('span', {
    staticClass: "orange-line"
  }, [_vm._v("Retrieve")]), _vm._v(" your password")]);
}];


/***/ }),

/***/ 713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RetrievePasswordForm_vue_vue_type_template_id_1e88aabc___ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RetrievePasswordForm_vue_vue_type_script_lang_js___ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RetrievePasswordForm_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__RetrievePasswordForm_vue_vue_type_template_id_1e88aabc___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RetrievePasswordForm_vue_vue_type_template_id_1e88aabc___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RetrievePasswordForm_vue_vue_type_template_id_1e88aabc___ = __webpack_require__(715);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RetrievePasswordForm_vue_vue_type_template_id_1e88aabc___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RetrievePasswordForm_vue_vue_type_template_id_1e88aabc___["b"]; });


/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('form', {
    staticClass: "login-form-forgotten-section active",
    attrs: {
      "id": "retrieve-password-form-modal"
    }
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onExit.apply(null, arguments);
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(" Enter your e-mail address to retrieve your password ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.retrieve.email,
      expression: "retrieve.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "retrieve-email",
      "data-validation": "email"
    },
    domProps: {
      "value": _vm.retrieve.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.retrieve, "email", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._v(" "), _c('ButtonArrow', {
    staticClass: "btn-yellow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Retrieve Password ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-form-image",
    class: _vm.login.type
  }, [_c('div', {
    staticClass: "close-button"
  }, [_c('a', {
    staticClass: "icon-close",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeModal();
      }
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h2', {
    staticClass: "heading heading__sm"
  }, [_c('span', {
    staticClass: "orange-line"
  }, [_vm._v("Retrieve")]), _vm._v(" your password")]);
}];


/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SkeletonBody_vue_vue_type_template_id_56ea5c71_scoped_true___ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SkeletonBody_vue_vue_type_style_index_0_id_56ea5c71_prod_lang_scss_scoped_true___ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);

var script = {}



/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__SkeletonBody_vue_vue_type_template_id_56ea5c71_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SkeletonBody_vue_vue_type_template_id_56ea5c71_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "56ea5c71",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SkeletonBody_vue_vue_type_template_id_56ea5c71_scoped_true___ = __webpack_require__(718);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SkeletonBody_vue_vue_type_template_id_56ea5c71_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SkeletonBody_vue_vue_type_template_id_56ea5c71_scoped_true___["b"]; });


/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "skeletonBody"
  }, [_vm._t("content")], 2);
};
var staticRenderFns = [];


/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SkeletonBody_vue_vue_type_style_index_0_id_56ea5c71_prod_lang_scss_scoped_true___ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SkeletonBody_vue_vue_type_style_index_0_id_56ea5c71_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SkeletonBody_vue_vue_type_style_index_0_id_56ea5c71_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 720:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAuthorizedPaymentsUser;
var PAYMENTS_USERS = new Set(['7d7c9786-9716-400e-82eb-3091e8c677bf',
// tobias@vesterlund.se
'30e60d69-bd23-4198-a9f6-07b3324d801a',
// mrkevbrown2@gmail.com
'59b36d05-27a9-4ed2-b960-aa8411a393ef',
// mj@afripods.com
'e0ab7860-f4ba-404f-b87b-f3ae49ebe289',
// lilly@selamandhello.com
'43b6d0ca-1fc6-48ba-80ad-618a8ed71a9e',
// yesgirlspodcast@gmail.com
'34417b5f-ee7f-4c6f-b453-9b229b87c1f7',
// machuangela@gmail.com
'ff93d6bb-1716-4faf-ba4e-3f5f115f36b0' // bookingkevinybrown@gmail.com
]);

function isAuthorizedPaymentsUser(userId) {
  return PAYMENTS_USERS.has(userId);
}

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_id_03b0f893_prod_lang_scss_scoped_true___ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_id_03b0f893_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_id_03b0f893_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 723:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 724:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_1_id_03b0f893_prod_lang_scss___ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_1_id_03b0f893_prod_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_1_id_03b0f893_prod_lang_scss___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 725:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RichTextEditor_vue_vue_type_template_id_d064f718_scoped_true___ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RichTextEditor_vue_vue_type_script_lang_js___ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RichTextEditor_vue_vue_type_style_index_0_id_d064f718_prod_lang_scss_scoped_true___ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(47);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RichTextEditor_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__RichTextEditor_vue_vue_type_template_id_d064f718_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RichTextEditor_vue_vue_type_template_id_d064f718_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "d064f718",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 727:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_template_id_d064f718_scoped_true___ = __webpack_require__(728);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_template_id_d064f718_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_babel_loader_8_3_0_babel_core_7_21_8_webpack_3_12_0_node_modules_babel_loader_lib_index_js_ref_1_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_templateLoader_js_ref_2_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_template_id_d064f718_scoped_true___["b"]; });


/***/ }),

/***/ 728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "rich-wrapper form-group"
  }, [_c('div', {
    ref: "editor"
  })]);
};
var staticRenderFns = [];


/***/ }),

/***/ 730:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_style_index_0_id_d064f718_prod_lang_scss_scoped_true___ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_style_index_0_id_d064f718_prod_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_pnpm_extract_text_webpack_plugin_3_0_2_webpack_3_12_0_node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_pnpm_vue_style_loader_4_1_3_node_modules_vue_style_loader_index_js_node_modules_pnpm_css_loader_0_28_11_node_modules_css_loader_index_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_sass_loader_7_3_1_webpack_3_12_0_node_modules_sass_loader_dist_cjs_js_sourceMap_node_modules_pnpm_vue_loader_15_10_1_css_loader_0_28_11_lodash_4_17_21_webpack_3_12_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RichTextEditor_vue_vue_type_style_index_0_id_d064f718_prod_lang_scss_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),

/***/ 732:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_meta_data_updator__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_page_loader__ = __webpack_require__(428);







/*  Routes Lazy Loading
    https://router.vuejs.org/en/advanced/lazy-loading.html
*/
var DebugInfo = function DebugInfo() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1050));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1051));
};
var LogOut = function LogOut() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1052));
};
var IframePlayer = function IframePlayer() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1053));
};
var IframeEmbedPlayer = function IframeEmbedPlayer() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1054));
};
var PodcasterRegister = function PodcasterRegister() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1055));
};
var ResetPassword = function ResetPassword() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1056));
};
var Podcast = function Podcast() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1057));
};
var Job = function Job() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1058));
};
var Episode = function Episode() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1059));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1060));
};
var Listen = function Listen() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1061));
};
var Categories = function Categories() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1062));
};
var PodcastMigrationDocument = function PodcastMigrationDocument() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1063));
};
var About = function About() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1064));
};
var BroadcastToPodcast = function BroadcastToPodcast() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1065));
};
var Advertisers = function Advertisers() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1066));
};
var BecomePodcaster = function BecomePodcaster() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1067));
};
var Creator = function Creator() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1068));
};
var SubmitPodcast = function SubmitPodcast() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1069));
};
var Career = function Career() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1070));
};
var News = function News() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1071));
};
var HelpPages = function HelpPages() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1072));
};
var Termsconditions = function Termsconditions() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1073));
};
var AdminAccount = function AdminAccount() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1074));
};
var AdminMyAccount = function AdminMyAccount() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1075));
};
var AdminCategoriesParent = function AdminCategoriesParent() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1076));
};
var AdminNotificationsParent = function AdminNotificationsParent() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1077));
};
var AdminPodcastsParent = function AdminPodcastsParent() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1078));
};
var AdminUsersParent = function AdminUsersParent() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1079));
};
var AdminStats = function AdminStats() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1080));
};
var AdminCareer = function AdminCareer() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1081));
};
var AdminCareerAdd = function AdminCareerAdd() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1047));
};
var ListenerAccount = function ListenerAccount() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1082));
};
var ListenerSaved = function ListenerSaved() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1083));
};
var ListenerShows = function ListenerShows() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1084));
};
var PodcasterAccount = function PodcasterAccount() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1085));
};
var PodcasterDashboard = function PodcasterDashboard() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1086));
};
var PodcasterPayments = function PodcasterPayments() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1087));
};
var PodcasterPodcastsParent = function PodcasterPodcastsParent() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1088));
};
var PodcasterMyAccount = function PodcasterMyAccount() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1089));
};
var PodcasterStats = function PodcasterStats() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1046));
};
var PodcasterMigrate = function PodcasterMigrate() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1048));
};
var PodcasterSubmit = function PodcasterSubmit() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1049));
};
var AdvertiserAccount = function AdvertiserAccount() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1090));
};
var AdvertiserDashboard = function AdvertiserDashboard() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1091));
};
var AdvertiserAdsParent = function AdvertiserAdsParent() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1092));
};
var AdvertiserMyAccount = function AdvertiserMyAccount() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1093));
};
var AdvertiserStats = function AdvertiserStats() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1094));
};
var PrivacyPolicy = function PrivacyPolicy() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1095));
};
var CookiePolicy = function CookiePolicy() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1096));
};
var Network = function Network() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1097));
};
var Station = function Station() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1098));
};
var GhostPage = function GhostPage() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1099));
};
var GhostPost = function GhostPost() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1100));
};
var GhostBlog = function GhostBlog() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1101));
};
var NetworksAndStationsLandingPage = function NetworksAndStationsLandingPage() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1102));
};
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: Object({"AFRIPODS_API_URL":"https://api.afripods.com","AFRIPODS_PAYMENT_API_URL":"https://payment-service-prod-dnh3ytvq4a-ew.a.run.app","AFRIPODS_APP_URL":"https://afripods.africa","AFRIPODS_MEDIA_URL":"https://media.afripods.com","NODE_ENV":"production","BUILD_ENV":"prod","GA4_ID":"G-CZDGWZ0K45","FEATURE_FILTER_PAYMENTS_USERS":"true","FEATURE_PAYMENTS_ONBOARDING":"true"}).PUBLIC_PATH,
  linkActiveClass: 'active',
  mode: 'history',
  routes: [{
    path: '/dev/debug-info',
    name: 'debug-info',
    component: DebugInfo
  }, {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  }, {
    path: '/cookie-policy',
    name: 'CookiePolicy',
    component: CookiePolicy
  }, {
    path: '',
    name: 'Home',
    component: Home
  }, {
    path: '/listen',
    name: 'Listen',
    component: Listen
  }, {
    path: '/listen/categories/:category/:language',
    name: 'Categories',
    component: Categories
  }, {
    path: '/podcasters',
    name: 'Podcasters',
    component: Login
  }, {
    path: '/advertisers',
    name: 'Advertisers',
    component: Login
  }, {
    path: '/register',
    name: 'PodcasterRegister',
    component: PodcasterRegister
  }, {
    path: '/reset_password',
    name: 'ResetPassword',
    component: ResetPassword
  }, {
    path: '/terms',
    name: 'TermsAndConditions',
    component: Termsconditions
  }, {
    path: '/about',
    name: 'About',
    component: About
  }, {
    path: '/b2p',
    name: 'BroadcastToPodcast',
    component: BroadcastToPodcast
  }, {
    path: '/creator',
    name: 'Creator',
    component: Creator
  }, {
    path: '/submit_podcast',
    name: 'SubmitPodcast',
    component: SubmitPodcast
  }, {
    path: '/become_advertiser',
    name: 'BecomeAdvertiser',
    component: Advertisers
  }, {
    path: '/news',
    name: 'News',
    component: News
  }, {
    path: '/help',
    name: 'HelpPages',
    component: HelpPages
  }, {
    path: '/careers',
    name: 'Career',
    component: Career
  }, {
    path: '/careers/:jobId',
    name: 'Job',
    component: Job,
    children: [{
      path: ':action',
      component: Job
    }]
  }, {
    path: '/podcast/:slug',
    name: 'Podcast',
    component: Podcast,
    children: [{
      path: ':action',
      component: Podcast
    }]
  }, {
    path: '/episode/:seoURL/:episodeId',
    name: 'Episode',
    component: Episode,
    children: [{
      path: ':action',
      component: Episode
    }]
  }, {
    path: '/embed/player/:episodeId',
    name: 'iframe-player',
    component: IframePlayer
  }, {
    path: '/embed/embedplayer/:episodeId',
    name: 'embedplayer',
    component: IframeEmbedPlayer
  }, {
    path: '/embed/embedarchiveplayer/:podcastId',
    name: 'embedarchiveplayer',
    component: IframeEmbedPlayer
  }, {
    path: '/admin',
    name: 'AdminAccount',
    component: AdminAccount,
    meta: {
      requiresAuth: true,
      authType: 'admin'
    },
    // authentication check
    children: [{
      path: 'my_account',
      name: 'AdminMyAccount',
      component: AdminMyAccount
    }, {
      path: 'stats',
      name: 'AdminStats',
      component: AdminStats
    }, {
      path: 'categories',
      name: 'AdminCategories',
      component: AdminCategoriesParent
    }, {
      path: 'notifications',
      name: 'AdminNotifications',
      component: AdminNotificationsParent
    }, {
      path: 'categories/:action/:recordId',
      name: 'AdminCategoriesAdd',
      component: AdminCategoriesParent
    }, {
      path: 'podcasts',
      name: 'AdminPodcastsParent',
      redirect: '/admin/podcasts/list',
      component: AdminPodcastsParent,
      children: [{
        path: ':section',
        name: 'AdminPodcastsList',
        component: AdminPodcastsParent,
        children: [{
          path: 'by_category/:categoryId',
          name: 'AdminPodcastsListByCategory',
          component: AdminPodcastsParent
        }, {
          path: 'by_author/:authorId',
          name: 'AdminPodcastsListByAuthor',
          component: AdminPodcastsParent
        }, {
          path: 'by_podcast/:podcastId',
          name: 'AdminEpisodesPodcastId',
          component: AdminPodcastsParent
        }, {
          path: ':action/:recordId',
          name: 'AdminPodcastsListAdd',
          component: AdminPodcastsParent
        }, {
          path: ':action/:recordId',
          name: 'AdminPodcastsListStats',
          component: AdminPodcastsParent
        }]
      }]
    }, {
      path: 'network/:action/:id?',
      name: 'AdminNetworkList',
      component: AdminPodcastsParent
    }, {
      path: 'station/:action/:id?',
      name: 'AdminStationList',
      component: AdminPodcastsParent
    }, {
      path: 'users',
      name: 'AdminUsersParent',
      component: AdminUsersParent,
      redirect: '/admin/users/list',
      children: [{
        path: ':section',
        name: 'AdminUsersList',
        component: AdminUsersParent,
        children: [{
          path: 'by_author/:authorId',
          name: 'AdminUsersListByAuthor',
          component: AdminPodcastsParent
        }, {
          path: ':action/:recordId',
          name: 'AdminUsersAdd',
          component: AdminUsersParent
        }]
      }]
    }, {
      path: 'career',
      name: 'AdminCareer',
      component: AdminCareer
    }, {
      path: '/career/:action/:recordId',
      name: 'AdminCareerAdd',
      component: AdminCareerAdd
    }]
  }, {
    path: '/listener',
    name: 'ListenerAccount',
    component: ListenerAccount,
    meta: {
      requiresAuth: true,
      authType: 'podcaster'
    },
    // authentication check
    children: [{
      path: 'shows',
      name: 'ListenerShows',
      component: ListenerShows
    }, {
      path: 'saved',
      name: 'ListenerSaved',
      component: ListenerSaved
    }]
  }, {
    path: '/become_podcaster',
    name: 'BecomePodcaster',
    component: BecomePodcaster,
    meta: {
      requiresAuth: true,
      authType: 'podcaster'
    } // authentication check
  }, {
    path: '/podcaster',
    name: 'PodcasterAccount',
    component: PodcasterAccount,
    meta: {
      requiresAuth: true,
      authType: 'podcaster'
    },
    // authentication check
    children: [{
      path: 'dashboard',
      name: 'PodcasterDashboard',
      component: PodcasterDashboard
    }, {
      path: 'payments',
      name: 'PodcasterPayments',
      component: PodcasterPayments
    }, {
      path: 'submit',
      name: 'PodcasterSubmitPodcast',
      component: PodcasterSubmit
    }, {
      path: 'migrate',
      name: 'PodcasterMigratePodcast',
      component: PodcasterMigrate
    }, {
      path: 'migrate/help',
      name: 'PodcastMigrationHelp',
      component: PodcastMigrationDocument
    }, {
      path: 'my_account',
      name: 'PodcasterMyAccount',
      component: PodcasterMyAccount
    }, {
      path: 'stats',
      name: 'PodcasterStats',
      component: PodcasterStats
    }, {
      path: 'podcasts',
      name: 'PodcasterPodcastsParent',
      redirect: '/podcaster/podcasts/list',
      component: PodcasterPodcastsParent,
      children: [{
        path: ':section',
        name: 'PodcasterPodcastList',
        component: PodcasterPodcastsParent,
        children: [{
          path: 'by_podcast/:podcastId',
          name: 'PodcasterEpisodesPodcastId',
          component: PodcasterPodcastsParent
        }, {
          path: ':change_status',
          name: 'PodcasterPodcastListStatus',
          component: PodcasterPodcastsParent
        }, {
          path: ':action/:recordId',
          name: 'PodcasterPodcastListAdd',
          component: PodcasterPodcastsParent
        }]
      }]
    }, {
      path: 'broadcasts/:section/:action?/:recordId?',
      name: 'PodcasterBroadcasts',
      component: PodcasterPodcastsParent
    }]
  }, {
    path: '/advertiser',
    name: 'AdvertiserAccount',
    component: AdvertiserAccount,
    meta: {
      requiresAuth: true,
      authType: 'advertiser'
    },
    // authentication check
    children: [{
      path: 'dashboard',
      name: 'AdvertiserDashboard',
      component: AdvertiserDashboard
    }, {
      path: 'my_account',
      name: 'AdvertiserMyAccount',
      component: AdvertiserMyAccount
    }, {
      path: 'stats',
      name: 'AdvertiserStats',
      component: AdvertiserStats
    }, {
      path: 'ads',
      name: 'AdvertiserAdsParent',
      redirect: '/advertiser/ads/list',
      component: AdvertiserAdsParent,
      children: [{
        path: ':section',
        name: 'AdvertiserAdsList',
        component: AdvertiserAdsParent
      }]
    }]
  }, {
    path: '/network/:slug',
    name: 'Network',
    component: Network
  }, {
    path: '/station/:slug',
    name: 'Station',
    component: Station
  }, {
    path: '/radio-networks',
    name: 'NetworksAndStationsLandingPage',
    component: NetworksAndStationsLandingPage
  }, {
    path: '/page/:slug',
    name: 'GhostPage',
    component: GhostPage
  }, {
    path: '/blog',
    name: 'GhostBlog',
    component: GhostBlog
  }, {
    path: '/logout',
    name: 'logout',
    component: LogOut
  }, {
    path: '/blog/:slug',
    name: 'GhostPost',
    component: GhostPost
  }, {
    path: '*',
    redirect: '/'
  }]
});
router.beforeResolve(function (to, from, next) {
  if (to.name) {
    Object(__WEBPACK_IMPORTED_MODULE_5_utils_page_loader__["a" /* startPageLoader */])();
  }
  next();
});
router.afterEach(function () {
  Object(__WEBPACK_IMPORTED_MODULE_5_utils_page_loader__["b" /* stopPageLoader */])();
});

/*  Global Router Function
    Checks if section require authentication and what type of user level
*/
router.beforeEach(function (to, from, next) {
  if ($('.navbar-collapse').hasClass('in')) {
    $('.navbar-toggle').trigger('click');
  }
  $('#afripods-content').animate({
    scrollTop: 0
  }, 0);

  // save last url in the eventBus
  __WEBPACK_IMPORTED_MODULE_3_utils__["c" /* event */].lastURL = from.fullPath;
  var authType = to.matched[0].meta.authType;
  var redirectToHome = false;
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) &&
  // if the token is not valid or auth type is not matching set redirect to true
  !__WEBPACK_IMPORTED_MODULE_2_auth__["a" /* default */].checkAuthentication(authType)) {
    redirectToHome = true;
  }
  if (redirectToHome) return next({
    name: 'Home'
  });

  // Update episode and podcast meta data
  Object(__WEBPACK_IMPORTED_MODULE_4_utils_meta_data_updator__["a" /* default */])(to).then(function () {
    return next();
  }).catch(function () {
    return next();
  });
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_conf__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_auth__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils__ = __webpack_require__(98);




var getEpisodeMetaData = function getEpisodeMetaData(route) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.http.get(__WEBPACK_IMPORTED_MODULE_1_src_conf__["a" /* default */].url.episodes + '/' + route.params.episodeId, {
      params: {},
      headers: __WEBPACK_IMPORTED_MODULE_2_src_auth__["a" /* default */].getAuthHeader()
    }).then(function (response) {
      var data = response.body.data;
      resolve({
        'og:title': data.title,
        'og:description': data.description,
        'og:image': Object(__WEBPACK_IMPORTED_MODULE_3_src_utils__["e" /* getEpisodeImageURL */])(data.image, data.podcast_images.main)
      });
    }).catch(function (e) {
      reject({});
    });
  });
};
var getPodcastMetaData = function getPodcastMetaData(route) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.http.get(__WEBPACK_IMPORTED_MODULE_1_src_conf__["a" /* default */].url.podcasts + '/' + route.params.slug, {
      params: {},
      headers: __WEBPACK_IMPORTED_MODULE_2_src_auth__["a" /* default */].getAuthHeader()
    }).then(function (response) {
      var data = response.body.data;
      resolve({
        'og:title': data.title,
        'og:description': data.description,
        'og:image': Object(__WEBPACK_IMPORTED_MODULE_3_src_utils__["e" /* getEpisodeImageURL */])(null, data.images.main)
      });
    }).catch(function (e) {
      reject({});
    });
  });
};
var updateMetaData = function updateMetaData(to) {
  return new Promise(function (resolve, reject) {
    var metaData = null;
    if (to.name === 'Episode') {
      metaData = getEpisodeMetaData(to);
    }
    if (to.name === 'Podcast') {
      metaData = getPodcastMetaData(to);
    }
    if (metaData) {
      metaData.then(function (response) {
        Object.keys(response).forEach(function (key) {
          document.querySelector("meta[property=\"".concat(key, "\"]")).setAttribute('content', response[key]);
        });
        resolve();
      }).catch(function () {
        reject();
      });
    }
    resolve();
  });
};
/* harmony default export */ __webpack_exports__["a"] = (updateMetaData);

/***/ }),

/***/ 737:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ErrorHandler = {
  install: function install(Vue) {
    Vue.prototype.getErrorMessage = function (_ref) {
      var _ref$body = _ref.body,
        _ref$body2 = _ref$body === void 0 ? {} : _ref$body,
        _ref$body2$descriptio = _ref$body2.description,
        description = _ref$body2$descriptio === void 0 ? '' : _ref$body2$descriptio,
        _ref$body2$error_mess = _ref$body2.error_message,
        errorMessage = _ref$body2$error_mess === void 0 ? '' : _ref$body2$error_mess,
        _ref$body2$message = _ref$body2.message,
        message = _ref$body2$message === void 0 ? '' : _ref$body2$message,
        status = _ref.status;
      if (errorMessage) return errorMessage;
      if (message) return message;
      if (description) return description;
      switch (status) {
        case 401:
          {
            return 'Unauthorized.';
          }
        case 403:
          {
            return 'Access denied.';
          }
        case 404:
          {
            return 'The desired resource cannot be found.';
          }
        case 500:
          {
            return 'Sorry, the service is temporarily unavailable.';
          }
        default:
          {
            if (status > 500) {
              return 'Sorry, something went wrong. Please try again later.';
            }
            if (status >= 400) {
              return 'Bad request.';
            }
            return 'Sorry, something went wrong. Please try again later.';
          }
      }
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorHandler);

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return scrollToHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return colorOverlayCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return locationListSorter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToListAndRemoveRegionsAndUpperCaseFirstLetter; });
/* unused harmony export getLanguageNameFromId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLanguageObjectFromId; });
/* unused harmony export getFlagImageUrlByLanguageName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isValidUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEpisodeImageURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return urlify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUTCtime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocalTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatToDefaultTimeFormat; });
/* unused harmony export getImageResolution */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return validateImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return uploadImageToS3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sortByISODateString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__xml_parser__ = __webpack_require__(502);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




var event = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  data: function data() {
    return {
      lastURL: ''
    };
  },
  methods: {
    redirectToLastURL: function redirectToLastURL(context) {
      context.$router.push({
        path: this.lastURL
      });
    }
  }
});
function colorOverlayCreator(color1) {
  function d2h() {
    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return d.toString(16);
  }
  function h2d(h) {
    return Number.parseInt(h, 16);
  }
  var weight = 50;
  var color2 = '#000000';
  var color = '#';
  for (var index = 1; index <= 5; index += 2) {
    var v1 = h2d(color1.substr(index, 2));
    var v2 = h2d(color2.substr(index, 2));
    var value = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100)));
    while (value.length < 2) {
      value = "0".concat(value);
    }
    color += value;
  }
  return color;
}
function locationListSorter(locationList) {
  locationList.sort(function (locationA, locationB) {
    // 2000 is international. Want it to be first in the list.
    if (locationA.locationId == 2000) {
      return -1;
    }
    if (locationB.locationId == 2000) {
      return 1;
    }

    // Sorting by the english name
    return locationA.locationName[0].value.localeCompare(locationB.locationName[0].value);
  });
}

// Loops through each location removes areas which are not countries besides international and capitalizes the first letter of each location name.
function addToListAndRemoveRegionsAndUpperCaseFirstLetter(list, inputList) {
  inputList.forEach(function (location) {
    if (location.locationId < 1000 || location.locationId > 1007) {
      location.locationName[0].value = location.locationName[0].value.charAt(0).toUpperCase() + location.locationName[0].value.slice(1);
      list.push(location);
    }
  });
}
function getLanguageNameFromId(id, languages) {
  var name = null;
  languages.forEach(function (language) {
    if (language.languageId === Number(id)) {
      name = language.languageName[0].value;
    }
  });
  return name;
}
function getLanguageObjectFromId(id, languages) {
  var returnValue = null;
  languages.forEach(function (language) {
    if (language.languageId === Number(id)) {
      returnValue = language;
    }
  });
  return returnValue;
}
function getFlagImageUrlByLanguageName() {
  return null;
}
function scrollToHash(hashbang) {
  window.location.hash = hashbang;
  window.location.href = hashbang;
}
function isValidUrl(string) {
  try {
    return Boolean(new URL(string));
  } catch (_unused) {
    return false;
  }
}
function getEpisodeImageURL(episodeImageURL, podcastImageURL) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'main';
  if (type !== 'main' && type !== 'thumb' && type !== 'cover') {
    type = 'main';
  }
  if (isValidUrl(episodeImageURL)) return episodeImageURL;
  if (!episodeImageURL || episodeImageURL === podcastImageURL) {
    return __WEBPACK_IMPORTED_MODULE_2__conf__["a" /* default */].image.podcast[type] + podcastImageURL;
  }
  return __WEBPACK_IMPORTED_MODULE_2__conf__["a" /* default */].image.episode[type] + episodeImageURL;
}
function urlify(text) {
  var caughtAnchors = [];
  var anchorTagMatcher = new RegExp('<a[^>]*>([^<]+)</a>', 'g');
  text = text.replace(anchorTagMatcher, function (anchors) {
    return anchors.replace(/rel=".*" /, function () {
      return 'rel="noopener noreferrer nofollow" ';
    });
  });
  var match = null;
  while (match = anchorTagMatcher.exec(text)) {
    caughtAnchors.push([match.index, anchorTagMatcher.lastIndex]);
  }
  var isBetweenCaughtAnchors = function isBetweenCaughtAnchors(index) {
    var isBetween = false;
    caughtAnchors.forEach(function (item) {
      if (index >= item[0] && index <= item[1]) {
        isBetween = true;
      }
    });
    return isBetween;
  };
  var urlRegex = /([([]?((http)s?:\/\/|www\.)\S+)/g;
  return text.replace(urlRegex, function (url) {
    if (isBetweenCaughtAnchors(text.indexOf(url))) return url;
    var urlList = url.replace(/[()[\]]/g, ' ').split(' ');
    for (var index = 0; index < urlList.length; index++) {
      if (urlList[index]) {
        var _url = urlList[index];
        if (!/https?:\/\/\S+/.test(_url)) {
          _url = "https://".concat(_url);
        }
        return "<a href=\"".concat(_url, "\" rel=\"noopener noreferrer nofollow\" target=\"_blank\">").concat(urlList[index], "</a>");
      }
    }
  });
}
function formatToDefaultTimeFormat(time) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time, 'hh:mm:ss').format('HH:mm');
}
function getUTCtime(unixTimeStamp) {
  return new Date(unixTimeStamp).toUTCString();
}
function getLocalTime(unixTimeStamp, includeTime) {
  return includeTime ? new Date(unixTimeStamp).toLocaleString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }) : new Date(unixTimeStamp).toLocaleString([], {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
}
function getImageResolution(file) {
  return new Promise(function (resolve, reject) {
    try {
      var img = new Image();
      img.addEventListener('load', function () {
        resolve({
          height: img.height,
          width: img.width
        });
        URL.revokeObjectURL(img.src);
      });
      img.src = URL.createObjectURL(file);
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * Validate an image file
 *
 * @param {object} file  - File object
 * @param {object} [options={}] - Validation options
 * @param {object} [options.minResolution={}] - Minimum resolution of the image
 * @param {number} [options.minResolution.width=0] - Minimum width of the image
 * @param {number} [options.minResolution.height=0] - Minimum height of the image
 * @param {[number, number]} [options.aspectRatio=[]] - Aspect ratio of the image
 * @returns {[boolean, string]} - An array with the first element being a boolean indicating if the image is valid, and if not, a second element containing the error message
 * @example
 * const [isValidImage, errorMessage] = await validateImage(file, {
 *   minResolution: {
 *     width: 1920,
 *     height: 1080
 *   },
 *   aspectRatio: [16, 9]
 * })
 */
function validateImage(_x) {
  return _validateImage.apply(this, arguments);
}
function _validateImage() {
  _validateImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
    var _ref,
      _ref$minResolution,
      _ref$minResolution2,
      _ref$minResolution2$h,
      minHeight,
      _ref$minResolution2$w,
      minWidth,
      _ref$aspectRatio,
      aspectRatio,
      ASPECT_RATIO_TOLERANCE,
      _yield$getImageResolu,
      height,
      width,
      _aspectRatio,
      dividend,
      divisor,
      imageAspectRatio,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$minResolution = _ref.minResolution, _ref$minResolution2 = _ref$minResolution === void 0 ? {} : _ref$minResolution, _ref$minResolution2$h = _ref$minResolution2.height, minHeight = _ref$minResolution2$h === void 0 ? 0 : _ref$minResolution2$h, _ref$minResolution2$w = _ref$minResolution2.width, minWidth = _ref$minResolution2$w === void 0 ? 0 : _ref$minResolution2$w, _ref$aspectRatio = _ref.aspectRatio, aspectRatio = _ref$aspectRatio === void 0 ? [] : _ref$aspectRatio;
          ASPECT_RATIO_TOLERANCE = 0.001;
          if (file) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", [false, 'An image is required.']);
        case 4:
          if (['image/png', 'image/jpeg'].includes(file.type)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", [false, 'Invalid file type. Needs to be a png or jpg.']);
        case 6:
          if (Number.isSafeInteger(minWidth)) {
            _context.next = 9;
            break;
          }
          __WEBPACK_IMPORTED_MODULE_1_vue___default.a.$log.error("width: ".concat(minWidth, " (").concat(_typeof(minWidth), ") is not a safe integer."));
          return _context.abrupt("return", [false]);
        case 9:
          if (Number.isSafeInteger(minHeight)) {
            _context.next = 12;
            break;
          }
          __WEBPACK_IMPORTED_MODULE_1_vue___default.a.$log.error("height: ".concat(minHeight, " (").concat(_typeof(minHeight), ") is not a safe integer."));
          return _context.abrupt("return", [false]);
        case 12:
          _context.next = 14;
          return getImageResolution(file);
        case 14:
          _yield$getImageResolu = _context.sent;
          height = _yield$getImageResolu.height;
          width = _yield$getImageResolu.width;
          if (!(width < minWidth || height < minHeight)) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return", [false, "Image resolution needs to be at least ".concat(minWidth, "x").concat(minHeight, "px.")]);
        case 19:
          _aspectRatio = _slicedToArray(aspectRatio, 2), dividend = _aspectRatio[0], divisor = _aspectRatio[1];
          if (!(dividend && !Number.isSafeInteger(dividend) || divisor && !Number.isSafeInteger(divisor))) {
            _context.next = 23;
            break;
          }
          __WEBPACK_IMPORTED_MODULE_1_vue___default.a.$log.error("aspectRatio: ".concat(dividend, " (").concat(_typeof(dividend), ") / ").concat(divisor, " (").concat(_typeof(divisor), ") is not a valid aspect ratio."));
          return _context.abrupt("return", [false]);
        case 23:
          imageAspectRatio = width / height;
          if (!(Math.abs(imageAspectRatio - dividend / divisor) > ASPECT_RATIO_TOLERANCE)) {
            _context.next = 26;
            break;
          }
          return _context.abrupt("return", [false, "Image aspect ratio needs to be ".concat(dividend, ":").concat(divisor, ".")]);
        case 26:
          return _context.abrupt("return", [true]);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _validateImage.apply(this, arguments);
}
function uploadImageToS3(_x2, _x3, _x4, _x5) {
  return _uploadImageToS.apply(this, arguments);
}
/**
 * Sort ISO8601 date strings lexicographically
 *
 * @param {object[]} array - Array of objects to sort
 * @param {string} key - Key to sort by
 * @param {('asc'|'desc')} [order='asc'] - Ascending or descending order
 * @returns {object[]} - Sorted clone of array
 * @example
 * const sortedArray = sortByISODateString(array, 'date_created', 'desc')
 */
function _uploadImageToS() {
  _uploadImageToS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, fileParentObject, fileType, loader) {
    var parentId,
      fileName,
      fileSize,
      contentType,
      fileExtension,
      _yield$Vue$http$get,
      body,
      formData,
      res,
      s3URL,
      s3Key,
      image,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          parentId = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : '';
          _context2.prev = 1;
          fileName = file.name, fileSize = file.size, contentType = file.type;
          fileExtension = fileName.split('.').pop();
          _context2.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(__WEBPACK_IMPORTED_MODULE_2__conf__["a" /* default */].upload.image, {
            params: {
              'file-type': contentType,
              'file-ending': fileExtension,
              'file-size': fileSize,
              'file-parent-object': fileParentObject,
              'file-image-type': fileType,
              'file-parent-id': parentId
            }
          });
        case 6:
          _yield$Vue$http$get = _context2.sent;
          body = _yield$Vue$http$get.body;
          formData = new FormData();
          body.params.file = file;
          loader(true);

          // convert object to formData
          Object.keys(body.params).forEach(function (key) {
            return formData.append(key, body.params[key]);
          });
          _context2.next = 14;
          return __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.post(body.endpoint_url, formData);
        case 14:
          res = _context2.sent;
          s3URL = Object(__WEBPACK_IMPORTED_MODULE_3__xml_parser__["a" /* parseXmlToJson */])(res.body).PostResponse.Location;
          s3Key = Object(__WEBPACK_IMPORTED_MODULE_3__xml_parser__["a" /* parseXmlToJson */])(res.body).PostResponse.Key;
          image = s3Key.split('/');
          loader(false);
          return _context2.abrupt("return", {
            ref: image[image.length - 1],
            url: s3URL,
            error: null
          });
        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2["catch"](1);
          return _context2.abrupt("return", {
            ref: null,
            url: null,
            error: _context2.t0
          });
        case 25:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 22]]);
  }));
  return _uploadImageToS.apply(this, arguments);
}
function sortByISODateString() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
  var arrayClone = structuredClone(array);
  return order === 'asc' ? arrayClone.sort(function (a, b) {
    return a[key].localeCompare(b[key]);
  }) : order === 'desc' ? arrayClone.sort(function (a, b) {
    return -a[key].localeCompare(b[key]);
  }) : arrayClone;
}


/***/ })

},[511]);


// WEBPACK FOOTER //
// static/js/main.32f4b2a252ffb077a572.js